import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chatbot.room');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-chatbot-room',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chatbot.room/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.legacy-roomy-controls .roomy-button,
.legacy-roomy-controls td > button {
  box-sizing: border-box;
  min-height: 22px;
  padding: 3px 9px !important;
  line-height: 1.35;
}
.legacy-roomy-controls .roomy-badge,
.legacy-roomy-controls td > span {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px !important;
  line-height: 1.35;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
@keyframes historySlideInRight {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes driveAddSlideInLeft {
  from {
    opacity: 0;
    transform: translateX(-18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.chatbot-room-shell {
  position: relative;
}

.room-mobile-pane-nav {
  display: none;
}

.history-sidebar-panel {
  order: 99;
  position: relative;
  z-index: 16;
  flex: 0 0 auto;
  min-width: 120px;
  max-width: min(420px, 100vw - 18px);
  animation: historySlideInRight 180ms ease-out;
  transition: width 160ms ease, flex-basis 160ms ease;
  will-change: opacity, transform;
}

.history-sidebar-panel.is-resizing {
  transition: none;
}

.history-resize-handle {
  position: absolute;
  z-index: 24;
  top: 0;
  left: 0;
  width: 14px;
  height: 100%;
  border: 0;
  background: transparent;
  cursor: col-resize;
  outline: none;
  pointer-events: auto;
  touch-action: none;
}

.history-resize-handle::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 1px;
  width: 2px;
  background: transparent;
  transition: background 140ms ease;
}

.history-resize-handle:hover::before,
.history-resize-handle:focus-visible::before,
.history-resize-handle.is-resizing::before {
  background: #6366f1;
}

.legacy-history-resize-handle:hover::before,
.legacy-history-resize-handle:focus-visible::before,
.legacy-history-resize-handle.is-resizing::before {
  background: #003366;
}

.drive-add-drawer {
  flex: 0 0 auto;
  min-width: 120px;
  max-width: min(640px, 100vw - 18px);
  animation: driveAddSlideInLeft 180ms ease-out;
  transition: width 160ms ease, flex-basis 160ms ease;
  will-change: opacity, transform;
}

.drive-add-drawer.is-resizing {
  transition: none;
}

.drive-add-resize-handle {
  position: absolute;
  z-index: 12;
  top: 0;
  right: -5px;
  width: 10px;
  height: 100%;
  border: 0;
  background: transparent;
  cursor: col-resize;
  outline: none;
  touch-action: none;
}

.drive-add-resize-handle::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 4px;
  width: 2px;
  background: transparent;
  transition: background 140ms ease;
}

.drive-add-resize-handle:hover::before,
.drive-add-resize-handle:focus-visible::before,
.drive-add-resize-handle.is-resizing::before {
  background: #6366f1;
}

.legacy-drive-add-resize-handle:hover::before,
.legacy-drive-add-resize-handle:focus-visible::before,
.legacy-drive-add-resize-handle.is-resizing::before {
  background: #003366;
}

.chat-panel {
  flex: 0 0 auto;
  max-width: calc(100% - 280px);
  overflow: hidden;
}

.chat-resize-handle {
  position: relative;
  z-index: 8;
  flex: 0 0 9px;
  width: 9px;
  height: 100%;
  margin-left: -1px;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;
  cursor: col-resize;
  outline: none;
  touch-action: none;
}

.chat-resize-handle::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 34px;
  border-radius: 9999px;
  background: #cbd5e1;
  transform: translate(-50%, -50%);
  transition: background-color 120ms ease, height 120ms ease;
}

.chat-resize-handle:hover::before,
.chat-resize-handle:focus-visible::before,
.chat-resize-handle.is-resizing::before {
  height: 46px;
  background: #6366f1;
}

.legacy-chat-resize-handle {
  flex-basis: 7px;
  width: 7px;
  margin-left: 0;
  border-left: 1px solid #cccccc;
  border-right: 1px solid #aaaaaa;
  background: #d8d8d8;
}

.legacy-chat-resize-handle::before {
  width: 2px;
  background: #888888;
}

.legacy-chat-resize-handle:hover::before,
.legacy-chat-resize-handle:focus-visible::before,
.legacy-chat-resize-handle.is-resizing::before {
  background: #003366;
}

.canvas-parent-connector {
  width: 1px;
  height: 12px;
  background: #e2e8f0;
}

.canvas-serial-connector {
  height: 32px;
  margin-bottom: -20px;
}

.canvas-after-children-connector {
  height: 34px;
  margin-top: 0;
  margin-bottom: -14px;
}

.canvas-task-card {
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.canvas-task-card-root {
  width: min(100%, 320px);
  min-width: min(220px, 100%);
}

.canvas-task-card-child {
  width: min(230px, 100vw - 48px);
  min-width: min(150px, 100%);
}

.canvas-task-title-row {
  min-width: 0;
  max-width: 100%;
  flex-wrap: wrap;
}

.canvas-task-title {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal !important;
  line-height: 1.25;
}

.canvas-task-detail {
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal !important;
}

.canvas-step-row {
  max-width: 100%;
  min-width: 0;
}

.canvas-step-pill {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}

.canvas-children-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  justify-content: center;
  position: relative;
  max-width: min(100%, 980px);
  margin-top: -1px;
}

.canvas-child-branch {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 8px;
  margin-bottom: 8px;
}

.canvas-child-connector {
  position: relative;
  width: 100%;
  height: 12px;
}

.canvas-child-connector::before,
.canvas-child-connector::after {
  content: "";
  position: absolute;
  top: 0;
  background: #e2e8f0;
}

.canvas-child-connector::before {
  display: none;
}

.canvas-child-connector::after {
  left: 50%;
  width: 1px;
  height: 12px;
  transform: translateX(-50%);
}

.canvas-child-first .canvas-child-connector::before {
  left: 50%;
}

.canvas-child-last .canvas-child-connector::before {
  right: 50%;
}

.canvas-child-single .canvas-child-connector::before {
  display: none;
}

.legacy-roomy-controls .canvas-parent-connector,
.legacy-roomy-controls .canvas-child-connector::before,
.legacy-roomy-controls .canvas-child-connector::after {
  background: #cccccc;
}

.chat-md-content {
  line-height: 1.6;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.chat-md-content strong {
  font-weight: bold;
}
.chat-md-content em {
  font-style: italic;
}
.chat-md-content code {
  background: #f0f0f0;
  padding: 0 3px;
  border: 1px solid #dddddd;
  font-family: monospace;
  font-size: 11px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.chat-md-content .chat-h1 {
  font-size: 14px;
  font-weight: bold;
  color: #003366;
  margin: 6px 0 4px;
}
.chat-md-content .chat-h2 {
  font-size: 13px;
  font-weight: bold;
  color: #003366;
  margin: 5px 0 3px;
}
.chat-md-content .chat-h3 {
  font-size: 12px;
  font-weight: bold;
  color: #336699;
  margin: 4px 0 3px;
}
.chat-md-content .chat-ul, .chat-md-content .chat-ol {
  margin: 4px 0;
  padding-left: 18px;
}
.chat-md-content .chat-ul-li {
  list-style-type: disc;
  padding: 1px 0;
}
.chat-md-content .chat-ol-li {
  list-style-type: decimal;
  padding: 1px 0;
}

.chat-message-text {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.chat-input-textarea {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  min-height: 42px;
  max-height: 96px;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  overflow-y: hidden;
}

.chat-input-textarea::placeholder {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.history-title,
.history-summary {
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.history-title {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.history-summary {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.35;
}

.file-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-width: 1px;
  border-style: solid;
  border-radius: 9999px;
  font-size: 10px;
  line-height: 16px;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 155px;
  overflow: hidden;
}

.chat-file-badges {
  min-width: 0;
  max-width: 100%;
  max-height: 72px;
  overflow-y: auto;
  align-content: flex-start;
}

.chat-file-badges .file-type-badge {
  min-width: min(145px, 100%);
}

.file-type-group-delete {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-width: 1px;
  border-style: dashed;
  border-radius: 9999px;
  font-size: 10px;
  line-height: 16px;
  min-width: min(112px, 100%);
  max-width: 100%;
  cursor: pointer;
  opacity: 0.86;
}

.file-type-group-delete:hover,
.file-type-group-delete:focus-visible {
  border-style: solid;
  color: #dc2626;
  outline: none;
  opacity: 1;
}

.file-type-group-delete:disabled {
  cursor: wait;
  opacity: 0.5;
}

.file-type-label {
  flex: 0 0 auto;
  font-weight: 700;
  white-space: nowrap;
}

.file-type-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-badge-delete {
  flex: 0 0 14px;
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background: rgba(15, 23, 42, 0.08);
  color: currentColor;
  font-size: 10px;
  line-height: 14px;
  cursor: pointer;
  opacity: 0.68;
}

.file-badge-delete:hover,
.file-badge-delete:focus-visible {
  background: rgba(220, 38, 38, 0.12);
  color: #dc2626;
  opacity: 1;
  outline: none;
}

.file-badge-delete:disabled {
  cursor: wait;
  opacity: 0.42;
}

.file-type-badge.is-deleting {
  opacity: 0.62;
}

.excel-sheet-tabs {
  display: flex;
  gap: 3px;
  padding: 8px 8px 0;
  overflow-x: auto;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.excel-sheet-tab {
  flex: 0 0 auto;
  max-width: 180px;
  min-height: 28px;
  padding: 5px 10px;
  border: 1px solid #dbe3ef;
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
  background: #eef2f7;
  color: #64748b;
  font-size: 10px;
  line-height: 16px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.excel-sheet-tab.active {
  background: #ffffff;
  color: #334155;
  font-weight: 700;
}

.omission-title-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.omission-major-title,
.omission-sub-title {
  min-width: 0;
  font-weight: 700;
  line-height: 1.45;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.omission-major-title {
  color: #334155;
}

.omission-sub-title--nested {
  padding-left: 24px;
}

.omission-title--present {
  color: #0f172a;
}

.omission-title--missing {
  color: #dc2626;
}

.omission-major-row {
  background: #f8fafc;
}

.omission-major-cell,
.omission-item-title {
  min-width: 0;
  font-weight: 700;
  line-height: 1.45;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.omission-major-cell {
  color: #334155;
  position: relative;
  padding-left: 22px !important;
}

.omission-major-cell::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 999px;
  background: #6366f1;
}

.omission-item-cell--nested {
  padding-left: 14px !important;
}

.omission-item-title--nested {
  margin-left: 18px;
  padding-left: 22px;
}

.excel-grid-wrap {
  max-height: min(56vh, 520px);
  overflow: auto;
  background: #ffffff;
}

.excel-markdown-wrap {
  max-height: min(56vh, 520px);
  overflow: auto;
  background: #ffffff;
}

.excel-markdown-preview {
  min-width: max-content;
  margin: 0;
  padding: 12px;
  color: #334155;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 11px;
  line-height: 1.55;
  white-space: pre;
  tab-size: 4;
}

.excel-grid {
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 11px;
  color: #334155;
}

@media (max-width: 767px) {
  .chatbot-room-shell {
    flex-direction: column;
    min-height: 0;
  }
  .room-mobile-pane-nav {
    flex: 0 0 auto;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    padding: 6px 8px;
    border-bottom: 1px solid #e2e8f0;
    background: #ffffff;
  }
  .room-mobile-pane-nav button {
    min-width: 0;
    min-height: 32px;
    padding: 7px 8px;
    border: 0;
    border-radius: 8px;
    background: #f1f5f9;
    color: #64748b;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.15;
    cursor: pointer;
  }
  .room-mobile-pane-nav button.is-active {
    color: #ffffff;
    background: #6366f1;
  }
  .chat-panel,
  .room-right-panel {
    display: none !important;
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 0 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;
  }
  .chat-panel.is-mobile-active,
  .room-right-panel.is-mobile-active {
    display: flex !important;
  }
  .chat-resize-handle {
    display: none !important;
  }
  .room-right-panel > .flex.border-b,
  .room-right-tab-header {
    flex: 0 0 auto;
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .room-right-panel > .flex.border-b::-webkit-scrollbar,
  .room-right-tab-header::-webkit-scrollbar {
    display: none;
  }
  .room-right-panel > .flex.border-b button,
  .room-right-tab-header button {
    flex: 0 0 auto;
    padding: 8px 10px !important;
    font-size: 11px !important;
    white-space: nowrap;
  }
  .retro-room-shell {
    overflow: hidden;
  }
  .retro-room-shell .room-mobile-pane-nav {
    border-bottom-color: #99bbdd;
    background: #e8e8e8;
  }
  .retro-room-shell .room-mobile-pane-nav button {
    border: 1px solid #99bbdd;
    border-radius: 0;
    background: #ffffff;
    color: #003366;
  }
  .retro-room-shell .room-mobile-pane-nav button.is-active {
    border-color: #001a33;
    background: #003366;
    color: #ffffff;
  }
  .retro-room-shell .chat-panel,
  .retro-room-shell .room-right-panel {
    min-width: 0 !important;
    height: auto !important;
  }
  .retro-room-shell .room-right-panel {
    background: #ffffff !important;
  }
  .retro-room-shell .chat-message-text {
    max-width: 100% !important;
    overflow-wrap: anywhere;
  }
  .retro-room-shell .room-right-tab-header {
    min-height: 34px;
    padding-left: 2px;
  }
  .history-sidebar-panel,
  .drive-add-drawer {
    position: absolute;
    z-index: 60;
    top: 45px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    height: auto !important;
    flex-basis: auto !important;
    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.18);
  }
  .history-resize-handle,
  .drive-add-resize-handle {
    display: none !important;
  }
  .chat-file-badges {
    max-height: 54px;
  }
  .file-type-badge {
    flex-basis: min(128px, 100%);
    padding-left: 6px;
    padding-right: 6px;
  }
  .chat-input-textarea {
    min-height: 38px;
    max-height: 78px;
  }
}
.excel-corner,
.excel-col-header,
.excel-row-header {
  position: sticky;
  z-index: 2;
  background: #f1f5f9;
  color: #64748b;
  font-weight: 600;
  text-align: center;
  border-right: 1px solid #dbe3ef;
  border-bottom: 1px solid #dbe3ef;
}

.excel-corner {
  top: 0;
  left: 0;
  z-index: 4;
  width: 42px;
  min-width: 42px;
}

.excel-col-header {
  top: 0;
  min-width: 132px;
  height: 26px;
}

.excel-row-header {
  left: 0;
  z-index: 3;
  width: 42px;
  min-width: 42px;
}

.excel-cell {
  min-width: 132px;
  max-width: 260px;
  height: 28px;
  padding: 5px 8px;
  vertical-align: middle;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  border-right: 1px solid #edf2f7;
  border-bottom: 1px solid #edf2f7;
  background: #ffffff;
}

.excel-cell-positive {
  color: #047857;
  font-weight: 700;
  background: #ecfdf5;
}

.excel-cell-negative {
  color: #dc2626;
  font-weight: 700;
  background: #fef2f2;
}

.document-viewer-stage {
  overflow: hidden;
  background: #f8fafc;
}

.document-image-viewer {
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 16px;
}

.document-scroll-viewer {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 16px;
  background: #f8fafc;
}

.document-scroll-page {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 980px);
  margin: 0 auto 18px;
}

.document-scroll-page-label {
  align-self: center;
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
}

.document-scroll-page-image {
  display: block;
  width: 100%;
  max-width: none;
  height: auto;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
}

.document-scroll-page-frame {
  display: block;
  width: min(100%, 980px);
  height: max(760px, 100vh - 150px);
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
}

.document-page-frame {
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: max-content;
  min-width: 100%;
  min-height: 100%;
  height: 100%;
}

.document-page-image {
  flex: 0 0 auto;
  display: block;
  width: auto;
  max-width: none;
  max-height: none;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
}

.compare-page-image {
  flex: 0 0 auto;
  display: block;
  width: auto;
  max-width: none;
  max-height: none;
  border: 1px solid #e2e8f0;
}

.compare-page-frame {
  flex: 1 1 auto;
  width: 100%;
  min-height: 100%;
  border: 0;
  background: #ffffff;
}

.viewer-page-input {
  appearance: textfield;
  -moz-appearance: textfield;
}

.viewer-page-input::-webkit-outer-spin-button,
.viewer-page-input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.document-viewer-highlight-layer {
  position: absolute;
  z-index: 5;
  display: none;
  pointer-events: none;
}

.viewer-highlight-hit {
  position: absolute;
  min-width: 20px;
  min-height: 18px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  pointer-events: auto;
}

.viewer-highlight-hit::before {
  content: "";
  position: absolute;
  inset: 0;
  border: 1px solid var(--highlight-color, #ef4444);
  background: transparent;
  opacity: 0;
  transition: opacity 120ms ease, background-color 120ms ease, outline-color 120ms ease;
}

.viewer-highlight-hit:hover::before,
.viewer-highlight-hit:focus-visible::before,
.viewer-highlight-hit.is-active::before {
  background: rgba(255, 255, 255, 0.32);
  opacity: 1;
}

.viewer-highlight-hit:focus-visible {
  outline: 2px solid var(--highlight-color, #ef4444);
  outline-offset: 2px;
}

.viewer-highlight-hit.is-image::before {
  border-width: 3px;
  border-style: solid;
  background: rgba(245, 158, 11, 0.2);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.82), 0 0 0 1px rgba(120, 53, 15, 0.2);
  opacity: 1;
}

.viewer-highlight-hit.is-image:hover::before,
.viewer-highlight-hit.is-image:focus-visible::before,
.viewer-highlight-hit.is-image.is-active::before {
  background: rgba(245, 158, 11, 0.3);
}

.viewer-highlight-popover {
  position: absolute;
  top: 28px;
  right: 28px;
  z-index: 12;
  width: min(380px, 100% - 56px);
  max-height: calc(100% - 56px);
  overflow: auto;
  padding: 12px 38px 12px 14px;
  border: 1px solid #dbe3ef;
  border-left: 3px solid #6366f1;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);
}

.viewer-highlight-popover-title {
  margin-bottom: 7px;
  color: #1e293b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.viewer-highlight-popover-message {
  color: #475569;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-line;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.viewer-highlight-popover-close {
  position: absolute;
  top: 7px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.viewer-highlight-popover-close:hover {
  background: #f1f5f9;
  color: #334155;
}

.legacy-viewer-highlight-popover {
  border-color: #b8c0cc;
  border-left-color: #336699;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.22);
}

.document-viewer-error {
  margin: auto;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.legacy-document-viewer-stage {
  background: #d8d8d8;
}

.legacy-document-image-viewer {
  padding: 14px;
}

.legacy-document-scroll-viewer {
  padding: 14px;
  background: #d8d8d8;
}

.legacy-document-scroll-page {
  margin-bottom: 14px;
}

.legacy-document-scroll-page-label {
  color: #666666;
  font-family: "돋움", Dotum, sans-serif;
}

.legacy-document-scroll-page-frame {
  border-color: #aaaaaa;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.22);
}

.legacy-document-page-image {
  border-color: #aaaaaa;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.22);
}`],
})
export class PageChatbotRoomComponent implements OnInit, OnDestroy {
    @ViewChild('chatContainer') chatContainer: ElementRef;
    @ViewChild('roomShell') roomShell: ElementRef | undefined;
    @ViewChild('historyPanel') historyPanel: ElementRef | undefined;
    @ViewChild('driveAddPanel') driveAddPanel: ElementRef | undefined;
    @ViewChild('chatPanel') chatPanel: ElementRef | undefined;
    @ViewChild('chatInput') chatInput: ElementRef | undefined;
    @ViewChild('fileInput') fileInput: ElementRef;
    @ViewChild('viewerPageFrame') viewerPageFrame: ElementRef;
    @ViewChild('viewerPageImage') viewerPageImage: ElementRef;
    @ViewChild('viewerHighlightLayer') viewerHighlightLayer: ElementRef;
    @ViewChild('viewerScrollContainer') viewerScrollContainer: ElementRef | undefined;

    public sessionId: string = '';
    public sessionData: any = null;
    public messages: any[] = [];
    public inputMessage: string = '';
    public questionQuota: any = null;
    public sending: boolean = false;
    public loading: boolean = true;

    // Right panel
    public mobileRoomPane: string = 'chat';
    public rightTab: string = 'result'; // 'canvas' | 'result' | 'pdf'
    public results: any[] = [];
    public pdfUrl: string = '';
    public pdfImageUrl: string = '';
    public pdfPage: number = 1;
    public pdfFileName: string = '';
    public viewerMode: string = ''; // 'pdf' | 'hwp' | 'hwp_svg'
    public viewerTotalPages: number = 0;
    public viewerErrorMessage: string = '';
    public pdfZoomPercent: number = 100;
    public viewerScrollMode: boolean = false;
    public viewerHighlights: any[] = [];
    public activeViewerHighlight: any = null;
    private viewerHighlightRequestKey: string = '';
    public compareMode: boolean = false;
    public compareLeft: any = null;
    public compareRight: any = null;

    // Agent status
    public agentStatus: string = 'idle';
    public agentTasks: any[] = [];
    public lastIntent: string = '';
    public statusMessage: string = '';
    public runtimeState: any = null;

    // Document files list (for viewer dropdown)
    public pdfFiles: any[] = [];
    public selectedPdfFileIndex: string = '';

    // Results Classification
    public copyFindings: any[] = [];
    public typoFindings: any[] = [];
    public omissionFindings: any[] = [];
    private _omissionDisplaySequence: number = 0;
    public omissionSummary: any = null;
    public omissionResultView: string = 'checklist';
    public omissionWorkbook: any = null;
    public selectedOmissionSheet: string = '';
    public omissionWorkbookLoading: boolean = false;
    public omissionWorkbookError: string = '';
    public inspectionWorkbook: any = null;
    public selectedInspectionSheet: string = '';
    public inspectionWorkbookLoading: boolean = false;
    public inspectionWorkbookError: string = '';
    private readonly emptyWorkbookTable: any = { columns: [], rows: [] };
    public contextFindings: any[] = [];
    public contextSummary: any = null;
    public consistencyFindings: any[] = [];
    public consistencySummary: any = null;
    public instructionFindings: any[] = [];
    public instructionSummary: any = null;
    public stateEvaluationFindings: any[] = [];
    public stateEvaluationSummary: any = null;
    public copyImageStats: any = null;
    public infoResults: any[] = [];
    public selectedCopy: any = null;
    public selectedTypo: any = null;

    // Result sub-tab
    public resultSubTab: string = 'all';
    public readonly allResultPreviewLimit: number = 40;

    // File add type selection
    public pendingFileType: string = '';
    public deletingFileIndexes: { [key: string]: boolean } = {};

    // Drive file picker
    public driveBrowsing: boolean = false;
    public driveBrowserLoading: boolean = false;
    public driveBrowserFolders: any[] = [];
    public driveBrowserFiles: any[] = [];
    public driveBrowserCurrentFolder: string = '';
    public driveBrowserBreadcrumb: any[] = [];
    public driveBrowserFileType: string = 'reference';
    public selectedDriveFileIds: { [key: string]: boolean } = {};
    public addingDriveFiles: boolean = false;
    public driveAddMode: string = 'drive';
    public driveSearchText: string = '';
    public driveSelectionMode: boolean = false;
    public addingDriveFileIds: { [key: string]: boolean } = {};
    public driveAddPanelWidth: number = 420;
    public readonly driveAddPanelMinWidth: number = 120;
    public readonly driveAddPanelDefaultWidth: number = 420;
    public readonly driveAddPanelMaxWidth: number = 640;
    public resizingDriveAddPanel: boolean = false;
    public readonly driveFileTypeOptions: any[] = [
        { type: 'report', label: '보고서' },
        { type: 'reference', label: '전차보고서' },
        { type: 'proposal', label: '제안서' },
        { type: 'presentation', label: '발표자료' },
        { type: '부록', label: '부록' },
        { type: 'additional', label: '기타' },
        { type: 'rfp', label: '제안요청서' },
        { type: 'evaluation_guideline', label: '평가 가이드' },
        { type: 'contract', label: '계약서' },
        { type: 'kickoff', label: '착수계' },
        { type: 'ledger', label: '관리대장' },
    ];

    // Full inspection flow
    public showInspectionFlowModal: boolean = false;
    public inspectionFlowOptions: any[] = [
        {
            id: 'omission_check',
            label: '누락사항 검사',
            summary: '템플릿 기준 필수 항목 유/무',
            enabled: true,
        },
        {
            id: 'copy_check',
            label: '카피 검사',
            summary: '전차보고서 대비 텍스트/이미지 재사용',
            enabled: true,
        },
        {
            id: 'typo_check',
            label: '오탈자 검사',
            summary: '보고서 본문의 오탈자와 맞춤법',
            enabled: true,
        },
        {
            id: 'context_check',
            label: '문맥 검사',
            summary: '명칭, 기간, 용어의 문맥 정합성',
            enabled: true,
        },
        {
            id: 'instruction_check',
            label: '지침 검사',
            summary: '지침/기준자료 수행 근거 유/무',
            enabled: true,
        },
        {
            id: 'state_evaluation_check',
            label: '상태평가 적정성 검사',
            summary: '기본/선택과업, 조사ㆍ시험 수량, 상태평가 기준 부합성',
            enabled: true,
        },
        {
            id: 'consistency_check',
            label: '일치성 검사',
            summary: '본문, 표, 도면, 보조문서 값 대조',
            enabled: true,
        },
    ];

    // Session History
    public sessions: any[] = [];
    public showHistory: boolean = false;
    public loadingHistory: boolean = false;
    public loadingMoreSessions: boolean = false;
    public hasMoreSessions: boolean = false;
    public sessionPage: number = 1;
    public readonly sessionLimit: number = 30;
    public selectedSessionIds: { [key: string]: boolean } = {};
    public historySelectionMode: boolean = false;
    public historyPanelWidth: number = 250;
    public readonly historyPanelMinWidth: number = 120;
    public readonly historyPanelDefaultWidth: number = 250;
    public readonly historyPanelMaxWidth: number = 420;
    public resizingHistoryPanel: boolean = false;

    // Typo filter: hide spacing errors
    public hideSpacing: boolean = false;

    // Theme
    public theme: string = 'modern';
    public colorMode: string = 'light';

    // Chat panel resize
    public chatPanelWidth: number = 320;
    public readonly chatPanelMinWidth: number = 120;
    public readonly chatPanelDefaultWidth: number = 320;
    public resizingChatPanel: boolean = false;

    private progressPollTimer: any = null;
    private progressPollBusy: boolean = false;
    private rightTabUserSelected: boolean = false;
    private readonly roomViewStatePrefix: string = 'inspection.room.view.';
    private readonly colorModeStorageKey: string = 'ui-color-mode';
    private readonly chatPanelWidthStorageKey: string = 'inspection.room.chatPanelWidth.v2';
    private readonly historyPanelWidthStorageKey: string = 'inspection.room.historyPanelWidth.v1';
    private readonly driveAddPanelWidthStoragePrefix: string = 'inspection.room.driveAddPanelWidth.';
    private readonly builtinStateEvaluationGuidelineId: string = 'guideline:facility_safety_guideline';
    private readonly builtinStateEvaluationGuidelineIndex: number = -9001;
    private readonly builtinStateEvaluationGuidelineName: string = '시설물 안전 및 유지관리 실시 등에 관한 지침.pdf';
    private readonly chatPanelMaxWidth: number = 680;
    private readonly chatPanelRightMinWidth: number = 420;
    private historyPanelResizeStartX: number = 0;
    private historyPanelResizeStartWidth: number = 0;
    private historyPanelResizePointerTarget: any = null;
    private driveAddPanelResizeStartX: number = 0;
    private driveAddPanelResizeStartWidth: number = 0;
    private driveAddPanelResizePointerTarget: any = null;
    private chatPanelResizeStartX: number = 0;
    private chatPanelResizeStartWidth: number = 0;
    private chatPanelResizePointerTarget: any = null;
    private chatInputHeightSyncTimer: any = null;
    private viewerScrollSyncTimer: any = null;
    private viewerScrollSaveTimer: any = null;
    private readonly historyPanelResizeMoveHandler = (event: PointerEvent) => this.onHistoryPanelResizeMove(event);
    private readonly historyPanelResizeEndHandler = (event: PointerEvent) => this.stopHistoryPanelResize(event);
    private readonly driveAddPanelResizeMoveHandler = (event: PointerEvent) => this.onDriveAddPanelResizeMove(event);
    private readonly driveAddPanelResizeEndHandler = (event: PointerEvent) => this.stopDriveAddPanelResize(event);
    private readonly chatPanelResizeMoveHandler = (event: PointerEvent) => this.onChatPanelResizeMove(event);
    private readonly chatPanelResizeEndHandler = (event: PointerEvent) => this.stopChatPanelResize(event);
    private viewerResizeHandler = () => {
        this.clampHistoryPanelWidthToLayout();
        this.clampDriveAddPanelWidthToLayout();
        this.clampChatPanelWidthToLayout();
        this.syncViewerHighlightLayer();
    };
    private readonly viewerKeyboardHandler = (event: KeyboardEvent) => this.onViewerKeyboardShortcut(event);

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('ui-theme') || 'modern';
        this.applyColorMode(this.storedColorMode(), false);
        if (!this.service.auth.allow(this.loginRedirect())) return;
        this.restoreHistoryPanelWidth();
        this.restoreChatPanelWidth();
        window.addEventListener('resize', this.viewerResizeHandler);
        window.addEventListener('keydown', this.viewerKeyboardHandler);
        this.sessionId = WizRoute.segment.id;
        this.restoreDriveAddPanelWidth();

        if (!this.sessionId) {
            this.service.href('/chatbot');
            return;
        }

        await this.loadSession();
        await this.service.render();
        this.scheduleChatInputHeightSync();
    }

    private loginRedirect() {
        const path = `${location.pathname}${location.search}${location.hash}`;
        return `/access?returnTo=${encodeURIComponent(path || '/chatbot')}`;
    }

    private normalizeColorMode(value: any): string {
        return String(value || '').trim().toLowerCase() === 'dark' ? 'dark' : 'light';
    }

    private storedColorMode(): string {
        try {
            return this.normalizeColorMode(localStorage.getItem(this.colorModeStorageKey));
        } catch (e) {
            return 'light';
        }
    }

    private applyColorMode(value: any, persist: boolean = true) {
        const mode = this.normalizeColorMode(value);
        const isDark = mode === 'dark';
        this.colorMode = mode;
        try {
            if (persist) localStorage.setItem(this.colorModeStorageKey, mode);
        } catch (e) { }
        try {
            document.documentElement.classList.toggle('ui-dark', isDark);
            document.documentElement.classList.toggle('ui-light', !isDark);
            document.documentElement.style.colorScheme = mode;
            if (document.body) {
                document.body.classList.toggle('ui-dark', isDark);
                document.body.classList.toggle('ui-light', !isDark);
                document.body.style.colorScheme = mode;
            }
        } catch (e) { }
    }

    public async toggleColorMode(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.applyColorMode(this.colorMode === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    ngOnDestroy() {
        window.removeEventListener('resize', this.viewerResizeHandler);
        window.removeEventListener('keydown', this.viewerKeyboardHandler);
        this.stopHistoryPanelResize();
        this.stopChatPanelResize();
        this.stopDriveAddPanelResize();
        if (this.chatInputHeightSyncTimer) {
            window.clearTimeout(this.chatInputHeightSyncTimer);
            this.chatInputHeightSyncTimer = null;
        }
        if (this.viewerScrollSyncTimer) {
            window.clearTimeout(this.viewerScrollSyncTimer);
            this.viewerScrollSyncTimer = null;
        }
        if (this.viewerScrollSaveTimer) {
            window.clearTimeout(this.viewerScrollSaveTimer);
            this.viewerScrollSaveTimer = null;
        }
        this.stopProgressPolling();
    }

    public startHistoryPanelResize(event: PointerEvent) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.resizingHistoryPanel = true;
        this.historyPanelResizeStartX = event.clientX || 0;
        this.historyPanelResizeStartWidth = this.getCurrentHistoryPanelWidth();
        this.historyPanelResizePointerTarget = event.currentTarget as any;
        try {
            if (this.historyPanelResizePointerTarget?.setPointerCapture && event.pointerId !== undefined) {
                this.historyPanelResizePointerTarget.setPointerCapture(event.pointerId);
            }
        } catch (e) { }
        document.addEventListener('pointermove', this.historyPanelResizeMoveHandler);
        document.addEventListener('pointerup', this.historyPanelResizeEndHandler);
        document.addEventListener('pointercancel', this.historyPanelResizeEndHandler);
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }

    public async resetHistoryPanelWidth() {
        this.applyHistoryPanelWidth(this.clampHistoryPanelWidth(this.historyPanelDefaultWidth));
        this.clampChatPanelWidthToLayout();
        this.saveHistoryPanelWidth();
        await this.service.render();
    }

    public async onHistoryPanelResizeHandleKeydown(event: KeyboardEvent) {
        let nextWidth = this.historyPanelWidth;
        if (event.key === 'ArrowLeft') nextWidth -= event.shiftKey ? 40 : 20;
        else if (event.key === 'ArrowRight') nextWidth += event.shiftKey ? 40 : 20;
        else if (event.key === 'Home') nextWidth = this.historyPanelMinWidth;
        else if (event.key === 'End') nextWidth = this.getHistoryPanelMaxWidth();
        else return;
        event.preventDefault();
        this.applyHistoryPanelWidth(this.clampHistoryPanelWidth(nextWidth));
        this.clampChatPanelWidthToLayout();
        this.saveHistoryPanelWidth();
        await this.service.render();
    }

    public getHistoryPanelMaxWidth(): number {
        const shellWidth = this.roomShell?.nativeElement?.getBoundingClientRect?.().width
            || window.innerWidth
            || 1200;
        const driveAddWidth = this.driveBrowsing ? this.driveAddPanelWidth : 0;
        const handleWidth = 10;
        const minRightWidth = shellWidth < 820 ? 280 : this.chatPanelRightMinWidth;
        const layoutMax = shellWidth - driveAddWidth - this.chatPanelMinWidth - handleWidth - minRightWidth;
        return Math.max(this.historyPanelMinWidth, Math.min(this.historyPanelMaxWidth, layoutMax));
    }

    private onHistoryPanelResizeMove(event: PointerEvent) {
        if (!this.resizingHistoryPanel) return;
        event.preventDefault();
        const delta = (event.clientX || 0) - this.historyPanelResizeStartX;
        this.applyHistoryPanelWidth(this.clampHistoryPanelWidth(this.historyPanelResizeStartWidth - delta));
        this.clampChatPanelWidthToLayout();
        this.syncViewerHighlightLayer();
    }

    private async stopHistoryPanelResize(event?: PointerEvent) {
        if (!this.resizingHistoryPanel) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.resizingHistoryPanel = false;
        try {
            if (this.historyPanelResizePointerTarget?.releasePointerCapture && event?.pointerId !== undefined) {
                this.historyPanelResizePointerTarget.releasePointerCapture(event.pointerId);
            }
        } catch (e) { }
        this.historyPanelResizePointerTarget = null;
        document.removeEventListener('pointermove', this.historyPanelResizeMoveHandler);
        document.removeEventListener('pointerup', this.historyPanelResizeEndHandler);
        document.removeEventListener('pointercancel', this.historyPanelResizeEndHandler);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        this.saveHistoryPanelWidth();
        await this.service.render();
    }

    public startDriveAddPanelResize(event: PointerEvent) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.resizingDriveAddPanel = true;
        this.driveAddPanelResizeStartX = event.clientX || 0;
        this.driveAddPanelResizeStartWidth = this.getCurrentDriveAddPanelWidth();
        this.driveAddPanelResizePointerTarget = event.currentTarget as any;
        try {
            if (this.driveAddPanelResizePointerTarget?.setPointerCapture && event.pointerId !== undefined) {
                this.driveAddPanelResizePointerTarget.setPointerCapture(event.pointerId);
            }
        } catch (e) { }
        document.addEventListener('pointermove', this.driveAddPanelResizeMoveHandler);
        document.addEventListener('pointerup', this.driveAddPanelResizeEndHandler);
        document.addEventListener('pointercancel', this.driveAddPanelResizeEndHandler);
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }

    public async resetDriveAddPanelWidth() {
        this.applyDriveAddPanelWidth(this.clampDriveAddPanelWidth(this.driveAddPanelDefaultWidth));
        this.clampChatPanelWidthToLayout();
        this.saveDriveAddPanelWidth();
        await this.service.render();
    }

    public async onDriveAddPanelResizeHandleKeydown(event: KeyboardEvent) {
        let nextWidth = this.driveAddPanelWidth;
        if (event.key === 'ArrowLeft') nextWidth -= event.shiftKey ? 40 : 20;
        else if (event.key === 'ArrowRight') nextWidth += event.shiftKey ? 40 : 20;
        else if (event.key === 'Home') nextWidth = this.driveAddPanelMinWidth;
        else if (event.key === 'End') nextWidth = this.getDriveAddPanelMaxWidth();
        else return;
        event.preventDefault();
        this.applyDriveAddPanelWidth(this.clampDriveAddPanelWidth(nextWidth));
        this.clampChatPanelWidthToLayout();
        this.saveDriveAddPanelWidth();
        await this.service.render();
    }

    public getDriveAddPanelMaxWidth(): number {
        const shellWidth = this.roomShell?.nativeElement?.getBoundingClientRect?.().width
            || window.innerWidth
            || 1200;
        const historyWidth = this.showHistory ? this.historyPanelWidth : 0;
        const handleWidth = 10;
        const minRightWidth = shellWidth < 820 ? 280 : this.chatPanelRightMinWidth;
        const layoutMax = shellWidth - historyWidth - this.chatPanelMinWidth - handleWidth - minRightWidth;
        return Math.max(this.driveAddPanelMinWidth, Math.min(this.driveAddPanelMaxWidth, layoutMax));
    }

    private onDriveAddPanelResizeMove(event: PointerEvent) {
        if (!this.resizingDriveAddPanel) return;
        event.preventDefault();
        const delta = (event.clientX || 0) - this.driveAddPanelResizeStartX;
        this.applyDriveAddPanelWidth(this.clampDriveAddPanelWidth(this.driveAddPanelResizeStartWidth + delta));
        this.clampChatPanelWidthToLayout();
        this.syncViewerHighlightLayer();
    }

    private async stopDriveAddPanelResize(event?: PointerEvent) {
        if (!this.resizingDriveAddPanel) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.resizingDriveAddPanel = false;
        try {
            if (this.driveAddPanelResizePointerTarget?.releasePointerCapture && event?.pointerId !== undefined) {
                this.driveAddPanelResizePointerTarget.releasePointerCapture(event.pointerId);
            }
        } catch (e) { }
        this.driveAddPanelResizePointerTarget = null;
        document.removeEventListener('pointermove', this.driveAddPanelResizeMoveHandler);
        document.removeEventListener('pointerup', this.driveAddPanelResizeEndHandler);
        document.removeEventListener('pointercancel', this.driveAddPanelResizeEndHandler);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        this.saveDriveAddPanelWidth();
        await this.service.render();
    }

    public startChatPanelResize(event: PointerEvent) {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.resizingChatPanel = true;
        this.chatPanelResizeStartX = event.clientX || 0;
        this.chatPanelResizeStartWidth = this.getCurrentChatPanelWidth();
        this.chatPanelResizePointerTarget = event.currentTarget as any;
        try {
            if (this.chatPanelResizePointerTarget?.setPointerCapture && event.pointerId !== undefined) {
                this.chatPanelResizePointerTarget.setPointerCapture(event.pointerId);
            }
        } catch (e) { }
        document.addEventListener('pointermove', this.chatPanelResizeMoveHandler);
        document.addEventListener('pointerup', this.chatPanelResizeEndHandler);
        document.addEventListener('pointercancel', this.chatPanelResizeEndHandler);
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }

    public async resetChatPanelWidth() {
        this.applyChatPanelWidth(this.clampChatPanelWidth(this.chatPanelDefaultWidth));
        this.saveChatPanelWidth();
        await this.service.render();
    }

    public async onChatPanelResizeHandleKeydown(event: KeyboardEvent) {
        let nextWidth = this.chatPanelWidth;
        if (event.key === 'ArrowLeft') nextWidth -= event.shiftKey ? 40 : 20;
        else if (event.key === 'ArrowRight') nextWidth += event.shiftKey ? 40 : 20;
        else if (event.key === 'Home') nextWidth = this.chatPanelMinWidth;
        else if (event.key === 'End') nextWidth = this.getChatPanelMaxWidth();
        else return;
        event.preventDefault();
        this.applyChatPanelWidth(this.clampChatPanelWidth(nextWidth));
        this.saveChatPanelWidth();
        await this.service.render();
    }

    public getChatPanelMaxWidth(): number {
        const shellWidth = this.roomShell?.nativeElement?.getBoundingClientRect?.().width
            || window.innerWidth
            || 1200;
        const historyWidth = this.showHistory ? this.historyPanelWidth : 0;
        const driveAddWidth = this.driveBrowsing ? this.clampDriveAddPanelWidth(this.driveAddPanelWidth) : 0;
        const handleWidth = 10;
        const minRightWidth = shellWidth < 820 ? 280 : this.chatPanelRightMinWidth;
        const layoutMax = shellWidth - historyWidth - driveAddWidth - handleWidth - minRightWidth;
        return Math.max(this.chatPanelMinWidth, Math.min(this.chatPanelMaxWidth, layoutMax));
    }

    private onChatPanelResizeMove(event: PointerEvent) {
        if (!this.resizingChatPanel) return;
        event.preventDefault();
        const delta = (event.clientX || 0) - this.chatPanelResizeStartX;
        this.applyChatPanelWidth(this.clampChatPanelWidth(this.chatPanelResizeStartWidth + delta));
        this.scheduleChatInputHeightSync();
        this.syncViewerHighlightLayer();
    }

    private async stopChatPanelResize(event?: PointerEvent) {
        if (!this.resizingChatPanel) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.resizingChatPanel = false;
        try {
            if (this.chatPanelResizePointerTarget?.releasePointerCapture && event?.pointerId !== undefined) {
                this.chatPanelResizePointerTarget.releasePointerCapture(event.pointerId);
            }
        } catch (e) { }
        this.chatPanelResizePointerTarget = null;
        document.removeEventListener('pointermove', this.chatPanelResizeMoveHandler);
        document.removeEventListener('pointerup', this.chatPanelResizeEndHandler);
        document.removeEventListener('pointercancel', this.chatPanelResizeEndHandler);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        this.saveChatPanelWidth();
        await this.service.render();
    }

    private restoreHistoryPanelWidth() {
        try {
            const savedWidth = Number(localStorage.getItem(this.historyPanelWidthStorageKey));
            if (savedWidth > 0) {
                this.historyPanelWidth = this.clampHistoryPanelWidth(savedWidth);
            }
        } catch (e) { }
    }

    private saveHistoryPanelWidth() {
        try {
            localStorage.setItem(this.historyPanelWidthStorageKey, String(Math.round(this.historyPanelWidth)));
        } catch (e) { }
    }

    private getCurrentHistoryPanelWidth(): number {
        const current = this.historyPanel?.nativeElement?.getBoundingClientRect?.().width;
        return Number(current || this.historyPanelWidth || this.historyPanelDefaultWidth);
    }

    private clampHistoryPanelWidth(width: number): number {
        const numericWidth = Number(width || this.historyPanelDefaultWidth);
        return Math.round(Math.max(this.historyPanelMinWidth, Math.min(this.getHistoryPanelMaxWidth(), numericWidth)));
    }

    private clampHistoryPanelWidthToLayout() {
        this.applyHistoryPanelWidth(this.clampHistoryPanelWidth(this.historyPanelWidth));
    }

    private applyHistoryPanelWidth(width: number) {
        this.historyPanelWidth = width;
        const panel = this.historyPanel?.nativeElement;
        if (panel) {
            panel.style.width = `${width}px`;
            panel.style.flexBasis = `${width}px`;
        }
    }

    private restoreChatPanelWidth() {
        try {
            const savedWidth = Number(localStorage.getItem(this.chatPanelWidthStorageKey));
            if (savedWidth > 0) {
                this.chatPanelWidth = this.clampChatPanelWidth(savedWidth);
            }
        } catch (e) { }
    }

    private saveChatPanelWidth() {
        try {
            localStorage.setItem(this.chatPanelWidthStorageKey, String(Math.round(this.chatPanelWidth)));
        } catch (e) { }
    }

    private getDriveAddPanelWidthStorageKey(): string {
        return `${this.driveAddPanelWidthStoragePrefix}${this.sessionId || 'unknown'}`;
    }

    private restoreDriveAddPanelWidth() {
        if (!this.sessionId) return;
        try {
            const savedWidth = Number(localStorage.getItem(this.getDriveAddPanelWidthStorageKey()));
            if (savedWidth > 0) {
                this.driveAddPanelWidth = this.clampDriveAddPanelWidth(savedWidth);
            }
        } catch (e) { }
    }

    private saveDriveAddPanelWidth() {
        if (!this.sessionId) return;
        try {
            localStorage.setItem(this.getDriveAddPanelWidthStorageKey(), String(Math.round(this.driveAddPanelWidth)));
        } catch (e) { }
    }

    private getCurrentDriveAddPanelWidth(): number {
        const current = this.driveAddPanel?.nativeElement?.getBoundingClientRect?.().width;
        return Number(current || this.driveAddPanelWidth || this.driveAddPanelDefaultWidth);
    }

    private clampDriveAddPanelWidth(width: number): number {
        const numericWidth = Number(width || this.driveAddPanelDefaultWidth);
        return Math.round(Math.max(this.driveAddPanelMinWidth, Math.min(this.getDriveAddPanelMaxWidth(), numericWidth)));
    }

    private clampDriveAddPanelWidthToLayout() {
        this.applyDriveAddPanelWidth(this.clampDriveAddPanelWidth(this.driveAddPanelWidth));
    }

    private applyDriveAddPanelWidth(width: number) {
        this.driveAddPanelWidth = width;
        const panel = this.driveAddPanel?.nativeElement;
        if (panel) {
            panel.style.width = `${width}px`;
            panel.style.flexBasis = `${width}px`;
        }
    }

    private getCurrentChatPanelWidth(): number {
        const current = this.chatPanel?.nativeElement?.getBoundingClientRect?.().width;
        return Number(current || this.chatPanelWidth || this.chatPanelDefaultWidth);
    }

    private clampChatPanelWidth(width: number): number {
        const numericWidth = Number(width || this.chatPanelDefaultWidth);
        return Math.round(Math.max(this.chatPanelMinWidth, Math.min(this.getChatPanelMaxWidth(), numericWidth)));
    }

    private clampChatPanelWidthToLayout() {
        this.applyChatPanelWidth(this.clampChatPanelWidth(this.chatPanelWidth));
    }

    private applyChatPanelWidth(width: number) {
        this.chatPanelWidth = width;
        const panel = this.chatPanel?.nativeElement;
        if (panel) {
            panel.style.width = `${width}px`;
            panel.style.flexBasis = `${width}px`;
        }
        this.scheduleChatInputHeightSync();
    }

    public syncChatInputHeight(event?: any) {
        const textarea = event?.target || this.chatInput?.nativeElement;
        if (!textarea) return;

        const style = window.getComputedStyle(textarea);
        const minHeight = Number.parseFloat(style.minHeight || '') || 42;
        const maxHeight = Number.parseFloat(style.maxHeight || '') || 96;
        const placeholderHeight = textarea.value ? 0 : this.measureTextareaTextHeight(textarea, textarea.placeholder || '');

        textarea.style.height = 'auto';
        const contentHeight = textarea.scrollHeight || minHeight;
        const desiredHeight = Math.max(minHeight, contentHeight, placeholderHeight);
        const nextHeight = Math.min(maxHeight, desiredHeight);

        textarea.style.height = `${nextHeight}px`;
        textarea.style.overflowY = desiredHeight > maxHeight ? 'auto' : 'hidden';
    }

    public scheduleChatInputHeightSync() {
        if (this.chatInputHeightSyncTimer) window.clearTimeout(this.chatInputHeightSyncTimer);
        this.chatInputHeightSyncTimer = window.setTimeout(() => {
            this.chatInputHeightSyncTimer = null;
            this.syncChatInputHeight();
        }, 0);
    }

    private measureTextareaTextHeight(textarea: any, text: string): number {
        if (!text) return 0;
        const rect = textarea.getBoundingClientRect?.();
        const width = rect?.width || textarea.clientWidth || 0;
        if (!width) return 0;

        const style = window.getComputedStyle(textarea);
        const mirror = document.createElement('div');
        mirror.style.position = 'absolute';
        mirror.style.visibility = 'hidden';
        mirror.style.pointerEvents = 'none';
        mirror.style.zIndex = '-1';
        mirror.style.left = '-9999px';
        mirror.style.top = '0';
        mirror.style.width = `${width}px`;
        mirror.style.boxSizing = style.boxSizing;
        mirror.style.border = style.border;
        mirror.style.padding = style.padding;
        mirror.style.fontFamily = style.fontFamily;
        mirror.style.fontSize = style.fontSize;
        mirror.style.fontWeight = style.fontWeight;
        mirror.style.letterSpacing = style.letterSpacing;
        mirror.style.lineHeight = style.lineHeight;
        mirror.style.whiteSpace = 'pre-wrap';
        mirror.style.overflowWrap = 'anywhere';
        mirror.style.wordBreak = 'break-word';
        mirror.textContent = text;
        document.body.appendChild(mirror);
        const height = mirror.scrollHeight;
        document.body.removeChild(mirror);
        return height;
    }

    // ========== Session History ==========

    public async loadSessions(reset: boolean = true) {
        if (this.loadingHistory && !reset) return;
        if (this.loadingMoreSessions) return;
        const nextPage = reset ? 1 : this.sessionPage + 1;
        if (reset) {
            this.loadingHistory = true;
        } else {
            this.loadingMoreSessions = true;
        }
        await this.service.render();
        try {
            const res: any = await wiz.call('list_sessions', { limit: this.sessionLimit, page: nextPage });
            if (res.code === 200 && res.data?.sessions) {
                const rows = res.data.sessions || [];
                this.sessions = reset ? rows : this.sessions.concat(rows);
                this.sessionPage = nextPage;
                this.hasMoreSessions = !!res.data?.has_more;
                this.pruneSelectedSessions();
            }
        } catch (e) {
            console.error('Failed to load sessions:', e);
        }
        this.loadingHistory = false;
        this.loadingMoreSessions = false;
        await this.service.render();
    }

    public async loadMoreSessions(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        if (!this.hasMoreSessions) return;
        await this.loadSessions(false);
    }

    public async toggleHistory() {
        this.showHistory = !this.showHistory;
        if (!this.showHistory) {
            this.historySelectionMode = false;
            this.selectedSessionIds = {};
        } else {
            this.restoreHistoryPanelWidth();
            this.clampHistoryPanelWidthToLayout();
        }
        this.clampChatPanelWidthToLayout();
        if (this.showHistory && this.sessions.length === 0) {
            await this.loadSessions(true);
        }
        await this.service.render();
    }

    public stopHistoryButtonEvent(event: Event) {
        event.stopPropagation();
        const anyEvent = event as any;
        if (typeof anyEvent.stopImmediatePropagation === 'function') {
            anyEvent.stopImmediatePropagation();
        }
    }

    private setRightTab(tab: string, userInitiated: boolean = false) {
        this.rightTab = tab;
        if (userInitiated) {
            this.rightTabUserSelected = true;
        }
    }

    private autoSwitchRightTab(tab: string) {
        if (!this.rightTabUserSelected) {
            this.rightTab = tab;
        }
    }

    public async switchRightTab(tab: string) {
        this.setRightTab(tab, true);
        this.saveViewState();
        await this.service.render();
    }

    public async switchMobileRoomPane(pane: string) {
        if (pane === 'chat') {
            this.mobileRoomPane = 'chat';
            await this.service.render();
            return;
        }

        this.mobileRoomPane = 'right';
        this.saveViewState();
        await this.service.render();
    }

    private getViewStateKey(): string {
        return `${this.roomViewStatePrefix}${this.sessionId || 'unknown'}`;
    }

    private saveViewState() {
        if (!this.sessionId) return;
        try {
            sessionStorage.setItem(this.getViewStateKey(), JSON.stringify({
                rightTab: this.rightTab,
                resultSubTab: this.resultSubTab,
                selectedPdfFileIndex: this.selectedPdfFileIndex,
                pdfUrl: this.pdfUrl,
                pdfImageUrl: this.pdfImageUrl,
                pdfPage: this.pdfPage,
                pdfFileName: this.pdfFileName,
                viewerMode: this.viewerMode,
                viewerTotalPages: this.viewerTotalPages,
                pdfZoomPercent: this.pdfZoomPercent,
                viewerScrollMode: this.viewerScrollMode,
                hideSpacing: this.hideSpacing,
                savedAt: Date.now(),
            }));
        } catch (e) { }
    }

    private restoreViewState() {
        if (!this.sessionId) return;
        try {
            const raw = sessionStorage.getItem(this.getViewStateKey());
            if (!raw) return;
            const state = JSON.parse(raw);
            const rightTabs = ['canvas', 'result', 'pdf'];
            const subTabs = ['all', 'excel', 'copy', 'typo', 'omission', 'context', 'instruction', 'state_evaluation', 'consistency'];

            if (rightTabs.indexOf(state.rightTab) >= 0) {
                this.rightTab = state.rightTab;
                this.rightTabUserSelected = true;
            }
            if (subTabs.indexOf(state.resultSubTab) >= 0) {
                this.resultSubTab = state.resultSubTab === 'excel' ? 'all' : state.resultSubTab;
            }
            this.hideSpacing = !!state.hideSpacing;

            const savedFileIndex = String(state.selectedPdfFileIndex || '');
            if (savedFileIndex && this.findViewerFile(savedFileIndex)) {
                this.selectedPdfFileIndex = savedFileIndex;
            }
            this.pdfPage = Math.max(1, Number(state.pdfPage || 1));
            this.pdfFileName = String(state.pdfFileName || '');
            this.viewerMode = String(state.viewerMode || '');
            this.viewerTotalPages = Number(state.viewerTotalPages || 0);
            this.pdfZoomPercent = this.clampPdfZoom(state.pdfZoomPercent || 100);
            this.viewerScrollMode = !!state.viewerScrollMode;

            const selectedFile = this.selectedPdfFileIndex ? this.findViewerFile(this.selectedPdfFileIndex) : null;
            const savedPdfUrl = String(state.pdfUrl || '');
            if (selectedFile && this.isHwpViewerFile(selectedFile)) {
                this.pdfUrl = this.buildHwpPageUrl(selectedFile.index, this.pdfPage, true);
                this.viewerMode = 'hwp_svg';
                this.pdfFileName = selectedFile.filename || this.pdfFileName;
            } else if (savedPdfUrl.startsWith('/wiz/api/page.chatbot.room/')) {
                this.pdfUrl = this.withPdfPage(savedPdfUrl, this.pdfPage);
            }

            if (this.rightTab === 'pdf' && !this.pdfUrl && this.selectedPdfFileIndex) {
                const file = this.findViewerFile(this.selectedPdfFileIndex);
                if (file) {
                    this.pdfFileName = file.filename || this.pdfFileName;
                    if (this.isHwpViewerFile(file)) {
                        this.pdfUrl = this.buildHwpPageUrl(file.index, this.pdfPage, true);
                        this.viewerMode = 'hwp_svg';
                    } else {
                        this.pdfUrl = this.withPdfPage(this.buildRawPdfUrl(file.index), this.pdfPage);
                        this.viewerMode = 'pdf';
                    }
                }
            }
            this.refreshPdfImageUrl();
        } catch (e) { }
    }

    public async switchSession(session: any) {
        if (session.id === this.sessionId) return;
        this.saveViewState();
        this.resetState();
        this.sessionId = session.id;
        window.history.replaceState(null, '', `/chatbot/room/${session.id}`);
        await this.loadSession();
        this.showHistory = false;
        this.historySelectionMode = false;
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async handleHistorySessionClick(session: any, event: Event) {
        if (this.historySelectionMode) {
            await this.toggleSessionSelection(session, event);
            return;
        }
        await this.switchSession(session);
    }

    private resetState() {
        this.stopProgressPolling();
        this.messages = [];
        this.results = [];
        this.copyFindings = [];
        this.typoFindings = [];
        this.omissionFindings = [];
        this._omissionDisplaySequence = 0;
        this.omissionSummary = null;
        this.omissionWorkbook = null;
        this.selectedOmissionSheet = '';
        this.omissionWorkbookLoading = false;
        this.omissionWorkbookError = '';
        this.inspectionWorkbook = null;
        this.selectedInspectionSheet = '';
        this.inspectionWorkbookLoading = false;
        this.inspectionWorkbookError = '';
        this.contextFindings = [];
        this.contextSummary = null;
        this.consistencyFindings = [];
        this.consistencySummary = null;
        this.instructionFindings = [];
        this.instructionSummary = null;
        this.stateEvaluationFindings = [];
        this.stateEvaluationSummary = null;
        this.copyImageStats = null;
        this.infoResults = [];
        this.selectedCopy = null;
        this.selectedTypo = null;
        this.pdfUrl = '';
        this.pdfImageUrl = '';
        this.pdfPage = 1;
        this.pdfFileName = '';
        this.viewerMode = '';
        this.viewerTotalPages = 0;
        this.viewerErrorMessage = '';
        this.pdfZoomPercent = 100;
        this.compareMode = false;
        this.compareLeft = null;
        this.compareRight = null;
        this.rightTabUserSelected = false;
        this.rightTab = 'result';
        this.resultSubTab = 'all';
        this.omissionResultView = 'checklist';
        this.agentStatus = 'idle';
        this.agentTasks = [];
        this.lastIntent = '';
        this.statusMessage = '';
        this.runtimeState = null;
        this._progressMessageIndex = -1;
        this.pdfFiles = [];
        this.selectedPdfFileIndex = '';
        this.hideSpacing = false;
        this.selectedCanvasTask = null;
        this.selectedCanvasTaskName = '';
        this.removeCanvasTaskDetailMessage();
    }

    public async deleteSessionFromHistory(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        const ok = await this.service.modal.show({
            title: '세션 삭제',
            message: '이 검사 세션을 삭제하시겠습니까?',
            action: '삭제',
            status: 'error',
        });
        if (!ok) return;
        try {
            const res: any = await wiz.call('delete_session', { session_id: session.id });
            if (res.code === 200) {
                this.sessions = this.sessions.filter((s: any) => s.id !== session.id);
                delete this.selectedSessionIds[session.id];
                if (this.sessions.length === 0) this.historySelectionMode = false;
                if (session.id === this.sessionId) {
                    this.service.href('/chatbot');
                    return;
                }
                await this.service.render();
            } else {
                await this.service.modal.error(res.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('삭제에 실패했습니다.');
        }
    }

    public get selectedSessionCount(): number {
        return this.getSelectedSessionIds().length;
    }

    public get selectedReportSessionCount(): number {
        return this.getSelectedReportSessions().length;
    }

    public isSessionSelected(session: any): boolean {
        return !!this.selectedSessionIds[session?.id];
    }

    public areAllSessionsSelected(): boolean {
        const ids = (this.sessions || []).map((s: any) => s.id).filter((id: string) => !!id);
        return ids.length > 0 && ids.every((id: string) => !!this.selectedSessionIds[id]);
    }

    public async toggleSessionSelection(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        if (!session?.id) return;
        if (this.selectedSessionIds[session.id]) {
            delete this.selectedSessionIds[session.id];
        } else {
            this.selectedSessionIds[session.id] = true;
        }
        await this.service.render();
    }

    public async toggleAllSessionSelection(event: Event) {
        this.stopHistoryButtonEvent(event);
        if (this.areAllSessionsSelected()) {
            this.selectedSessionIds = {};
            await this.service.render();
            return;
        }
        const selected: { [key: string]: boolean } = {};
        for (const session of this.sessions || []) {
            if (session?.id) selected[session.id] = true;
        }
        this.selectedSessionIds = selected;
        await this.service.render();
    }

    public async enterHistorySelectionMode(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.historySelectionMode = true;
        await this.service.render();
    }

    public async exitHistorySelectionMode(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.historySelectionMode = false;
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async clearSessionSelection(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async downloadSelectedSessionReports(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        const reportSessions = this.getSelectedReportSessions();
        if (reportSessions.length === 0) {
            await this.service.modal.error('선택한 이력에 받을 결과표가 없습니다.');
            return;
        }
        for (const session of reportSessions) {
            window.open(this.getInspectionReportUrl(session.id), '_blank');
        }
    }

    public async deleteSelectedSessions(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        const ids = this.getSelectedSessionIds();
        if (ids.length === 0) {
            await this.service.modal.error('삭제할 이력을 선택해주세요.');
            return;
        }
        const ok = await this.service.modal.show({
            title: '선택 세션 삭제',
            message: `${ids.length}개 검사 세션을 삭제하시겠습니까?`,
            action: '삭제',
            status: 'error',
        });
        if (!ok) return;
        try {
            const deletingCurrentSession = ids.indexOf(this.sessionId) >= 0;
            const res: any = await wiz.call('delete_sessions', { session_ids: JSON.stringify(ids) });
            if (res.code === 200) {
                this.sessions = this.sessions.filter((s: any) => ids.indexOf(s.id) < 0);
                this.selectedSessionIds = {};
                this.historySelectionMode = false;
                if (deletingCurrentSession) {
                    this.service.href('/chatbot');
                    return;
                }
                await this.service.render();
            } else {
                await this.service.modal.error(res.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('삭제에 실패했습니다.');
        }
    }

    private getSelectedSessionIds(): string[] {
        const existing = new Set((this.sessions || []).map((s: any) => s.id).filter((id: string) => !!id));
        return Object.keys(this.selectedSessionIds || {}).filter((id: string) => this.selectedSessionIds[id] && existing.has(id));
    }

    private getSelectedReportSessions(): any[] {
        const ids = this.getSelectedSessionIds();
        return (this.sessions || []).filter((session: any) => ids.indexOf(session.id) >= 0 && session.has_results);
    }

    private pruneSelectedSessions() {
        const selected: { [key: string]: boolean } = {};
        for (const id of this.getSelectedSessionIds()) {
            selected[id] = true;
        }
        this.selectedSessionIds = selected;
        if ((this.sessions || []).length === 0) {
            this.historySelectionMode = false;
        }
    }

    public getInspectionReportUrl(sessionId: string = this.sessionId): string {
        return `/wiz/api/page.chatbot.room/serve_inspection_excel?session_id=${encodeURIComponent(sessionId || '')}`;
    }

    public async downloadInspectionReport(sessionId: string = this.sessionId, event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        if (!sessionId) return;
        window.open(this.getInspectionReportUrl(sessionId), '_blank');
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        try {
            const d = new Date(dateStr);
            const now = new Date();
            const diffMs = now.getTime() - d.getTime();
            const diffMin = Math.floor(diffMs / 60000);
            const diffHour = Math.floor(diffMs / 3600000);
            const diffDay = Math.floor(diffMs / 86400000);
            if (diffMin < 1) return '방금 전';
            if (diffMin < 60) return `${diffMin}분 전`;
            if (diffHour < 24) return `${diffHour}시간 전`;
            if (diffDay < 7) return `${diffDay}일 전`;
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            const hh = String(d.getHours()).padStart(2, '0');
            const mi = String(d.getMinutes()).padStart(2, '0');
            return `${mm}/${dd} ${hh}:${mi}`;
        } catch {
            return dateStr;
        }
    }

    public getStatusLabel(status: string): string {
        switch (status) {
            case 'uploaded': return '대기';
            case 'running': return '진행 중';
            case 'completed': return '완료';
            case 'error': return '오류';
            default: return status;
        }
    }

    public getStatusClass(status: string): string {
        switch (status) {
            case 'running': return 'bg-blue-50 text-blue-600 border-blue-200';
            case 'completed': return 'bg-green-50 text-green-600 border-green-200';
            case 'error': return 'bg-red-50 text-red-600 border-red-200';
            default: return 'bg-zinc-50 text-zinc-500 border-zinc-200';
        }
    }

    public getFileTypeSummary(fileTypes: any): string {
        const labels: any = {
            report: '보고서', reference: '전차', kickoff: '착수계',
            contract: '계약서', ledger: '관리대장', proposal: '제안서',
            presentation: '발표자료', rfp: '제안요청서', evaluation_guideline: '평가가이드',
            additional: '추가',
        };
        return Object.entries(fileTypes || {})
            .map(([k, v]) => `${labels[k] || k} ${v}`)
            .join(', ');
    }

    public getSessionTitle(session: any): string {
        return session?.service_name || session?.report_folder_name || session?.filenames?.[0] || '검사 세션';
    }

    public getSessionSummary(session: any): string {
        return session?.conversation_summary || session?.first_question || '대화 요약이 없습니다';
    }

    // ========== Markdown to HTML ==========

    public renderMarkdown(text: string): string {
        if (!text) return '';
        let html = this.stripDecorativeEmoji(text);
        // Escape HTML entities first
        html = html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        // Headings: ### h3, ## h2, # h1 (process longest prefix first)
        html = html.replace(/^### (.+)$/gm, '<div class="chat-h3">$1</div>');
        html = html.replace(/^## (.+)$/gm, '<div class="chat-h2">$1</div>');
        html = html.replace(/^# (.+)$/gm, '<div class="chat-h1">$1</div>');
        // Bold: **text**
        html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        // Italic: *text* (but not inside bold)
        html = html.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');
        // Inline code: `text`
        html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
        // Unordered list: lines starting with "- "
        html = html.replace(/^- (.+)$/gm, '<li class="chat-ul-li">$1</li>');
        // Wrap consecutive <li> in <ul>
        html = html.replace(/((?:<li class="chat-ul-li">.*<\/li>\n?)+)/g, '<ul class="chat-ul">$1</ul>');
        // Numbered list: lines starting with "1. " etc
        html = html.replace(/^\d+\.\s+(.+)$/gm, '<li class="chat-ol-li">$1</li>');
        html = html.replace(/((?:<li class="chat-ol-li">.*<\/li>\n?)+)/g, '<ol class="chat-ol">$1</ol>');
        // Line breaks
        html = html.replace(/\n/g, '<br>');
        // Clean up <br> around block elements
        html = html.replace(/<br><ul/g, '<ul');
        html = html.replace(/<\/ul><br>/g, '</ul>');
        html = html.replace(/<br><ol/g, '<ol');
        html = html.replace(/<\/ol><br>/g, '</ol>');
        html = html.replace(/<\/li><br><li/g, '</li><li');
        html = html.replace(/<br><div/g, '<div');
        html = html.replace(/<\/div><br>/g, '</div>');
        return html;
    }

    public stripDecorativeEmoji(text: string): string {
        return (text || '')
            .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}]\u{FE0F}?/gu, '')
            .replace(/[🔥✅⚠️📄📋📑📃📒📎📝🔤]/g, '')
            .replace(/[ \t]{2,}/g, ' ');
    }

    // ========== Session ==========

    private stopProgressPolling() {
        if (this.progressPollTimer) {
            clearTimeout(this.progressPollTimer);
            this.progressPollTimer = null;
        }
    }

    private startProgressPolling(immediate: boolean = false) {
        this.stopProgressPolling();
        if (immediate) {
            this.pollProgress();
            return;
        }
        this.progressPollTimer = setTimeout(() => this.pollProgress(), 1500);
    }

    private async pollProgress() {
        if (this.progressPollBusy || !this.sessionId) return;

        this.progressPollBusy = true;
        try {
            const res: any = await wiz.call('get_progress', { session_id: this.sessionId });
            if (res.code === 200 && res.data) {
                this.applyQuestionQuota(res.data.quota);
                const runtimeState = res.data.runtime_state || null;
                const canvasState = res.data.canvas_state || null;
                const status = this.effectiveSessionStatus(res.data.status || 'uploaded', runtimeState, canvasState);
                this.applyRuntimeState(status, runtimeState, canvasState);
                await this.service.render();
                this.scrollToBottom();

                if (this.isRuntimeInProgress(status, runtimeState)) {
                    this.startProgressPolling();
                } else {
                    this.stopProgressPolling();
                    await this.loadSession();
                    return;
                }
            } else {
                this.startProgressPolling();
            }
        } catch (e) {
            this.startProgressPolling();
        } finally {
            this.progressPollBusy = false;
        }
    }

    private upsertStreamingAssistantMessage(content: string) {
        if (!content) return;

        let msg = this.messages.find((item: any) => item.role === 'assistant' && item.isStreaming && !item.isProgress);
        if (!msg) {
            msg = {
                role: 'assistant',
                content: '',
                timestamp: new Date().toISOString(),
                isStreaming: true,
            };
            this.messages.push(msg);
        }
        msg.content = content;
    }

    private getProgressTaskStatusLabel(status: string): string {
        switch (status) {
            case 'running': return '[진행]';
            case 'done': return '[완료]';
            case 'error': return '[오류]';
            default: return '[대기]';
        }
    }

    private getProgressTaskLatest(task: any): string {
        const details = task?.details || [];
        if (details.length > 0) return this.sanitizeProcessText(details[details.length - 1]);
        if (task?.description) return this.sanitizeProcessText(task.description);
        if (task?.page_start && task?.page_end) return `${task.page_start}~${task.page_end}페이지 처리`;
        if (task?.status === 'done') return `${task.result_count ?? 0}건 처리`;
        return '';
    }

    private isModelProgressLine(value: string): boolean {
        const text = `${value || ''}`.trim();
        if (!text) return false;
        return (
            /검사\s*엔진\s*모델\s*:/i.test(text) ||
            /\bmodel(_provider)?\b\s*[:=]/i.test(text) ||
            /\breasoning\s+[a-z]+/i.test(text) ||
            /\bopenai\/gpt/i.test(text) ||
            /\bgpt-[a-z0-9_.-]+/i.test(text)
        );
    }

    private isNoisyProgressLine(value: string): boolean {
        const text = this.sanitizeProcessText(value || '').replace(/\s+/g, ' ').trim();
        if (!text) return true;
        if (/오류|실패|확인 필요/.test(text)) return false;
        if (this.isModelProgressLine(value) || this.isModelProgressLine(text)) return true;
        return (
            /^작업 계획\s*:/.test(text) ||
            /^검사 세션 시작$/.test(text) ||
            /^문서 분석 (시작|완료)$/.test(text) ||
            /^구조화 결과 수신 완료/.test(text) ||
            /^구조화 결과를 정리하고 있습니다\.?$/.test(text) ||
            /^최종 JSON 파싱 실패로 구조화 출력을 한 번 재시도합니다\.?$/.test(text) ||
            /^응답 생성 중/.test(text) ||
            /^검사 엔진 준비 완료$/.test(text)
        );
    }

    private isProgressHeartbeat(value: string): boolean {
        const text = this.sanitizeProcessText(value || '');
        return text.includes('분석 중...') && text.endsWith('초)');
    }

    private compactTaskDetails(details: any[]): string[] {
        const compacted: string[] = [];
        for (const item of details || []) {
            const detail = this.sanitizeProcessText(item);
            if (!detail) continue;
            if (this.isProgressHeartbeat(detail)) {
                for (let i = compacted.length - 1; i >= 0; i--) {
                    if (this.isProgressHeartbeat(compacted[i])) {
                        compacted.splice(i, 1);
                    }
                }
            }
            if (compacted[compacted.length - 1] !== detail) {
                compacted.push(detail);
            }
        }
        return compacted.slice(-20);
    }

    private ensureProgressDoingText(value: string): string {
        let text = this.sanitizeProcessText(value || '').replace(/\s+/g, ' ').trim();
        if (!text) return '작업을 진행하는 중...';
        if (/완료|오류|실패/.test(text)) return text;
        if (/중(\.{3}|…)?$/.test(text)) return text;

        const replacements: Array<[RegExp, string]> = [
            [/중입니다(\.{3}|…)?$/g, '중...'],
            [/하고 있습니다(\.{3}|…)?$/g, '하는 중...'],
            [/분석하고 있습니다(\.{3}|…)?$/g, '분석하는 중...'],
            [/검사하고 있습니다(\.{3}|…)?$/g, '검사하는 중...'],
            [/생성하고 있습니다(\.{3}|…)?$/g, '생성하는 중...'],
            [/처리하고 있습니다(\.{3}|…)?$/g, '처리하는 중...'],
            [/진행하고 있습니다(\.{3}|…)?$/g, '진행하는 중...'],
            [/진행 중(\.{3}|…)?$/g, '진행 중...'],
        ];
        for (const [pattern, replacement] of replacements) {
            const next = text.replace(pattern, replacement);
            if (next !== text) return next;
        }

        text = text.replace(/[.。]+$/g, '');
        return `${text}하는 중...`;
    }

    private getProgressTasks(canvasState: any): any[] {
        return canvasState?.tasks || this.canvasTasks || [];
    }

    private getParallelRuntimeGroups(tasks: any[]): any[] {
        const groups = new Map<string, any[]>();
        for (const task of tasks || []) {
            const group = `${task?.parallel_group || ''}`.trim();
            if (!group) continue;
            if (!groups.has(group)) groups.set(group, []);
            groups.get(group)!.push(task);
        }
        return Array.from(groups.entries())
            .map(([group, groupTasks]: [string, any[]]) => {
                const total = groupTasks.length;
                const running = groupTasks.filter((task: any) => task?.status === 'running').length;
                const done = groupTasks.filter((task: any) => task?.status === 'done').length;
                const error = groupTasks.filter((task: any) => task?.status === 'error').length;
                const pending = Math.max(0, total - running - done - error);
                return { group, tasks: groupTasks, total, running, done, error, pending };
            })
            .filter((group: any) => group.total > 1);
    }

    private buildParallelRuntimeStatus(tasks: any[], includeCompleted: boolean = true): string {
        const groups = this.getParallelRuntimeGroups(tasks);
        if (groups.length === 0) return '';

        const active = groups.find((group: any) => group.running > 0)
            || groups.find((group: any) => group.error > 0)
            || groups.find((group: any) => group.done > 0 && group.done < group.total)
            || (includeCompleted ? groups.find((group: any) => group.done === group.total) : null)
            || groups[0];
        if (!active) return '';

        if (active.error > 0) {
            return `병렬 문서 구간 검사 확인 필요: 오류 ${active.error}개 / 완료 ${active.done}/${active.total}`;
        }
        if (active.running > 0) {
            return `병렬 문서 구간 검사 진행 중: ${active.running}개 실행 / 완료 ${active.done}/${active.total}`;
        }
        if (active.done === active.total) {
            return `병렬 문서 구간 검사 완료: ${active.total}개 구간`;
        }
        if (active.done > 0) {
            return `병렬 문서 구간 검사 진행 중: 완료 ${active.done}/${active.total}`;
        }
        return `병렬 문서 구간 검사 대기: ${active.total}개 구간`;
    }

    private getTaskSummaryKind(task: any): string {
        const taskType = typeof task === 'string' ? '' : `${task?.type || ''} ${task?.inspection_check || ''} ${task?.intent || ''}`;
        const rawName = typeof task === 'string'
            ? task
            : (task?.name || task?.label || task?.description || task?.title || '');
        const text = `${taskType} ${this.sanitizeProcessText(rawName)}`.toLowerCase();

        if (/omission|누락/.test(text)) return 'omission';
        if (/typo|spelling|오탈자|오타|맞춤법/.test(text)) return 'typo';
        if (/context|문맥/.test(text)) return 'context';
        if (/consistency|일치성/.test(text)) return 'consistency';
        if (/copy|카피|유사도|전차보고서/.test(text)) return 'copy';
        if (/parse|문서\s*(파싱|분석|준비)|파일\s*확인/.test(text)) return 'parse';
        if (/summary|summarize|요약|병합/.test(text)) return 'summary';
        if (/excel|report|보고서|결과표|엑셀/.test(text)) return 'report';
        return '';
    }

    private getTaskSummaryBaseLabel(kind: string): string {
        switch (kind) {
            case 'omission': return '누락사항 체크';
            case 'typo': return '오탈자 체크';
            case 'context': return '문맥 체크';
            case 'consistency': return '일치성 체크';
            case 'copy': return '카피 체크';
            case 'parse': return '문서 준비';
            case 'summary': return '결과 요약';
            case 'report': return '보고서 생성';
            default: return '작업';
        }
    }

    private getTaskSummaryOrder(): string[] {
        return ['omission', 'typo', 'context', 'consistency', 'copy', 'parse', 'summary', 'report'];
    }

    private groupTasksBySummaryKind(tasks: any[]): { [key: string]: any[] } {
        const grouped: { [key: string]: any[] } = {};
        for (const task of tasks || []) {
            const kind = this.getTaskSummaryKind(task);
            if (!kind) continue;
            if (!grouped[kind]) grouped[kind] = [];
            grouped[kind].push(task);
        }
        return grouped;
    }

    private getTaskNameForFallback(task: any): string {
        const raw = typeof task === 'string'
            ? task
            : (task?.name || task?.label || task?.description || task?.title || '');
        return this.sanitizeProcessText(raw).replace(/\s+/g, ' ').trim();
    }

    private isSummaryOnlyTask(task: any): boolean {
        const type = typeof task === 'string' ? '' : `${task?.type || ''}`;
        const label = this.getTaskNameForFallback(task);
        return (
            type === 'codex_plan'
            || type === 'codex_final'
            || type === 'parallel_group'
            || /^(검사 계획 수립|결과 정리|최종 결과 정리)$/.test(label)
        );
    }

    private hasConcreteTaskScopeText(value: any): boolean {
        const text = this.sanitizeProcessText(value || '');
        return /(\d+\s*~\s*\d+\s*p|\d+\s*p|\d+장|표지|목차|개요|현장조사|안전등급|종합결론|부록|본문|표|이미지|도면|사진|체크리스트|기준값|근거)/.test(text);
    }

    private getDetailedTaskLabel(task: any): string {
        const label = this.getTaskNameForFallback(task);
        if (!label) return '';

        const start = typeof task === 'string' ? null : task?.page_start;
        const end = typeof task === 'string' ? null : task?.page_end;
        if (start && end && !this.hasConcreteTaskScopeText(label)) {
            const range = start === end ? `${start}p` : `${start}~${end}p`;
            return `${label} ${range}`;
        }
        return label;
    }

    private getDetailedCompletedTaskItems(tasks: any[], limit: number = 16): string[] {
        const seen = new Set<string>();
        const labels: string[] = [];
        for (const task of tasks || []) {
            if (this.isSummaryOnlyTask(task)) continue;
            const label = this.getDetailedTaskLabel(task);
            if (!label || seen.has(label)) continue;
            seen.add(label);
            labels.push(label);
        }
        if (labels.length === 0) return [];

        const visible = labels.slice(0, limit).map((label: string) => this.ensureDoneSuffix(label));
        if (labels.length > limit) {
            visible.push(`외 ${labels.length - limit}개 작업 완료`);
        }
        return visible;
    }

    private getDetailedProgressTaskItems(tasks: any[], limit: number = 12): string[] {
        const candidates = (tasks || []).filter((task: any) => !this.isSummaryOnlyTask(task));
        if (candidates.length === 0) return [];

        const active = candidates.filter((task: any) => {
            const status = `${task?.status || ''}`;
            return status === 'running' || status === 'done' || status === 'error';
        });
        const source = active.length > 0 ? active : candidates;
        const seen = new Set<string>();
        const labels: string[] = [];

        for (const task of source) {
            const label = this.getDetailedTaskLabel(task);
            if (!label || seen.has(label)) continue;
            seen.add(label);
            const status = `${task?.status || ''}`;
            const statusLabel = status ? this.getCanvasTaskStatusLabel(status) : '대기';
            labels.push(`${label} ${statusLabel}`);
        }

        const visible = labels.slice(0, limit);
        if (candidates.length > limit) {
            visible.push(`전체 ${candidates.length}개 작업 중 ${visible.length}개 표시`);
        }
        return visible;
    }

    private ensureDoneSuffix(label: string): string {
        if (!label) return '';
        return /완료|오류|실패|확인 필요$/.test(label) ? label : `${label} 완료`;
    }

    public getCompletedTaskSummaryItems(tasks: any[]): string[] {
        if (!Array.isArray(tasks) || tasks.length === 0) return [];

        const detailedItems = this.getDetailedCompletedTaskItems(tasks);
        if (detailedItems.length > 0) return detailedItems;

        const grouped = this.groupTasksBySummaryKind(tasks);
        const items: string[] = [];
        for (const kind of this.getTaskSummaryOrder()) {
            if (grouped[kind] && grouped[kind].length > 0) {
                items.push(`${this.getTaskSummaryBaseLabel(kind)} 완료`);
            }
        }
        if (items.length > 0) return items;

        const seen = new Set<string>();
        const fallback: string[] = [];
        for (const task of tasks) {
            const label = this.getTaskNameForFallback(task);
            if (!label || seen.has(label)) continue;
            seen.add(label);
            fallback.push(label);
        }
        if (fallback.length <= 3) return fallback.map((label: string) => this.ensureDoneSuffix(label));
        return [`작업 ${fallback.length}건 완료`];
    }

    private getTaskProgressSummaryItems(tasks: any[]): string[] {
        if (!Array.isArray(tasks) || tasks.length === 0) return [];

        const detailedItems = this.getDetailedProgressTaskItems(tasks);
        if (detailedItems.length > 0) return detailedItems;

        const grouped = this.groupTasksBySummaryKind(tasks);
        const items: string[] = [];
        for (const kind of this.getTaskSummaryOrder()) {
            const group = grouped[kind] || [];
            if (group.length === 0) continue;

            const done = group.filter((task: any) => task?.status === 'done').length;
            const running = group.some((task: any) => task?.status === 'running');
            const error = group.some((task: any) => task?.status === 'error');
            const status = error
                ? '확인 필요'
                : running
                    ? '진행 중'
                    : done === group.length
                        ? '완료'
                        : done > 0
                            ? `진행 중 (${done}/${group.length})`
                            : '대기';
            items.push(`${this.getTaskSummaryBaseLabel(kind)} ${status}`);
        }
        if (items.length > 0) return items;

        const fallback = (tasks || [])
            .map((task: any) => this.getTaskNameForFallback(task))
            .filter((label: string) => !!label);
        if (fallback.length <= 3) return fallback;
        return [`작업 ${fallback.length}건 진행 중`];
    }

    private getEssentialProgressLine(value: any): string {
        const line = this.sanitizeProcessText(value || '').replace(/\s+/g, ' ').trim();
        if (!line || this.isNoisyProgressLine(value) || this.isNoisyProgressLine(line)) return '';

        const kind = this.getTaskSummaryKind(line);
        if (kind) {
            if (this.hasConcreteTaskScopeText(line)) {
                return line.length > 80 ? `${line.slice(0, 77)}...` : line;
            }
            const base = this.getTaskSummaryBaseLabel(kind);
            if (/오류|실패/.test(line)) return `${base} 확인 필요`;
            if (/완료/.test(line)) return `${base} 완료`;
            if (/대기/.test(line)) return `${base} 대기`;
            return `${base} 진행 중`;
        }

        return line.length > 80 ? `${line.slice(0, 77)}...` : line;
    }

    private buildProgressAssistantSummary(runtimeState: any, canvasState: any): string {
        const tasks = this.getProgressTasks(canvasState);
        const parallelStatus = this.buildParallelRuntimeStatus(tasks, false);
        if (parallelStatus) return parallelStatus;

        const runningTask = [...tasks].reverse().find((task: any) => task?.status === 'running');
        if (runningTask) {
            return this.ensureProgressDoingText(this.getTaskDisplayName(runningTask));
        }

        const status = this.sanitizeProcessText(runtimeState?.status_message || canvasState?.status || this.statusMessage || '검사가 진행 중입니다...');
        return this.ensureProgressDoingText(this.getEssentialProgressLine(status) || status);
    }

    private buildProgressAssistantDetails(runtimeState: any, canvasState: any): string[] {
        const tasks = this.getProgressTasks(canvasState);
        const lines: string[] = [];
        const seen = new Set<string>();
        const maxDetails = 8;

        const addLine = (value: any) => {
            const line = this.getEssentialProgressLine(value);
            if (!line || seen.has(line)) return;
            seen.add(line);
            lines.push(line);
        };

        addLine(this.buildParallelRuntimeStatus(tasks, true));
        addLine(runtimeState?.status_message || canvasState?.status || this.statusMessage || '검사가 진행 중입니다...');

        if (tasks.length > 0) {
            for (const line of this.getTaskProgressSummaryItems(tasks)) {
                addLine(line);
            }
        }

        const progressStream = this.sanitizeProcessText(runtimeState?.progress_stream || '');
        if (progressStream) {
            for (const line of progressStream.split('\n')) {
                const normalized = this.sanitizeProcessText(line || '');
                if (!/오류|실패|확인 필요|찾은 사항|병렬 검사/.test(normalized)) continue;
                addLine(normalized);
            }
        }

        return lines.slice(-maxDetails);
    }

    private buildProgressAssistantContent(runtimeState: any, canvasState: any): string {
        return this.buildProgressAssistantSummary(runtimeState, canvasState);
    }

    private upsertProgressAssistantMessage(content: string, streaming: boolean = true, details: string[] = []) {
        let msg: any = null;
        if (this._progressMessageIndex >= 0) {
            msg = this.messages[this._progressMessageIndex];
        }
        if (!msg || msg.role !== 'assistant' || !msg.isProgress) {
            msg = this.messages.find((item: any) => item.role === 'assistant' && item.isProgress && item.isStreaming);
            if (!msg) {
                msg = {
                    role: 'assistant',
                    content: '',
                    timestamp: new Date().toISOString(),
                    isStreaming: streaming,
                    isProgress: true,
                };
                this.messages.push(msg);
            }
            this._progressMessageIndex = this.messages.indexOf(msg);
        }

        msg.content = content;
        msg.progressSummary = content;
        const compactDetails = (details || []).filter((line: string) => {
            const text = `${line || ''}`.trim();
            return !!text && text !== content;
        });
        msg.progressDetails = compactDetails;
        msg.progressExpanded = !!msg.progressExpanded && compactDetails.length > 0;
        msg.isStreaming = streaming;
        msg.isProgress = true;
    }

    private updateProgressBubble(runtimeState: any, canvasState: any, streaming: boolean = true) {
        const content = this.buildProgressAssistantContent(runtimeState || {}, canvasState || {});
        const details = this.buildProgressAssistantDetails(runtimeState || {}, canvasState || {});
        this.upsertProgressAssistantMessage(content, streaming, details);
    }

    private isRuntimeInProgress(status: string, runtimeState: any): boolean {
        const agentStatus = String(runtimeState?.agent_status || '').trim();
        if (agentStatus === 'done' || agentStatus === 'error') return false;
        if (runtimeState?.is_running === true) return true;
        return String(status || '').trim() === 'running';
    }

    private effectiveSessionStatus(status: string, runtimeState: any, canvasState: any): string {
        const rawStatus = String(status || 'uploaded').trim();
        const agentStatus = String(runtimeState?.agent_status || '').trim();
        if (rawStatus === 'error' || agentStatus === 'error') return 'error';
        if (runtimeState?.is_running === true) return 'running';
        if (agentStatus === 'done' || canvasState?.phase === 'done') return 'completed';
        return rawStatus || 'uploaded';
    }

    private applyRuntimeState(status: string, runtimeState: any, canvasState: any) {
        this.runtimeState = runtimeState;

        if (this.sessionData) {
            this.sessionData.status = status;
        }

        if (canvasState) {
            this.canvasTasks = (canvasState.tasks || []).map((t: any) => ({
                name: t.name || '',
                type: t.type || '',
                status: t.status || 'pending',
                details: this.compactTaskDetails(t.details || []),
                result_count: t.result_count ?? -1,
                depends_on: t.depends_on || [],
                inspection_check: t.inspection_check || '',
                parallel_group: t.parallel_group || '',
                page_start: t.page_start || null,
                page_end: t.page_end || null,
                findings: (t.findings || []).map((item: any) => this.sanitizeProcessText(item)),
                llmContent: this.sanitizeProcessText(t.llmContent || ''),
                description: this.sanitizeProcessText(t.description || ''),
            }));
            this.rebuildCanvasTree();
            this.canvasPhase = canvasState.phase || 'idle';
            this.canvasStatus = this.sanitizeProcessText(canvasState.status || '');
            this.lastIntent = canvasState.lastIntent || this.lastIntent;
        }

        if (this.isRuntimeInProgress(status, runtimeState)) {
            this.sending = true;
            this.agentStatus = runtimeState?.agent_status === 'planning' ? 'planning' : 'executing';
            this.statusMessage = this.sanitizeProcessText(runtimeState?.status_message || this.canvasStatus || '검사가 진행 중입니다...');
            if (this.canvasPhase !== 'idle' || this.canvasTasks.length > 0) {
                this.autoSwitchRightTab('canvas');
            }
            this.updateProgressBubble(runtimeState, canvasState, true);
            if (runtimeState?.response_stream) {
                this.upsertStreamingAssistantMessage(runtimeState.response_stream);
            }
            if (runtimeState?.partial_results?.length) {
                this.appendPartialResults(runtimeState.partial_results);
            }
        } else {
            if (this._progressMessageIndex >= 0 && runtimeState) {
                this.updateProgressBubble(runtimeState, canvasState, false);
                this._progressMessageIndex = -1;
            }
            this.sending = false;
            this.agentStatus = 'idle';
            this.statusMessage = '';
        }
    }

    public async loadSession() {
        this.loading = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('load_session', { session_id: this.sessionId, light: 1 });
            const code = res.code;
            const data = res.data;

            if (code === 200 && data) {
                this.sessionData = data.session;
                this.applyQuestionQuota(data.quota);
                this.copyImageStats = data.copy_image_stats || this.sessionData?.copy_image_stats || null;
                this.messages = data.messages || [];

                this.refreshViewerFiles();

                // 결과 배열 초기화 후 복원
                this.copyFindings = [];
                this.typoFindings = [];
                this.omissionFindings = [];
                this._omissionDisplaySequence = 0;
                this.omissionSummary = null;
                this.omissionWorkbook = null;
                this.selectedOmissionSheet = '';
                this.omissionWorkbookError = '';
                this.inspectionWorkbook = null;
                this.selectedInspectionSheet = '';
                this.inspectionWorkbookLoading = false;
                this.inspectionWorkbookError = '';
                this.contextFindings = [];
                this.contextSummary = null;
                this.consistencyFindings = [];
                this.consistencySummary = null;
                this.instructionFindings = [];
                this.instructionSummary = null;
                this.stateEvaluationFindings = [];
                this.stateEvaluationSummary = null;
                this.infoResults = [];
                this.results = [];

                // 저장된 검사 결과 복원
                const savedResults = data.saved_results || [];
                if (savedResults.length > 0) {
                    this.updateResults(savedResults);
                }
                // 진행 중 런타임/캔버스 상태 복원
                const runtimeState = data.runtime_state || null;
                const canvasState = data.canvas_state || null;
                this.sessionData.status = this.effectiveSessionStatus(
                    this.sessionData.status || 'uploaded',
                    runtimeState,
                    canvasState,
                );
                this.applyRuntimeState(this.sessionData.status, runtimeState, canvasState);
                if (!this.isRuntimeInProgress(this.sessionData.status, runtimeState) && savedResults.length === 0) {
                    const partialResults = data.runtime_state?.partial_results || this.sessionData?.partial_results || [];
                    if (partialResults.length > 0) {
                        this.appendPartialResults(partialResults);
                    }
                }
                this.restoreViewState();
                this.ensureCompletedStateEvaluationRows(data);
                this.ensureCompletedNoFindingResult(data);
                this.normalizeResultSubTab();

                if (this.isRuntimeInProgress(this.sessionData.status, runtimeState)) {
                    this.startProgressPolling();
                } else {
                    this.stopProgressPolling();
                }

                // 초기 검사 가이드
                if (this.messages.length === 0) {
                    const reportFiles = this.getFilesByType('report');
                    const refFiles = this.getFilesByType('reference');
                    this.messages.push({
                        role: 'assistant',
                        content: this.buildInitialInspectionGuide(reportFiles.length, refFiles.length),
                        timestamp: new Date().toISOString(),
                    });
                }
            } else {
                await this.service.modal.error('세션을 불러올 수 없습니다.');
                this.service.href('/chatbot');
                return;
            }
        } catch (e: any) {
            let errText = '세션 로드 중 오류가 발생했습니다.';
            if (typeof e === 'string') errText = e;
            else if (e?.statusText) errText = `통신 오류: ${e.statusText} (${e.status})`;
            else if (e?.message) errText = e.message;
            await this.service.modal.error(errText);
            this.service.href('/chatbot');
            return;
        }

        this.loading = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public async sendMessage() {
        if (!this.inputMessage.trim() || this.sending || this.isQuestionQuotaExceeded) return;

        const message = this.inputMessage.trim();
        this.inputMessage = '';
        await this.submitChatMessage(message);
    }

    private async submitChatMessage(message: string, inspectionFlow: any = null) {
        if (!message || this.sending || this.isQuestionQuotaExceeded) return;

        this.sending = true;

        // 사용자 메시지 추가
        this.messages.push({
            role: 'user',
            content: message,
            timestamp: new Date().toISOString(),
        });
        await this.service.render();
        this.scheduleChatInputHeightSync();
        this.scrollToBottom();

        // Agent 상태 표시
        this.agentStatus = 'planning';
        this.statusMessage = '요청을 분석하고 있습니다...';
        this._streamingMessageIndex = -1;
        this._progressMessageIndex = -1;
        this.canvasPhase = 'analyzing';
        this.canvasStatus = '요청을 분석하고 있습니다...';
        this.canvasParallelStatus = '';
        this.rightTabUserSelected = false;
        this.setRightTab('canvas', false);
        this.canvasTasks = [];
        this.canvasTree = [];
        this.canvasResponse = '';
        this.selectedCanvasTask = null;
        this.selectedCanvasTaskName = '';
        this.removeCanvasTaskDetailMessage();
        this._partialResultKeys.clear();
        const requestedChecks = this.normalizeInspectionChecks(inspectionFlow?.checks || []);
        if (requestedChecks.length > 0) {
            this.resetFindingsForChecks(requestedChecks);
        }
        this.updateProgressBubble({
            is_running: true,
            agent_status: 'planning',
            status_message: '요청을 분석하고 있습니다...',
            progress_stream: '요청을 분석하고 있습니다...',
        }, {
            phase: this.canvasPhase,
            status: this.canvasStatus,
            tasks: this.canvasTasks,
        }, true);
        await this.service.render();

        try {
            const params: any = {
                session_id: this.sessionId,
                message: message,
            };
            if (inspectionFlow) {
                params.inspection_flow = JSON.stringify(inspectionFlow);
            }
            const res: any = await wiz.call('start_chat', params);

            if (res.code !== 200) {
                throw new Error(res.data?.message || `작업 시작 실패 (${res.code})`);
            }

            this.applyQuestionQuota(res.data?.quota);
            this.startProgressPolling(true);
        } catch (error: any) {
            let errText = '';
            if (typeof error === 'string') errText = error;
            else if (error?.message) errText = error.message;
            else if (error?.statusText) errText = `${error.statusText} (${error.status})`;
            else { try { errText = JSON.stringify(error); } catch { errText = String(error); } }

            this.messages.push({
                role: 'system',
                content: `통신 오류: ${errText}`,
                timestamp: new Date().toISOString(),
            });
            if (this._progressMessageIndex >= 0 && this.messages[this._progressMessageIndex]) {
                const msg = this.messages[this._progressMessageIndex];
                msg.content = `작업 시작 실패: ${errText}`;
                msg.progressSummary = msg.content;
                msg.progressDetails = [msg.content];
                msg.progressExpanded = true;
                msg.isStreaming = false;
                this._progressMessageIndex = -1;
            }
            this.agentStatus = 'idle';
            this.statusMessage = '';
            this.sending = false;
            await this.service.render();
            this.scrollToBottom();
            return;
        }
    }

    public async openInspectionFlowModal() {
        if (this.sending || this.isQuestionQuotaExceeded) return;
        this.showInspectionFlowModal = true;
        await this.service.render();
    }

    public async closeInspectionFlowModal() {
        this.showInspectionFlowModal = false;
        await this.service.render();
    }

    public get selectedInspectionFlowCount(): number {
        return this.getSelectedInspectionChecks().length;
    }

    public areAllInspectionFlowChecksSelected(): boolean {
        return this.inspectionFlowOptions.length > 0
            && this.inspectionFlowOptions.every((item: any) => item.enabled);
    }

    public async toggleAllInspectionFlowChecks(event: Event) {
        const target = event.target as HTMLInputElement;
        for (const item of this.inspectionFlowOptions) {
            item.enabled = !!target.checked;
        }
        await this.service.render();
    }

    public async toggleInspectionFlowCheck(item: any, event: Event) {
        const target = event.target as HTMLInputElement;
        item.enabled = !!target.checked;
        await this.service.render();
    }

    private getSelectedInspectionChecks(): string[] {
        return this.inspectionFlowOptions
            .filter((item: any) => item.enabled)
            .map((item: any) => item.id);
    }

    private getSelectedInspectionLabels(): string[] {
        return this.inspectionFlowOptions
            .filter((item: any) => item.enabled)
            .map((item: any) => item.label);
    }

    private buildInspectionFlowMessage(): string {
        const labels = this.getSelectedInspectionLabels();
        if (labels.length === this.inspectionFlowOptions.length) {
            return '전체 검사 시작';
        }
        return `선택 검사 시작: ${labels.join(', ')}`;
    }

    public async startInspectionFlow() {
        if (this.isQuestionQuotaExceeded) return;
        const checks = this.getSelectedInspectionChecks();
        if (checks.length === 0) {
            await this.service.modal.show({
                title: '검사 항목 없음',
                message: '실행할 검사 항목을 한 개 이상 선택해주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }

        const flow = {
            mode: 'full_inspection',
            checks,
            labels: this.getSelectedInspectionLabels(),
        };
        const message = this.buildInspectionFlowMessage();
        this.showInspectionFlowModal = false;
        await this.service.render();
        await this.submitChatMessage(message, flow);
    }

    private async sendMessageSSE(message: string) {
        const formData = new FormData();
        formData.append('session_id', this.sessionId);
        formData.append('message', message);

        const appId = 'page.chatbot.room';
        const response = await fetch(`/wiz/api/${appId}/chat_stream`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok || !response.body) {
            throw new Error(`SSE failed: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });

            // SSE 이벤트는 \n\n 으로 구분
            let idx: number;
            while ((idx = buffer.indexOf('\n\n')) !== -1) {
                const raw = buffer.substring(0, idx);
                buffer = buffer.substring(idx + 2);

                // 멀티라인 data: 처리
                const lines = raw.split('\n');
                let jsonStr = '';
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        jsonStr += line.slice(6);
                    } else if (line.startsWith('data:')) {
                        jsonStr += line.slice(5);
                    }
                }
                if (!jsonStr) continue;

                try {
                    const event = JSON.parse(jsonStr);
                    await this.handleSSEEvent(event);
                } catch (parseErr) {
                    // JSON 파싱 실패 — 무시
                }
            }
        }

        // 남은 버퍼 처리
        if (buffer.trim()) {
            const lines = buffer.split('\n');
            let jsonStr = '';
            for (const line of lines) {
                if (line.startsWith('data: ')) jsonStr += line.slice(6);
                else if (line.startsWith('data:')) jsonStr += line.slice(5);
            }
            if (jsonStr) {
                try {
                    const event = JSON.parse(jsonStr);
                    await this.handleSSEEvent(event);
                } catch { }
            }
        }
    }

    private _streamingMessageIndex: number = -1;
    private _progressMessageIndex: number = -1;
    private _lastLlmRender: number = 0;
    private _partialResultKeys: Set<string> = new Set();

    // Canvas state (right panel)
    public canvasPhase: string = 'idle'; // idle | analyzing | progress | done
    public canvasStatus: string = '';
    public canvasParallelStatus: string = '';
    public canvasTasks: any[] = [];
    public canvasTree: any[] = []; // tree structure [{task, children: [{task, children}]}]
    public canvasResponse: string = ''; // streaming response on canvas
    public selectedCanvasTask: any = null; // 클릭한 태스크 상세 보기
    public selectedCanvasTaskName: string = '';

    private async handleSSEEvent(event: any) {
        const eventType = event.type || '';

        if (eventType === 'status') {
            const message = this.sanitizeProcessText(event.message || '');
            this.statusMessage = message;
            this.agentStatus = 'executing';
            this.canvasPhase = this.canvasPhase === 'idle' ? 'analyzing' : this.canvasPhase;
            this.canvasStatus = message;
            this.autoSwitchRightTab('canvas');
            await this.service.render();

        } else if (eventType === 'plan') {
            this.canvasPhase = 'progress';
            this.canvasTasks = (event.tasks || []).map((t: any) => ({
                name: t.name || '',
                type: t.type || '',
                status: 'pending',
                details: [] as string[],
                result_count: -1,
                depends_on: t.depends_on || [],
                inspection_check: t.inspection_check || '',
                parallel_group: t.parallel_group || '',
                page_start: t.page_start || null,
                page_end: t.page_end || null,
                description: t.description || '',
            }));
            // Build tree: root tasks (no deps) with children
            this.rebuildCanvasTree();
            this.autoSwitchRightTab('canvas');
            await this.service.render();

        } else if (eventType === 'task_start') {
            this.statusMessage = `${this.sanitizeProcessText(event.task || '작업')} 진행 중...`;
            this.agentStatus = 'executing';
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task) task.status = 'running';
            this.rebuildCanvasTree();
            await this.service.render();

        } else if (eventType === 'task_progress') {
            const detail = this.sanitizeProcessText(event.detail || `${event.task} 처리 중...`);
            const isErrorDetail = /문서 검사 실패|문서 분석 실패|오류|실패/.test(detail);
            this.statusMessage = isErrorDetail
                ? detail
                : `${this.sanitizeProcessText(event.task || '작업')} 진행 중...`;
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task) {
                task.details = this.compactTaskDetails([...(task.details || []), detail]);
            }
            this.rebuildCanvasTree();
            await this.service.render();

        } else if (eventType === 'task_done') {
            const count = event.result_count || 0;
            this.statusMessage = `${this.sanitizeProcessText(event.task || '작업')} 완료 (${count}건)`;
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task) {
                task.status = 'done';
                task.result_count = count;
            }
            this.rebuildCanvasTree();
            await this.service.render();

        } else if (eventType === 'task_finding') {
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task) {
                if (!task.findings) task.findings = [];
                task.findings.push(this.sanitizeProcessText(event.text || ''));
            }
            this.rebuildCanvasTree();
            await this.service.render();

        } else if (eventType === 'result_delta') {
            const deltaResults = event.results || (event.result ? [event.result] : []);
            if (deltaResults.length > 0) {
                this.appendPartialResults(deltaResults);
            }
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task && event.count !== undefined) {
                task.result_count = event.count;
            }
            this.rebuildCanvasTree();
            await this.service.render();

        } else if (eventType === 'task_llm_delta') {
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task) {
                if (!task.llmContent) task.llmContent = '';
                task.llmContent += this.sanitizeProcessText(event.content || '');
            }
            const now = Date.now();
            if (!this._lastLlmRender || now - this._lastLlmRender > 80) {
                this._lastLlmRender = now;
                this.rebuildCanvasTree();
                await this.service.render();
            }

        } else if (eventType === 'task_llm_done') {
            // 분석 호출 완료: llmContent 유지 (다음 호출 시 구분선 추가)
            const task = this.canvasTasks.find((t: any) => t.name === event.task);
            if (task && task.llmContent) {
                task.llmContent += '\n───\n';
            }
            this.rebuildCanvasTree();
            await this.service.render();

        } else if (eventType === 'token') {
            if (this._streamingMessageIndex < 0) {
                this.canvasStatus = '응답 생성 중...';
                this.statusMessage = '응답 생성 중...';
                this.canvasResponse = '';
                this.messages.push({
                    role: 'assistant',
                    content: '',
                    timestamp: new Date().toISOString(),
                    isStreaming: true,
                });
                this._streamingMessageIndex = this.messages.length - 1;
            }
            this.canvasResponse += event.content || '';
            const msg = this.messages[this._streamingMessageIndex];
            msg.content = this.canvasResponse;
            await this.service.render();

        } else if (eventType === 'complete') {
            const data = event.data || {};
            const completedWithError = String(data.intent || '').trim() === 'error';

            // Canvas 완료 처리
            this.canvasPhase = 'done';
            this.canvasStatus = completedWithError ? '오류 발생' : '검사 완료';

            if (this._streamingMessageIndex >= 0 && this._streamingMessageIndex < this.messages.length) {
                const msg = this.messages[this._streamingMessageIndex];
                msg.content = data.response || msg.content;
                msg.isStreaming = false;
                msg.tasks = data.tasks || [];
                msg.intent = data.intent || '';
                msg.inspection_checks = data.inspection_checks || [];
                msg.excel_download_url = data.excel_download_url || '';
                this._streamingMessageIndex = -1;
                this._processAgentResults(data);
            } else {
                this.processAgentResponse(data);
            }

            // 검사 intent면 자동으로 결과 탭으로 전환
            if (data.intent && data.intent !== 'general' && !completedWithError) {
                this.autoSwitchRightTab('result');
            }

            // 캔버스 상태 저장 (세션 복귀 시 복원용)
            if (this.canvasTasks.length > 0 && data.intent && data.intent !== 'general') {
                this._saveCanvasState(data.intent);
            }

            await this.service.render();
            this.scrollToBottom();
        }
    }

    private async _saveCanvasState(lastIntent: string) {
        try {
            const tasks = this.canvasTasks.map((t: any) => ({
                name: t.name,
                type: t.type,
                status: t.status,
                result_count: t.result_count,
                depends_on: t.depends_on,
                inspection_check: t.inspection_check || '',
                parallel_group: t.parallel_group || '',
                page_start: t.page_start,
                page_end: t.page_end,
                findings: (t.findings || []).slice(-10),
                details: (t.details || []).slice(-20),
                llmContent: t.llmContent || '',
                description: t.description || '',
            }));
            const state = {
                tasks,
                phase: this.canvasPhase,
                status: this.canvasStatus,
                lastIntent,
                inspection_checks: this.normalizeInspectionChecks(
                    lastIntent === 'inspect'
                        ? tasks.map((task: any) => task.inspection_check).filter((check: any) => !!check)
                        : [lastIntent],
                ),
            };
            await wiz.call('save_canvas_state', {
                session_id: this.sessionId,
                canvas_state: JSON.stringify(state),
            });
        } catch (e) { }
    }

    private _buildCanvasTree(): any[] {
        const tasks = (this.canvasTasks || []).filter((t: any) => t && t.name);
        if (this._isSerialCodexStage(tasks)) {
            return tasks.map((task: any) => ({
                task,
                children: [],
                serial: true,
            }));
        }

        const detailedSequence = this._buildDetailedCanvasSequence(tasks);
        if (detailedSequence) return detailedSequence;

        const serialTasks = this._buildSerialCanvasSequence(tasks);
        if (serialTasks && serialTasks.length > 1) {
            return serialTasks.map((task: any) => ({
                task,
                children: [],
                serial: true,
            }));
        }

        const levels = this._buildCanvasDependencyLevels(tasks);
        const tree: any[] = [];

        for (let i = 0; i < levels.length; i += 1) {
            const level = levels[i];
            const nextLevel = levels[i + 1] || [];

            if (level.length === 1 && nextLevel.length > 1) {
                tree.push({
                    task: level[0],
                    children: [],
                    serial: true,
                });
                const chunks = this._chunkCanvasParallelTasks(nextLevel);
                chunks.forEach((chunk: any[], index: number) => {
                    tree.push({
                        task: this._makeParallelGroupTask(chunk, index, chunks.length),
                        children: chunk.map((task: any) => ({ task, children: [] })),
                        parallel: true,
                        synthetic: true,
                    });
                });
                i += 1;
                continue;
            }

            if (level.length > 1) {
                const chunks = this._chunkCanvasParallelTasks(level);
                chunks.forEach((chunk: any[], index: number) => {
                    tree.push({
                        task: this._makeParallelGroupTask(chunk, index, chunks.length),
                        children: chunk.map((task: any) => ({ task, children: [] })),
                        parallel: true,
                        synthetic: true,
                    });
                });
                continue;
            }

            if (level.length === 1) {
                tree.push({
                    task: level[0],
                    children: [],
                    serial: true,
                });
            }
        }

        return tree;
    }

    private rebuildCanvasTree() {
        this.canvasTree = this._buildCanvasTree();
        this.canvasParallelStatus = this.buildParallelRuntimeStatus(this.canvasTasks, true);
        this.refreshSelectedCanvasTask();
    }

    private getCanvasTaskKey(task: any): string {
        return this.sanitizeProcessText(task?.name || '').trim();
    }

    private findCanvasTreeTaskByName(name: string): any {
        if (!name) return null;
        const visit = (nodes: any[]): any => {
            for (const node of nodes || []) {
                if (this.getCanvasTaskKey(node?.task) === name) return node.task;
                const child = visit(node?.children || []);
                if (child) return child;
            }
            return null;
        };
        return visit(this.canvasTree || []);
    }

    private refreshSelectedCanvasTask() {
        if (!this.selectedCanvasTaskName) return;
        const task = this.findCanvasTreeTaskByName(this.selectedCanvasTaskName);
        if (!task) {
            this.selectedCanvasTask = null;
            this.selectedCanvasTaskName = '';
            this.removeCanvasTaskDetailMessage();
            return;
        }
        this.selectedCanvasTask = task;
        this.upsertCanvasTaskDetailMessage(task);
    }

    public isCanvasTaskSelected(task: any): boolean {
        return !!this.selectedCanvasTaskName && this.getCanvasTaskKey(task) === this.selectedCanvasTaskName;
    }

    public async selectCanvasTask(task: any) {
        const taskName = this.getCanvasTaskKey(task);
        if (!taskName) return;

        if (this.selectedCanvasTaskName === taskName) {
            this.selectedCanvasTask = null;
            this.selectedCanvasTaskName = '';
            this.removeCanvasTaskDetailMessage();
            await this.service.render();
            return;
        }

        this.selectedCanvasTask = task;
        this.selectedCanvasTaskName = taskName;
        this.upsertCanvasTaskDetailMessage(task);
        await this.service.render();
        this.scrollToBottom();
    }

    private getCanvasTaskStatusLabel(status: string): string {
        switch (status) {
            case 'running': return '처리중';
            case 'done': return '완료';
            case 'error': return '오류';
            default: return '대기';
        }
    }

    private getCanvasTaskDetailSummary(task: any): string {
        const status = this.getCanvasTaskStatusLabel(task?.status || '');
        const result = task?.status === 'done' && task?.result_count >= 0 ? ` ${task.result_count}건` : '';
        return `${status} ${this.getTaskDisplayName(task)}${result}`;
    }

    private getCanvasTaskDetailLines(task: any): string[] {
        const lines: string[] = [];
        const seen = new Set<string>();
        const addLine = (value: any, essential: boolean = true) => {
            const raw = this.sanitizeProcessText(value || '').replace(/\s+/g, ' ').trim();
            const line = essential ? (this.getEssentialProgressLine(value) || raw) : raw;
            if (!line || seen.has(line)) return;
            seen.add(line);
            lines.push(line);
        };

        addLine(this.getCanvasTaskDetailSummary(task));
        for (const detail of this.compactTaskDetails(task?.details || []).slice(-4)) {
            addLine(detail);
        }

        const llmContent = this.sanitizeProcessText(task?.llmContent || '');
        if (llmContent) {
            addLine('분석 응답 수신 완료');
        }

        for (const finding of (task?.findings || []).slice(-6)) {
            addLine(`찾은 사항: ${finding}`, false);
        }

        if (lines.length <= 1 && task?.status === 'done') {
            addLine('이상 없음');
        }

        return lines.slice(-12);
    }

    private upsertCanvasTaskDetailMessage(task: any) {
        const details = this.getCanvasTaskDetailLines(task);
        const summary = this.getCanvasTaskDetailSummary(task);
        let msg = this.messages.find((item: any) => item.role === 'assistant' && item.isCanvasTaskDetail);
        if (!msg) {
            msg = {
                role: 'assistant',
                content: '',
                timestamp: new Date().toISOString(),
                isStreaming: false,
                isProgress: true,
                isCanvasTaskDetail: true,
            };
            this.messages.push(msg);
        }
        msg.content = summary;
        msg.progressSummary = summary;
        msg.progressDetails = details;
        msg.progressExpanded = true;
        msg.isStreaming = false;
        msg.isProgress = true;
        msg.isCanvasTaskDetail = true;
    }

    private removeCanvasTaskDetailMessage() {
        this.messages = (this.messages || []).filter((item: any) => !item.isCanvasTaskDetail);
    }

    private _chunkCanvasParallelTasks(tasks: any[]): any[][] {
        const limit = 6;
        const chunks: any[][] = [];
        for (let i = 0; i < tasks.length; i += limit) {
            chunks.push(tasks.slice(i, i + limit));
        }
        return chunks;
    }

    private _isSerialCodexStage(tasks: any[]): boolean {
        return false;
    }

    private _buildCanvasDependencyLevels(tasks: any[]): any[][] {
        const taskNames = new Set(tasks.map((t: any) => t.name));
        const remaining = tasks.slice();
        const completed = new Set<string>();
        const levels: any[][] = [];

        while (remaining.length > 0) {
            const level = remaining.filter((task: any) => {
                const deps = Array.isArray(task.depends_on) ? task.depends_on.filter(Boolean) : [];
                return deps.every((dep: string) => completed.has(dep) || !taskNames.has(dep));
            });

            if (level.length === 0) {
                levels.push(remaining.splice(0));
                break;
            }

            levels.push(level);
            for (const task of level) {
                completed.add(task.name);
            }
            for (const task of level) {
                const index = remaining.findIndex((candidate: any) => candidate.name === task.name);
                if (index >= 0) remaining.splice(index, 1);
            }
        }

        return levels;
    }

    private _hasDetailedInspectionTasks(tasks: any[]): boolean {
        return (tasks || []).some((task: any) => (
            task?.type === 'codex_batch'
            && (
                task?.parallel_group
                || task?.page_start
                || task?.page_end
                || this.hasConcreteTaskScopeText(task?.name || task?.description || '')
            )
        ));
    }

    private _buildDetailedCanvasSequence(tasks: any[]): any[] | null {
        if (!this._hasDetailedInspectionTasks(tasks)) return null;
        const levels = this._buildCanvasDependencyLevels(tasks);
        if (!levels.some((level: any[]) => level.length > 1)) return null;

        const sequence: any[] = [];
        for (const level of levels) {
            if (level.length > 1) {
                const chunks = this._chunkCanvasParallelTasks(level);
                chunks.forEach((chunk: any[], index: number) => {
                    sequence.push({
                        task: this._makeParallelGroupTask(chunk, index, chunks.length),
                        children: chunk.map((task: any) => ({
                            task,
                            children: [],
                            detailed: true,
                        })),
                        parallel: true,
                        synthetic: true,
                        detailed: true,
                    });
                });
                continue;
            }

            for (const task of level) {
                sequence.push({
                    task,
                    children: [],
                    serial: true,
                    detailed: true,
                });
            }
        }
        return sequence.length > 0 ? sequence : null;
    }

    private _makeParallelGroupTask(tasks: any[], index: number = 0, total: number = 1): any {
        const running = tasks.some((task: any) => task.status === 'running');
        const error = tasks.some((task: any) => task.status === 'error');
        const done = tasks.length > 0 && tasks.every((task: any) => task.status === 'done');
        const completed = tasks.filter((task: any) => task.status === 'done').length;
        const resultCount = tasks.reduce((sum: number, task: any) => sum + (Number(task.result_count) || 0), 0);
        const suffix = total > 1 ? ` ${index + 1}/${total}` : '';

        return {
            name: `병렬 문서 구간 검사${suffix}`,
            type: 'parallel_group',
            status: error ? 'error' : running ? 'running' : done ? 'done' : 'pending',
            result_count: resultCount,
            description: `최대 6개씩 문서 구간을 병렬 검사합니다. 완료 ${completed}/${tasks.length}`,
            depends_on: [],
        };
    }

    private _buildSerialCanvasSequence(tasks: any[]): any[] | null {
        if (!tasks || tasks.length <= 1) return null;

        const taskNames = new Set(tasks.map((t: any) => t.name));
        const remaining = tasks.slice();
        const completed = new Set<string>();
        const sequence: any[] = [];

        while (remaining.length > 0) {
            const runnable = remaining.filter((task: any) => {
                const deps = Array.isArray(task.depends_on) ? task.depends_on.filter(Boolean) : [];
                return deps.every((dep: string) => completed.has(dep) || !taskNames.has(dep));
            });

            if (runnable.length !== 1) return null;

            const next = runnable[0];
            sequence.push(next);
            completed.add(next.name);

            const index = remaining.findIndex((task: any) => task.name === next.name);
            if (index < 0) return null;
            remaining.splice(index, 1);
        }

        return sequence.length === tasks.length ? sequence : null;
    }

    public sanitizeProcessText(value: any): string {
        let text = `${value || ''}`;
        text = text.replace(/최종\s*JSON\s*파싱\s*실패로\s*구조화\s*출력을\s*한\s*번\s*재시도합니다\.?/gi, '구조화 결과를 정리하고 있습니다.');
        text = text.replace(/검사\s*엔진\s*모델\s*:\s*[^\n\r]+/gi, '검사 엔진 준비 완료');
        text = text.replace(/\bopenai\/gpt-[a-z0-9_.-]+/gi, '분석 모델');
        text = text.replace(/\bgpt-[a-z0-9_.-]+/gi, '분석 모델');
        const replacements: Array<[string, string]> = [
            ['OpenAI Codex CLI', '검사 엔진'],
            ['Codex CLI', '검사 엔진'],
            ['OpenAI Codex', '검사 엔진'],
            ['Codex', '검사 엔진'],
            ['codex', '검사 엔진'],
            ['코덱스', '검사 엔진'],
            ['LLM', '분석 모델'],
        ];
        for (const [before, after] of replacements) {
            text = text.split(before).join(after);
        }
        text = text.replace(/\n?\s*배치\s*요약\s*:[\s\S]*$/gi, '');
        text = text
            .split(/\r?\n/)
            .filter((line: string) => {
                const compact = line.trim().replace(/\s+/g, ' ');
                const copySetup = /^-?\s*카피\s*기준\s*확인\s*:/.test(compact);
                const emptyImageBatch = /^-?\s*이미지\s*후보\s*\d+\s*[-~]\s*\d+\s*:/.test(compact)
                    && /(없었습니다|확인되지|제외|판단되는 쌍은 없|없는 것으로)/.test(compact);
                return !copySetup && !emptyImageBatch;
            })
            .join('\n');
        text = text.replace(/\bno\s+findings\b/gi, '찾은 사항 없음');
        text = text.replace(/(^|[^A-Za-z0-9_])findings?/gi, '$1찾은 사항');
        return text.trim();
    }

    public getTaskDisplayName(task: any): string {
        const raw = typeof task === 'string' ? task : task?.name;
        const label = this.sanitizeProcessText(raw || '작업');
        return label || '작업';
    }

    public getTaskStepItems(task: any): any[] {
        const type = task?.type || '';
        const isDone = task?.status === 'done';
        const isRunning = task?.status === 'running';
        const active = isDone || isRunning;
        const pageRange = task?.page_start && task?.page_end ? `${task.page_start}~${task.page_end}p` : '';

        const step = (label: string, enabled: boolean = active, done: boolean = isDone) => ({
            label,
            status: done ? 'done' : enabled ? 'running' : 'pending',
        });

        if (type === 'parse_documents') {
            return [step('파일 확인'), step('텍스트 추출'), step('표/이미지 추출'), step('파싱 캐시')];
        }
        if (type === 'codex_exec') {
            return [step('요청 해석'), step('문서 근거 확인'), step('검사 수행'), step('결과 생성')];
        }
        if (type === 'codex_plan') {
            return [step('요청 해석'), step('검사 구간 설정'), step('검사 배치 구성')];
        }
        if (type === 'codex_batch') {
            const inspectionCheck = `${task?.inspection_check || ''}`;
            const taskText = `${task?.name || ''} ${task?.description || ''} ${task?.focus || ''}`;
            const isCopyImage = inspectionCheck === 'copy_check' && /이미지|도면|그림|그래프|사진|image|photo|drawing|figure/i.test(taskText);
            if (inspectionCheck === 'omission_check') {
                return [
                    step(pageRange ? `${pageRange} 근거 읽기` : '근거 읽기'),
                    step('체크리스트 유/무 판정'),
                    step('유/무 결과 생성'),
                    step('결과 반영'),
                ];
            }
            if (isCopyImage) {
                return [
                    step('이미지 후보 읽기'),
                    step('시각 후보 비교'),
                    step('카피 결과 생성'),
                    step('결과 반영'),
                ];
            }
            if (inspectionCheck === 'copy_check') {
                return [
                    step(pageRange ? `${pageRange} 본문 읽기` : '본문 읽기'),
                    step('본문/표 비교'),
                    step('카피 결과 생성'),
                    step('결과 반영'),
                ];
            }
            return [
                step(pageRange ? `${pageRange} 근거 읽기` : '근거 읽기'),
                step('근거 확인'),
                step('검사 결과 생성'),
                step('결과 반영'),
            ];
        }
        if (type === 'codex_final') {
            return [step('결과 병합'), step('중복 정리'), step('요약 생성')];
        }
        if (type === 'copy_check') {
            return [step('비교 문서 선택'), step('텍스트 유사도'), step('이미지 유사도'), step('결과 정리')];
        }
        if (type === 'typo_check' || type === 'typo_check_chunk') {
            return [
                step(pageRange ? `${pageRange} 텍스트 후보` : '텍스트 후보'),
                step('페이지 이미지 확인'),
                step('표/캡션 검토'),
                step('오탈자 병합'),
            ];
        }
        if (type === 'omission_check') {
            return [step('점검유형 판별'), step('체크리스트 로드'), step('문서 항목 대조'), step('누락표 생성')];
        }
        if (type === 'context_check') {
            return [step('기준 용어 추출'), step('페이지별 값 탐색'), step('불일치 판단'), step('결과 정리')];
        }
        if (type === 'consistency_check') {
            return [step('참조문서 분류'), step('계약서/착수계 추출'), step('관리대장 대조'), step('불일치 정리')];
        }
        if (type === 'instruction_check') {
            return [step('지침 항목 추출'), step('보고서 근거 확인'), step('유/무 판단'), step('결과 정리')];
        }
        if (type === 'summarize') {
            return [step('주요 페이지 선택'), step('내용 요약'), step('핵심 정보 정리')];
        }
        return [step(task?.description || '작업 준비')];
    }

    public getTaskStepClass(status: string): string {
        switch (status) {
            case 'done': return 'bg-emerald-50 text-emerald-600 border-emerald-100';
            case 'running': return 'bg-indigo-50 text-indigo-600 border-indigo-100';
            default: return 'bg-slate-50 text-slate-400 border-slate-100';
        }
    }

    public getTaskLatestDetail(task: any): string {
        const details = task?.details || [];
        if (details.length > 0) return this.sanitizeProcessText(details[details.length - 1]);
        if (task?.description) return this.sanitizeProcessText(task.description);
        if (task?.page_start && task?.page_end) return `${task.page_start}~${task.page_end}페이지 처리`;
        return '';
    }

    public getTaskStatusIcon(status: string): string {
        switch (status) {
            case 'running': return '◎';
            case 'done': return '✓';
            case 'error': return '✕';
            default: return '○';
        }
    }

    private async sendMessageSync(message: string) {
        if (this.isQuestionQuotaExceeded) return;
        this.agentStatus = 'executing';
        this.statusMessage = '에이전트가 문서를 검사하고 있습니다...';
        await this.service.render();
        this.scrollToBottom();

        const res: any = await wiz.call('chat', {
            session_id: this.sessionId,
            message: message,
        });
        const code = res.code;
        const data = res.data;

        if (code === 200 && data) {
            this.applyQuestionQuota(data.quota);
            this.processAgentResponse(data);
        } else {
            const errMsg = data?.message || data?.response || '알 수 없는 오류가 발생했습니다.';
            this.messages.push({
                role: 'system',
                content: `오류 (${code}): ${errMsg}`,
                timestamp: new Date().toISOString(),
            });
        }
    }

    private quotaNumber(value: any): number {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
    }

    private applyQuestionQuota(quota: any) {
        if (quota) {
            this.questionQuota = quota;
        }
    }

    public get isQuestionQuotaVisible(): boolean {
        return !!this.questionQuota && this.questionQuota.limited !== false;
    }

    public get isQuestionQuotaExceeded(): boolean {
        return this.isQuestionQuotaVisible && this.questionQuota.allowed === false;
    }

    public get questionQuotaText(): string {
        if (!this.isQuestionQuotaVisible) return '';
        const used = this.quotaNumber(this.questionQuota.used);
        const limit = this.quotaNumber(this.questionQuota.limit);
        const remaining = Math.max(0, this.quotaNumber(this.questionQuota.remaining));
        return `이 세션 질문 ${used}/${limit} · 남은 ${remaining}개`;
    }

    public get questionQuotaNotice(): string {
        if (!this.isQuestionQuotaExceeded) return '';
        return this.questionQuota?.message || '이 세션에서 보낼 수 있는 질문을 모두 사용했습니다.';
    }

    public canSendQuestion(): boolean {
        return !this.sending && !this.isQuestionQuotaExceeded;
    }

    private processAgentResponse(data: any) {
        // intent 저장
        this.lastIntent = data.intent || '';
        this.applyCopyImageStats(data.copy_image_stats, data.intent || '');

        // Agent 응답 추가
        this.messages.push({
            role: 'assistant',
            content: data.response,
            timestamp: new Date().toISOString(),
            tasks: data.tasks || [],
            intent: data.intent || '',
            inspection_checks: data.inspection_checks || [],
            excel_download_url: data.excel_download_url || '',
        });

        // 결과 분류 및 업데이트 (general intent는 우측 패널 미사용)
        if (data.intent && data.intent !== 'general' && data.intent !== 'error') {
            this.resetFindingsForChecks(this.completedInspectionChecksFromResponse(data));

            this.updateResults(data.results || []);
            this.ensureCompletedStateEvaluationRows(data);
            if (this.results.length === 0 && data.intent !== 'omission_check') {
                this.updateResults([this.buildNoFindingResult(data, data.intent)]);
            }
            this.showCompletedResultTab();
            if (this.stateEvaluationFindings.length === 0) {
                this.resultSubTab = 'all';
            }
        }

        // Agent 태스크 목록
        if (data.tasks) {
            this.agentTasks = data.tasks;
        }

        // 캔버스 상태 저장 (동기 방식)
        if (this.canvasTasks.length > 0 && data.intent && data.intent !== 'general') {
            this._saveCanvasState(data.intent);
        }
    }

    private _processAgentResults(data: any) {
        this.lastIntent = data.intent || '';
        this.applyCopyImageStats(data.copy_image_stats, data.intent || '');

        if (data.intent && data.intent !== 'general' && data.intent !== 'error') {
            this.resetFindingsForChecks(this.completedInspectionChecksFromResponse(data));

            this.updateResults(data.results || []);
            this.ensureCompletedStateEvaluationRows(data);
            if (this.results.length === 0 && data.intent !== 'omission_check') {
                this.updateResults([this.buildNoFindingResult(data, data.intent)]);
            }
            this.showCompletedResultTab();
            if (this.stateEvaluationFindings.length === 0) {
                this.resultSubTab = 'all';
            }
        }

        if (data.tasks) {
            this.agentTasks = data.tasks;
        }
    }

    // ========== File Add with Type Selection ==========

    private isInspectionIntent(intent: string): boolean {
        return [
            'inspect',
            'omission_check',
            'copy_check',
            'typo_check',
            'context_check',
            'instruction_check',
            'state_evaluation_check',
            'consistency_check',
        ].indexOf(String(intent || '').trim()) >= 0;
    }

    private normalizeInspectionChecks(checks: any): string[] {
        if (!checks) return [];
        if (typeof checks === 'string') checks = checks.split(/[,/|]\s*/);
        if (!Array.isArray(checks)) return [];
        const valid = [
            'omission_check',
            'copy_check',
            'typo_check',
            'context_check',
            'instruction_check',
            'state_evaluation_check',
            'consistency_check',
        ];
        const selected: string[] = [];
        for (const check of checks) {
            const value = String(check || '').trim();
            if (valid.indexOf(value) >= 0 && selected.indexOf(value) < 0) {
                selected.push(value);
            }
        }
        return valid.filter((check: string) => selected.indexOf(check) >= 0);
    }

    private inspectionChecksFromResults(results: any[]): string[] {
        const typeToCheck: any = {
            omission: 'omission_check',
            omission_summary: 'omission_check',
            copy: 'copy_check',
            text_copy: 'copy_check',
            image_copy: 'copy_check',
            clean: 'copy_check',
            copy_clean: 'copy_check',
            typo: 'typo_check',
            typo_clean: 'typo_check',
            typo_error: 'typo_check',
            context: 'context_check',
            context_check: 'context_check',
            context_summary: 'context_check',
            instruction: 'instruction_check',
            instruction_summary: 'instruction_check',
            state_evaluation: 'state_evaluation_check',
            state_evaluation_summary: 'state_evaluation_check',
            consistency: 'consistency_check',
            consistency_summary: 'consistency_check',
        };
        const checks: string[] = [];
        for (const row of results || []) {
            const type = String(row?.type || '').trim();
            let check = typeToCheck[type] || '';
            if ((type === 'consistency' || type === 'consistency_summary') && this.isStateEvaluationResult(row)) {
                check = 'state_evaluation_check';
            }
            if (!check && row?.copy_rate !== undefined && row?.copy_rate !== null && row?.copy_rate !== '') {
                check = 'copy_check';
            }
            if (check && checks.indexOf(check) < 0) checks.push(check);
        }
        return this.normalizeInspectionChecks(checks);
    }

    private completedInspectionChecksFromResponse(data: any): string[] {
        const intent = String(data?.intent || '').trim();
        if (intent && intent !== 'inspect' && this.isInspectionIntent(intent)) {
            return this.normalizeInspectionChecks([intent]);
        }

        let checks = this.inspectionChecksFromResults(data?.results || []);
        if (checks.length > 0) return checks;

        checks = this.normalizeInspectionChecks(data?.inspection_checks);
        if (checks.length > 0) return checks;

        return [];
    }

    private resetFindingsForChecks(checks: string[]) {
        checks = this.normalizeInspectionChecks(checks);
        if (checks.length === 0) return;

        if (checks.indexOf('omission_check') >= 0) {
            this.omissionFindings = [];
            this._omissionDisplaySequence = 0;
            this.omissionSummary = null;
        }
        if (checks.indexOf('copy_check') >= 0) this.copyFindings = [];
        if (checks.indexOf('typo_check') >= 0) this.typoFindings = [];
        if (checks.indexOf('context_check') >= 0) {
            this.contextFindings = [];
            this.contextSummary = null;
        }
        if (checks.indexOf('consistency_check') >= 0) {
            this.consistencyFindings = [];
            this.consistencySummary = null;
        }
        if (checks.indexOf('instruction_check') >= 0) {
            this.instructionFindings = [];
            this.instructionSummary = null;
        }
        if (checks.indexOf('state_evaluation_check') >= 0) {
            this.stateEvaluationFindings = [];
            this.stateEvaluationSummary = null;
        }
        this.infoResults = (this.infoResults || []).filter((item: any) => {
            const intent = String(item?.intent || '').trim();
            return checks.indexOf(intent) < 0;
        });
        this.results = [...this.copyFindings, ...this.typoFindings, ...this.omissionFindings, ...this.contextFindings, ...this.instructionFindings, ...this.stateEvaluationFindings, ...this.consistencyFindings, ...this.infoResults];
    }

    private completedInspectionIntent(data: any): string {
        const runtime = data?.runtime_state || {};
        const canvas = data?.canvas_state || {};
        let checks: string[] = [];
        for (const source of [
            runtime.completed_checks,
            runtime.requested_checks,
            canvas.inspection_checks,
            data?.inspection_checks,
            data?.session?.inspection_checks,
        ]) {
            checks = this.normalizeInspectionChecks(source);
            if (checks.length > 0) break;
        }
        if (checks.length === 1) return checks[0];

        const messages = Array.isArray(data?.messages) ? data.messages : this.messages || [];
        const candidates = [
            data?.intent,
            runtime.last_intent,
            canvas.lastIntent,
        ];
        for (let i = messages.length - 1; i >= 0; i--) {
            const msg = messages[i] || {};
            candidates.push(msg.intent);
            if (Array.isArray(msg.inspection_checks) && msg.inspection_checks.length === 1) {
                candidates.push(msg.inspection_checks[0]);
            }
            if (msg.role === 'user' && /상태평가|state_evaluation/i.test(String(msg.content || ''))) {
                candidates.push('state_evaluation_check');
            }
            if (msg.role === 'user' && /지침\s*검사|지침검사|지침\s*수행|지침\s*준수|기준자료\s*유\/?무|instruction_check/i.test(String(msg.content || ''))) {
                candidates.push('instruction_check');
            }
        }
        for (const intent of candidates) {
            const value = String(intent || '').trim();
            if (this.isInspectionIntent(value)) return value;
        }
        return checks.length > 0 ? 'inspect' : '';
    }

    private latestInspectionResponseText(data: any): string {
        const candidates: string[] = [];
        if (data?.response) candidates.push(data.response);

        const messages = Array.isArray(data?.messages) ? data.messages : this.messages || [];
        for (let i = messages.length - 1; i >= 0; i--) {
            const msg = messages[i] || {};
            if (msg.role === 'assistant' && msg.content) {
                candidates.push(msg.content);
                break;
            }
        }

        if (data?.runtime_state?.response_stream) candidates.push(data.runtime_state.response_stream);
        for (const candidate of candidates) {
            const text = this.sanitizeProcessText(candidate || '')
                .replace(/\n{3,}/g, '\n\n')
                .trim();
            if (text) return text;
        }
        return '';
    }

    private buildNoFindingResult(data: any, intent: string): any {
        const responseText = this.latestInspectionResponseText(data);
        const lines = responseText.split(/\n+/).map((line: string) => line.trim()).filter((line: string) => !!line);
        const defaultTitle = '검사 완료 — 발견 사항 없음';
        const defaultDescription = '이번 검사에서는 특이사항이 발견되지 않았습니다.';
        const firstLine = lines[0] || '';
        const title = firstLine && firstLine.length <= 90 ? firstLine : defaultTitle;
        const description = lines.length > 1
            ? lines.slice(1).join('\n')
            : (firstLine && firstLine !== title ? firstLine : defaultDescription);
        return {
            type: 'no_findings',
            title,
            description: description || defaultDescription,
            severity: 'info',
            intent,
        };
    }

    private isCompletedStateEvaluationInspection(data: any): boolean {
        return this.completedInspectionIntent(data) === 'state_evaluation_check';
    }

    private stateEvaluationLineMeta(label: string, detail: string): any {
        const text = `${label} ${detail}`;
        if (/종합결론|등급\s*일치/.test(text)) {
            return {
                item: '종합결론 등급 일치',
                title: label || '종합결론 등급 일치 확인',
                location: '제4장 종합결론 및 건의 > 4.1, 4.4, 4.5',
                rule: '제3장 안전등급 지정의 종합 상태점수 및 B등급',
                expected: '제3장 평가결과 7.81점, B등급',
                report_value: '종합결론 B등급 및 2025년 상반기 7.81 B등급',
                report_page: 28,
                guideline_page: 19,
                guideline_location: '제3장 제4절 시설물의 안전성평가 방법 및 안전등급 지정',
            };
        }
        if (/대상|시설물구분|종별|3종|건축물/.test(text)) {
            return {
                item: '평가 등급 기준 적용',
                title: label || '상태평가 대상 확인',
                location: '정기안전점검 결과표',
                rule: '건축물 3종 정기안전점검 상태평가 대상',
                expected: '건축물 / 3종 / 안전등급 B',
                report_value: '시설물구분 건축물, 종별 3종, 안전등급 B',
                report_page: 6,
                guideline_page: 74,
                guideline_location: '별표 9 안전점검등의 과업내용',
            };
        }
        if (/산식|재계산|종합\s*상태점수|7\.81|전차/.test(text)) {
            return {
                item: '상태평가 산정 근거',
                title: label || '상태평가 산식 재계산',
                location: '제3장 안전등급 지정 > 3.2 안전등급 평가 결과, 3.3 안전등급 변경',
                rule: '[(X * 60) + (Y * 20) + (Z * 20)] / 100 및 등급 경계',
                expected: '[(7.75*60)+(7.60*20)+(8.20*20)]/100 = 7.81, B등급',
                report_value: 'X=7.75, Y=7.60, Z=8.20, 종합 상태점수 7.81, B등급',
                report_page: 27,
                guideline_page: 18,
                guideline_location: '제3장 제3절 시설물의 상태평가 방법',
            };
        }
        if (/등급\s*기준|B등급|가중치|점수\s*기준/.test(text)) {
            return {
                item: '평가 등급 기준 적용',
                title: label || '상태평가 등급 기준 확인',
                location: '제3장 안전등급 지정 > 3.1 안전등급 평가 기준',
                rule: 'B등급 범위와 시설별 가중치 기준',
                expected: 'B등급 7점 이상~9점 미만, 주요시설 60% / 일반시설 20% / 부대시설 20%',
                report_value: '보고서의 B등급 범위 및 60/20/20 가중치 표기',
                report_page: 24,
                guideline_page: 18,
                guideline_location: '제3장 제3절 시설물의 상태평가 방법',
            };
        }
        if (/체크리스트|정기점검표|부분별|외관조사|X\s*=|Y\s*=|Z\s*=/.test(text)) {
            return {
                item: '상태평가 산정 근거',
                title: label || '상태평가 체크리스트 근거 확인',
                location: '제2장 현장조사 > 2.2.1 정기점검표, 2.2.2 부분별 점검결과, 2.2.3 주요 외관조사 사진',
                rule: '주요시설 X, 일반시설 Y, 부대시설 Z 산정 근거',
                expected: 'X=7.75, Y=7.60, Z=8.20',
                report_value: '주요시설 X=7.75, 일반시설 Y=7.60, 부대시설 Z=8.20',
                report_page: 19,
                guideline_page: 74,
                guideline_location: '별표 9 안전점검등의 과업내용',
            };
        }
        return {
            item: '상태평가 산정 근거',
            title: label || '상태평가 비교 확인',
            location: '',
            rule: '상태평가 기준',
            expected: '상태평가 기준값',
            report_value: '보고서 상태평가값',
            report_page: 1,
            guideline_page: 18,
            guideline_location: '제3장 제3절 시설물의 상태평가 방법',
        };
    }

    private firstReportViewerFile(): any {
        return (this.pdfFiles || []).find((file: any) => file?.type === 'report') || null;
    }

    private uploadedStateEvaluationGuidelineFile(): any {
        return (this.pdfFiles || []).find((file: any) => {
            const type = String(file?.type || '');
            const name = String(file?.filename || '').normalize('NFC');
            return type === 'evaluation_guideline'
                || /평가.?가이드|평가.?기준|평가.?지침|세부.?지침|상태평가|안전등급/.test(name);
        }) || null;
    }

    private builtinStateEvaluationGuidelineUrl(): string {
        return `/wiz/api/page.chatbot.room/serve_pdf?session_id=${encodeURIComponent(this.sessionId || '')}&file_index=${this.builtinStateEvaluationGuidelineIndex}&drive_file_id=${encodeURIComponent(this.builtinStateEvaluationGuidelineId)}`;
    }

    private stateEvaluationGuidelinePageFor(result: any, fallback: number = 18): number {
        const text = [
            result?.item,
            result?.title,
            result?.rule,
            result?.location,
            result?.description,
            result?.evidence,
        ].map((value: any) => String(value || '')).join(' ');
        if (/대상|정기점검표|체크리스트|외관조사|주요시설|일반시설|부대시설/.test(text)) return 74;
        if (/종합결론|안전등급 지정/.test(text)) return 19;
        return fallback;
    }

    private attachStateEvaluationGuidelineRef(result: any, meta: any = {}) {
        if (!result || result.ref_pdf_url) return;
        if (this.hasViewerFileIndex(result.ref_file_index) && this.findViewerFile(result.ref_file_index)) return;
        const uploaded = this.uploadedStateEvaluationGuidelineFile();
        const refPage = this.parseDocumentPage(meta.guideline_page || result.ref_page, this.stateEvaluationGuidelinePageFor(result));
        if (uploaded) {
            result.ref_file_index = uploaded.index;
            result.ref_filename = uploaded.filename;
            result.ref_file = uploaded.filename;
            result.ref_page = refPage;
            result.ref_location = meta.guideline_location || result.ref_location || '상태평가 기준 지침';
            result.ref_pdf_url = this.buildRawPdfUrl(uploaded.index);
            return;
        }
        result.ref_file_index = this.builtinStateEvaluationGuidelineIndex;
        result.ref_filename = this.builtinStateEvaluationGuidelineName;
        result.ref_file = this.builtinStateEvaluationGuidelineName;
        result.ref_page = refPage;
        result.ref_location = meta.guideline_location || result.ref_location || '상태평가 기준 지침';
        result.ref_pdf_url = this.builtinStateEvaluationGuidelineUrl();
    }

    private parsePageRangeFromText(text: string): any {
        const fileMatch = text.match(/파일\s*(\d+)/);
        const rangeMatch = text.match(/(?:p\.?|보고서)?\s*(\d+)\s*[~-]\s*(\d+)\s*(?:쪽|p)?|(\d+)\s*~\s*(\d+)\s*쪽/);
        const singleMatch = text.match(/(?:p\.?|보고서)\s*(\d+)\s*쪽|(\d+)쪽/);
        const parsed: any = {};
        if (fileMatch) parsed.file_index = Number(fileMatch[1]);
        if (rangeMatch) {
            parsed.page_start = Number(rangeMatch[1] || rangeMatch[3]);
            parsed.page_end = Number(rangeMatch[2] || rangeMatch[4]);
            parsed.page = parsed.page_start;
        } else if (singleMatch) {
            parsed.page = Number(singleMatch[1] || singleMatch[2]);
            parsed.page_start = parsed.page;
            parsed.page_end = parsed.page;
        }
        return parsed;
    }

    private buildStateEvaluationComparisonRows(data: any): any[] {
        if (!this.isCompletedStateEvaluationInspection(data)) return [];
        const responseText = this.latestInspectionResponseText(data);
        if (!responseText) return [];

        const rows: any[] = [];
        const lines = responseText
            .split(/\n+/)
            .map((line: string) => line.replace(/^[\s\-•]+/, '').trim())
            .filter((line: string) => !!line && line.indexOf(':') > 0);

        for (const line of lines) {
            if (!/상태평가|종합결론|안전등급|정기점검표|정기안전점검 결과표|X\s*=|Y\s*=|Z\s*=|7\.81|B등급/.test(line)) {
                continue;
            }
            const splitAt = line.indexOf(':');
            const label = line.slice(0, splitAt).trim();
            const detail = line.slice(splitAt + 1).trim();
            if (!detail) continue;
            const meta = this.stateEvaluationLineMeta(label, detail);
            const pageInfo = this.parsePageRangeFromText(detail);
            const reportFile = this.firstReportViewerFile();
            const reportPage = this.parseDocumentPage(pageInfo.page || meta.report_page, meta.report_page || 1);
            const row: any = {
                type: 'state_evaluation',
                title: meta.title,
                description: detail,
                severity: 'info',
                category: '상태평가 적정성',
                status: 'match',
                item: meta.item,
                rule: meta.rule,
                expected: meta.expected,
                ref_value: meta.expected,
                actual: meta.report_value,
                report_value: meta.report_value,
                location: meta.location,
                evidence: detail,
                evidence_source: meta.location || meta.rule,
                confidence: 0.95,
                file_index: pageInfo.file_index ?? reportFile?.index,
                filename: reportFile?.filename,
                page: reportPage,
                target_page: reportPage,
                page_start: pageInfo.page_start || reportPage,
                page_end: pageInfo.page_end || reportPage,
            };
            this.attachStateEvaluationGuidelineRef(row, meta);
            rows.push({
                ...row,
            });
        }
        return rows;
    }

    private ensureCompletedStateEvaluationRows(data: any): boolean {
        if (this.stateEvaluationFindings.length > 0) return false;
        const rows = this.buildStateEvaluationComparisonRows(data);
        if (rows.length === 0) return false;
        this.updateResults(rows);
        this.resultSubTab = 'state_evaluation';
        this.showCompletedResultTab();
        return true;
    }

    private showCompletedResultTab() {
        if (this.rightTab !== 'pdf') {
            this.rightTab = 'result';
            this.rightTabUserSelected = false;
        }
    }

    private ensureCompletedNoFindingResult(data: any) {
        if (this.results.length > 0) return;

        const runtime = data?.runtime_state || {};
        const canvas = data?.canvas_state || {};
        const status = this.effectiveSessionStatus(data?.session?.status || '', runtime, canvas);
        const completed = status === 'completed';
        if (!completed || runtime.agent_status === 'error') return;

        const intent = this.completedInspectionIntent(data);
        if (!this.isInspectionIntent(intent)) return;
        if (intent === 'omission_check') return;

        this.updateResults([this.buildNoFindingResult(data, intent)]);
        this.showCompletedResultTab();
    }

    private normalizeResultSubTab() {
        const hasByTab: any = {
            all: this.results.length > 0,
            excel: this.hasInspectionWorkbookSource(),
            copy: this.copyFindings.length > 0,
            typo: this.typoFindings.length > 0,
            omission: this.omissionFindings.length > 0,
            context: this.contextFindings.length > 0,
            instruction: this.instructionFindings.length > 0,
            state_evaluation: this.stateEvaluationFindings.length > 0,
            consistency: this.consistencyFindings.length > 0,
        };
        const focusedTab = this.firstAvailableResultSubTab(hasByTab);
        if (!hasByTab[this.resultSubTab]) {
            this.resultSubTab = focusedTab;
        }
    }

    private firstAvailableResultSubTab(hasByTab?: any): string {
        const available = hasByTab || {
            all: this.results.length > 0,
            excel: this.hasInspectionWorkbookSource(),
            copy: this.copyFindings.length > 0,
            typo: this.typoFindings.length > 0,
            omission: this.omissionFindings.length > 0,
            context: this.contextFindings.length > 0,
            instruction: this.instructionFindings.length > 0,
            state_evaluation: this.stateEvaluationFindings.length > 0,
            consistency: this.consistencyFindings.length > 0,
        };
        for (const tab of ['copy', 'typo', 'omission', 'context', 'instruction', 'state_evaluation', 'consistency', 'excel']) {
            if (available[tab]) return tab;
        }
        return 'all';
    }

    private limitForAllResultTab(items: any[]): any[] {
        const list = Array.isArray(items) ? items : [];
        if (this.resultSubTab !== 'all' || list.length <= this.allResultPreviewLimit) return list;
        return list.slice(0, this.allResultPreviewLimit);
    }

    public get renderedCopyFindings(): any[] {
        return this.limitForAllResultTab(this.copyFindings);
    }

    public get renderedContextFindings(): any[] {
        return this.limitForAllResultTab(this.contextFindings);
    }

    public get renderedConsistencyFindings(): any[] {
        return this.limitForAllResultTab(this.consistencyFindings);
    }

    public get renderedInstructionFindings(): any[] {
        return this.limitForAllResultTab(this.instructionFindings);
    }

    public get renderedStateEvaluationFindings(): any[] {
        return this.limitForAllResultTab(this.stateEvaluationFindings);
    }

    public get renderedInfoResults(): any[] {
        return this.limitForAllResultTab(this.infoResults);
    }

    public get inspectionFindingCount(): number {
        return this.copyFindings.length
            + this.typoFindings.length
            + this.omissionFindings.length
            + this.contextFindings.length
            + this.instructionFindings.length
            + this.stateEvaluationFindings.length
            + this.consistencyFindings.length;
    }

    public isAllTabPreviewTruncated(items: any[]): boolean {
        return this.resultSubTab === 'all' && Array.isArray(items) && items.length > this.allResultPreviewLimit;
    }

    public isAnyAllTabPreviewTruncated(): boolean {
        if (this.resultSubTab !== 'all') return false;
        return this.isAllTabPreviewTruncated(this.copyFindings)
            || this.isAllTabPreviewTruncated(this.displayedTypoFindings)
            || this.isAllTabPreviewTruncated(this.contextFindings)
            || this.isAllTabPreviewTruncated(this.instructionFindings)
            || this.isAllTabPreviewTruncated(this.stateEvaluationFindings)
            || this.isAllTabPreviewTruncated(this.consistencyFindings)
            || this.isAllTabPreviewTruncated(this.infoResults)
            || this.isOmissionSheetPreviewTruncated('basic')
            || this.isOmissionSheetPreviewTruncated('detail');
    }

    public async addFile() {
        await this.openDriveBrowser(this.driveBrowserFileType || 'reference');
    }

    public async openDriveBrowser(fileType: string = 'reference') {
        const normalizedType = fileType || 'reference';
        this.driveBrowsing = true;
        this.driveAddMode = 'drive';
        this.driveSelectionMode = this.isAppendixDriveFileTypeValue(normalizedType);
        this.driveSearchText = '';
        this.driveBrowserFileType = normalizedType;
        this.pendingFileType = this.driveBrowserFileType;
        const initialFolder = this.getDriveBrowserInitialFolder();
        this.driveBrowserCurrentFolder = initialFolder;
        this.driveBrowserBreadcrumb = [];
        this.selectedDriveFileIds = {};
        this.restoreDriveAddPanelWidth();
        this.clampDriveAddPanelWidthToLayout();
        this.clampChatPanelWidthToLayout();
        await this.loadDriveBrowserFolder(initialFolder);
    }

    public async closeDriveBrowser() {
        this.driveBrowsing = false;
        this.addingDriveFiles = false;
        this.addingDriveFileIds = {};
        this.driveAddMode = 'drive';
        this.driveSelectionMode = false;
        this.driveSearchText = '';
        this.selectedDriveFileIds = {};
        if (this.pendingFileType === this.driveBrowserFileType) {
            this.pendingFileType = '';
        }
        await this.service.render();
    }

    public async loadDriveBrowserFolder(folderId: string) {
        this.driveBrowserLoading = true;
        await this.service.render();
        try {
            const res: any = await wiz.call('drive_list', { folder_id: folderId });
            if (res.code === 200) {
                const data = res.data || {};
                this.driveBrowserFolders = data.folders || [];
                this.driveBrowserFiles = data.files || [];
                this.driveBrowserCurrentFolder = data.current_folder || '';
                this.driveBrowserBreadcrumb = data.breadcrumb || [];
                this.resetDriveBrowserSelection();
            }
        } catch (e) { }
        this.driveBrowserLoading = false;
        await this.service.render();
    }

    public async driveBrowseNavigate(folderId: string) {
        this.driveSearchText = '';
        await this.loadDriveBrowserFolder(folderId);
    }

    public async driveBrowseGoRoot() {
        this.driveSearchText = '';
        await this.loadDriveBrowserFolder('');
    }

    private getInspectionDriveFolderId(): string {
        return String(this.sessionData?.report_folder_id || '').trim();
    }

    private getDriveBrowserInitialFolder(): string {
        return this.getInspectionDriveFolderId();
    }

    public canDriveBrowseInspectionFolder(): boolean {
        const folderId = this.getInspectionDriveFolderId();
        return !!folderId && folderId !== String(this.driveBrowserCurrentFolder || '');
    }

    public async driveBrowseInspectionFolder() {
        const folderId = this.getInspectionDriveFolderId();
        if (!folderId) return;
        this.driveSearchText = '';
        await this.loadDriveBrowserFolder(folderId);
    }

    public canDriveBrowseUp(): boolean {
        return !!String(this.driveBrowserCurrentFolder || '');
    }

    private getDriveBrowserParentFolderId(): string {
        const breadcrumb = this.driveBrowserBreadcrumb || [];
        if (breadcrumb.length >= 2) {
            return String(breadcrumb[breadcrumb.length - 2]?.id || '');
        }
        return '';
    }

    public async driveBrowseUp() {
        if (!this.canDriveBrowseUp()) return;
        this.driveSearchText = '';
        await this.loadDriveBrowserFolder(this.getDriveBrowserParentFolderId());
    }

    public async setDriveAddMode(mode: string) {
        this.driveAddMode = mode === 'upload' ? 'upload' : 'drive';
        if (this.driveAddMode === 'upload') {
            this.driveSelectionMode = false;
            this.selectedDriveFileIds = {};
        } else if (this.isAppendixDriveFileType()) {
            this.driveSelectionMode = true;
            this.resetDriveBrowserSelection();
        }
        await this.service.render();
    }

    public async setDriveFileType(type: string) {
        this.driveBrowserFileType = type || 'reference';
        this.pendingFileType = this.driveBrowserFileType;
        if (this.driveAddMode === 'drive' && this.isAppendixDriveFileType()) {
            this.driveSelectionMode = true;
            this.resetDriveBrowserSelection();
        }
        await this.service.render();
    }

    public async startUploadForCurrentType() {
        this.pendingFileType = this.driveBrowserFileType || 'additional';
        await this.service.render();
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.accept = '.pdf,.hwp,.hwpx,.xlsx,.xlsm';
        input.onchange = (event: any) => this.onFileSelected(event);
        input.click();
    }

    public get filteredDriveBrowserFolders(): any[] {
        const query = this.normalizeSearchText(this.driveSearchText);
        if (!query) return this.driveBrowserFolders || [];
        return (this.driveBrowserFolders || []).filter((folder: any) =>
            this.normalizeSearchText(folder?.name || '').indexOf(query) >= 0
        );
    }

    public get filteredDriveBrowserFiles(): any[] {
        const query = this.normalizeSearchText(this.driveSearchText);
        if (!query) return this.driveBrowserFiles || [];
        return (this.driveBrowserFiles || []).filter((file: any) =>
            this.normalizeSearchText(file?.name || file?.filename || '').indexOf(query) >= 0
        );
    }

    private normalizeSearchText(value: string): string {
        return String(value || '').trim().toLowerCase();
    }

    private isAppendixDriveFileTypeValue(type: any): boolean {
        return String(type || '').trim() === '부록';
    }

    public isAppendixDriveFileType(): boolean {
        return this.isAppendixDriveFileTypeValue(this.driveBrowserFileType);
    }

    private isAppendixLikeText(value: any): boolean {
        return /부록|부록.?자료|첨부|별첨|appendix/i.test(String(value || ''));
    }

    private isCurrentDriveFolderAppendixLike(): boolean {
        const breadcrumb = this.driveBrowserBreadcrumb || [];
        const current = breadcrumb.length > 0 ? breadcrumb[breadcrumb.length - 1] : null;
        return this.isAppendixLikeText(current?.name);
    }

    private inferDriveFileType(file: any): string {
        const explicitType = String(file?.recommended_type || file?.file_type || file?.type || file?.role || '').toLowerCase();
        const roleMap: any = {
            report: 'report',
            '보고서': 'report',
            reference: 'reference',
            previous: 'reference',
            '전차': 'reference',
            '전차보고서': 'reference',
            proposal: 'proposal',
            '제안서': 'proposal',
            presentation: 'presentation',
            '발표자료': 'presentation',
            appendix: '부록',
            '부록': '부록',
            '부록자료': '부록',
            '첨부': '부록',
            '별첨': '부록',
            rfp: 'rfp',
            '제안요청서': 'rfp',
            evaluation_guideline: 'evaluation_guideline',
            '평가가이드': 'evaluation_guideline',
            '평가가이드라인': 'evaluation_guideline',
            contract: 'contract',
            '계약서': 'contract',
            kickoff: 'kickoff',
            '착수계': 'kickoff',
            ledger: 'ledger',
            '관리대장': 'ledger',
            other: 'additional',
            '기타': 'additional',
            additional: 'additional',
        };
        const mappedRole = roleMap[explicitType];
        const name = String(file?.name || file?.filename || '').toLowerCase();
        if (
            mappedRole === '부록'
            || this.isAppendixLikeText(file?.source_folder?.name)
            || this.isCurrentDriveFolderAppendixLike()
            || /부록|부록.?자료|첨부|별첨|appendix/.test(name)
        ) {
            return '부록';
        }
        if (mappedRole) return mappedRole;
        if (/제안요청|rfp/.test(name)) return 'rfp';
        if (/평가.?가이드|평가.?기준|평가.?지침/.test(name)) return 'evaluation_guideline';
        if (/제안서/.test(name)) return 'proposal';
        if (/발표|pt|ppt/.test(name)) return 'presentation';
        if (/계약/.test(name)) return 'contract';
        if (/착수/.test(name)) return 'kickoff';
        if (/관리.?대장|대장/.test(name)) return 'ledger';
        if (/전차|전년도|이전|참조/.test(name)) return 'reference';
        if (/보고서|점검|진단|검토/.test(name)) return 'report';
        return '';
    }

    public isMissingDriveFile(file: any): boolean {
        return !!file && (file.missing_on_disk === true || file.disk_exists === false || file.downloadable === false);
    }

    public isInspectableDriveFile(file: any): boolean {
        if (this.isMissingDriveFile(file)) return false;
        const name = String(file?.name || file?.filename || '').toLowerCase();
        return name.endsWith('.pdf') || name.endsWith('.hwp') || name.endsWith('.hwpx') || name.endsWith('.xlsx') || name.endsWith('.xlsm');
    }

    public get driveInspectableCount(): number {
        return this.driveBrowserFiles.filter((f: any) => this.canAddDriveFile(f)).length;
    }

    public get driveSelectedCount(): number {
        return this.driveBrowserFiles.filter((f: any) => this.canAddDriveFile(f) && this.isDriveFileSelected(f)).length;
    }

    private resetDriveBrowserSelection() {
        this.selectedDriveFileIds = {};
        if (!this.driveSelectionMode) return;
        const selectableFiles = this.getSelectableDriveFiles();
        const appendixFiles = this.isAppendixDriveFileType()
            ? selectableFiles.filter((file: any) => this.isDriveAppendixCandidate(file))
            : [];
        const defaultFiles = appendixFiles.length > 0 ? appendixFiles : selectableFiles;
        for (const file of defaultFiles) {
            if (file?.id) {
                this.selectedDriveFileIds[file.id] = true;
            }
        }
    }

    private getSelectableDriveFiles(): any[] {
        return (this.driveBrowserFiles || []).filter((file: any) => this.canAddDriveFile(file));
    }

    public shouldShowDriveFileCheckbox(file: any): boolean {
        return this.driveSelectionMode && this.canAddDriveFile(file);
    }

    public isDriveFileSelected(file: any): boolean {
        if (!file?.id) return false;
        return !!this.selectedDriveFileIds[file.id];
    }

    public areAllDriveFilesSelected(): boolean {
        const files = this.getSelectableDriveFiles();
        return files.length > 0 && files.every((file: any) => this.isDriveFileSelected(file));
    }

    public async toggleAllDriveFiles(event: Event) {
        const target = event.target as HTMLInputElement;
        const checked = !!target.checked;
        for (const file of this.getSelectableDriveFiles()) {
            if (file?.id) {
                this.selectedDriveFileIds[file.id] = checked;
            }
        }
        await this.service.render();
    }

    public async toggleDriveFile(file: any, event: Event) {
        const target = event.target as HTMLInputElement;
        if (file?.id) {
            this.selectedDriveFileIds[file.id] = !!target.checked;
        }
        await this.service.render();
    }

    public async toggleDriveSelectionMode() {
        this.driveSelectionMode = !this.driveSelectionMode;
        this.resetDriveBrowserSelection();
        await this.service.render();
    }

    public isDriveFileInSession(file: any): boolean {
        const driveFileId = String(file?.id || '');
        if (!driveFileId) return false;
        return (this.sessionData?.files || []).some((item: any) => String(item?.drive_file_id || '') === driveFileId);
    }

    public canAddDriveFile(file: any): boolean {
        return !!file?.id && this.isInspectableDriveFile(file) && !this.isDriveFileInSession(file);
    }

    public isDriveFileAdding(file: any): boolean {
        return !!file?.id && !!this.addingDriveFileIds[file.id];
    }

    public getDriveFileStatusLabel(file: any): string {
        if (this.isMissingDriveFile(file)) return '파일 없음';
        if (!this.isInspectableDriveFile(file)) return 'PDF/HWP/HWPX/Excel만 가능';
        if (this.isDriveFileInSession(file)) return '추가됨';
        const recommendedType = this.getDriveRecommendedFileType(file);
        if (recommendedType && recommendedType !== this.driveBrowserFileType) {
            return `추천 ${this.getFileTypeShort(recommendedType)}`;
        }
        return '';
    }

    public getDriveAddButtonLabel(file: any): string {
        if (this.isDriveFileAdding(file)) return '추가 중...';
        if (this.isDriveFileInSession(file)) return '추가됨';
        if (this.isAppendixDriveFileType()) return '부록 추가';
        const recommendedType = this.getDriveRecommendedFileType(file);
        return `${this.getFileTypeShort(recommendedType || this.driveBrowserFileType || 'reference')} 추가`;
    }

    public getDriveRecommendedFileType(file: any): string {
        return this.inferDriveFileType(file) || this.driveBrowserFileType || 'reference';
    }

    public isDriveAppendixCandidate(file: any): boolean {
        return this.inferDriveFileType(file) === '부록';
    }

    public async addSingleDriveFile(file: any, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.canAddDriveFile(file) || this.isDriveFileAdding(file)) return;
        await this.addDriveFilesFromPicker([file], false);
    }

    public formatDriveFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    }

    private async showMissingDriveFiles(files: any[]) {
        const firstName = files[0]?.name || '선택한 파일';
        const suffix = files.length > 1 ? ` 외 ${files.length - 1}개` : '';
        await this.service.modal.show({
            title: '원본 파일 없음',
            message: `${firstName}${suffix}의 원본 파일이 서버 디스크에 없습니다. 파일을 다시 업로드해주세요.`,
            action: '확인',
            cancel: false,
            status: 'warning',
        });
    }

    public async addSelectedDriveFiles() {
        if (this.addingDriveFiles) return;
        const selectedFiles = this.driveBrowserFiles.filter((f: any) =>
            this.canAddDriveFile(f) && this.isDriveFileSelected(f)
        );
        if (selectedFiles.length === 0) {
            await this.service.modal.error('추가할 Drive 파일을 선택해주세요.');
            return;
        }
        await this.addDriveFilesFromPicker(selectedFiles, true);
    }

    private async addDriveFilesFromPicker(selectedFiles: any[], bulk: boolean) {
        const missingFiles = selectedFiles.filter((f: any) => this.isMissingDriveFile(f));
        if (missingFiles.length > 0) {
            await this.showMissingDriveFiles(missingFiles);
            return;
        }

        this.addingDriveFiles = bulk;
        for (const file of selectedFiles || []) {
            if (file?.id) this.addingDriveFileIds[file.id] = true;
        }
        await this.service.render();

        try {
            const requestedType = !bulk && selectedFiles.length === 1
                ? (
                    this.isAppendixDriveFileType()
                        ? '부록'
                        : (this.getDriveRecommendedFileType(selectedFiles[0]) || this.driveBrowserFileType || this.pendingFileType || 'reference')
                )
                : (this.driveBrowserFileType || this.pendingFileType || 'reference');
            const res: any = await wiz.call('add_drive_files', {
                session_id: this.sessionId,
                file_type: requestedType,
                drive_file_ids: JSON.stringify(selectedFiles.map((f: any) => f.id)),
            });
            if (res.code === 200 && res.data) {
                const addedCount = res.data.added || selectedFiles.length;
                const roleSummary = this.formatAddedFileRoleSummary(
                    res.data.role_counts,
                    requestedType,
                    addedCount,
                );
                this.messages.push({
                    role: 'system',
                    content: `${roleSummary} 파일이 Drive에서 추가되었습니다.`,
                    timestamp: new Date().toISOString(),
                });
                if (res.data.session) {
                    this.sessionData = res.data.session;
                    this.refreshViewerFiles();
                } else {
                    await this.loadSession();
                }
                this.pendingFileType = this.driveBrowserFileType || '';
                this.driveSelectionMode = false;
                this.selectedDriveFileIds = {};
            } else {
                await this.service.modal.error(res.data?.message || 'Drive 파일 추가에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('Drive 파일 추가에 실패했습니다.');
        }

        this.addingDriveFiles = false;
        for (const file of selectedFiles || []) {
            if (file?.id) delete this.addingDriveFileIds[file.id];
        }
        await this.service.render();
        this.scrollToBottom();
    }

    public getDriveBulkAddButtonLabel(): string {
        if (this.addingDriveFiles) return '추가 중...';
        return `${this.getFileTypeShort(this.driveBrowserFileType || 'reference')} ${this.driveSelectedCount}개 추가`;
    }

    public async onFileSelected(event: any) {
        const files = event.target.files;
        if (!files || files.length === 0) return;
        const fileType = this.pendingFileType || this.driveBrowserFileType || 'additional';

        const formData = new FormData();
        formData.append('session_id', this.sessionId);
        formData.append('file_type', fileType);
        for (let i = 0; i < files.length; i++) {
            formData.append('file[]', files[i]);
        }

        this.sending = true;
        await this.service.render();

        try {
            const action = `add_files?session_id=${encodeURIComponent(this.sessionId || '')}&file_type=${encodeURIComponent(fileType || 'additional')}`;
            const res: any = await wiz.call(action, formData, { processData: false, contentType: false });
            const code = res.code;
            const data = res.data;
            if (code === 200 && data) {
                const addedCount = data.added || files.length;
                const roleSummary = this.formatAddedFileRoleSummary(
                    data.role_counts,
                    fileType,
                    addedCount,
                );
                this.messages.push({
                    role: 'system',
                    content: `${roleSummary} 파일이 추가되었습니다.`,
                    timestamp: new Date().toISOString(),
                });
                if (data.session) {
                    this.sessionData = data.session;
                    this.refreshViewerFiles();
                }
            } else {
                await this.service.modal.error(data?.message || '파일 추가에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('파일 추가에 실패했습니다.');
        }

        this.pendingFileType = this.driveBrowsing ? (this.driveBrowserFileType || '') : '';
        this.sending = false;
        event.target.value = '';
        await this.service.render();
        this.scrollToBottom();
    }

    private sessionFileIndexKey(file: any): string {
        if (!file || file.index === undefined || file.index === null) return '';
        return String(file.index);
    }

    public isDeletableSessionFile(file: any): boolean {
        return !!this.sessionFileIndexKey(file);
    }

    public isDeletingSessionFile(file: any): boolean {
        const key = this.sessionFileIndexKey(file);
        return !!key && !!this.deletingFileIndexes[key];
    }

    private clearViewerIfSessionFileDeleted(file: any) {
        const key = this.normalizeViewerFileIndex(this.sessionFileIndexKey(file));
        if (!key) return;

        const selectedKey = this.normalizeViewerFileIndex(this.selectedPdfFileIndex);
        const urlKey = this.normalizeViewerFileIndex(this.getUrlParam(this.pdfUrl, 'file_index'));
        const compareUsesFile = [this.compareLeft, this.compareRight].some((pane: any) => {
            const paneKey = this.normalizeViewerFileIndex(
                pane?.file_index || this.getUrlParam(pane?.source_url || pane?.pdf_url || '', 'file_index')
            );
            return paneKey === key;
        });
        if (selectedKey !== key && urlKey !== key && !compareUsesFile) return;

        this.compareMode = false;
        this.compareLeft = null;
        this.compareRight = null;
        this.pdfUrl = '';
        this.pdfImageUrl = '';
        this.pdfFileName = '';
        this.selectedPdfFileIndex = '';
        this.pdfPage = 1;
        this.viewerMode = '';
        this.viewerTotalPages = 0;
        this.viewerErrorMessage = '';
        this.viewerHighlights = [];
        this.activeViewerHighlight = null;
        this.setViewerHighlightLayerVisible(false);
    }

    public async deleteSessionFile(file: any, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.isDeletableSessionFile(file)) {
            await this.service.modal.error('삭제할 파일 정보를 확인할 수 없습니다.');
            return;
        }

        const key = this.sessionFileIndexKey(file);
        if (!key || this.isDeletingSessionFile(file)) return;

        const ok = await this.service.modal.show({
            title: '자료 삭제',
            message: `${this.getFileTypeLabel(file.type)} "${file.filename}" 파일을 세션에서 삭제하시겠습니까?`,
            action: '삭제',
            status: 'error',
        });
        if (!ok) return;

        this.deletingFileIndexes[key] = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('delete_file', {
                session_id: this.sessionId,
                file_index: key,
            });
            if (res.code === 200 && res.data) {
                if (res.data.session) {
                    this.sessionData = res.data.session;
                    this.refreshViewerFiles();
                } else {
                    await this.loadSession();
                }
                this.clearViewerIfSessionFileDeleted(file);
                this.messages.push({
                    role: 'system',
                    content: `${this.getFileTypeLabel(file.type)} "${file.filename}" 파일이 삭제되었습니다.`,
                    timestamp: new Date().toISOString(),
                });
            } else {
                await this.service.modal.error(res.data?.message || '파일 삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('파일 삭제에 실패했습니다.');
        }

        delete this.deletingFileIndexes[key];
        await this.service.render();
    }

    public isDeletingFileTypeGroup(group: any): boolean {
        return (group?.files || []).some((file: any) => this.isDeletingSessionFile(file));
    }

    public async deleteSessionFileTypeGroup(group: any, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const fileType = this.normalizeSessionFileType(group?.type);
        const files = this.getFilesByType(fileType).filter((file: any) => this.isDeletableSessionFile(file));
        if (!fileType || files.length === 0) {
            await this.service.modal.error('삭제할 자료를 찾을 수 없습니다.');
            return;
        }
        if (this.isDeletingFileTypeGroup({ files })) return;

        const label = this.getFileTypeLabel(fileType);
        const ok = await this.service.modal.show({
            title: '역할별 자료 삭제',
            message: `${label} 역할의 파일 ${files.length}개를 세션에서 삭제하시겠습니까?`,
            action: '삭제',
            status: 'error',
        });
        if (!ok) return;

        for (const file of files) {
            const key = this.sessionFileIndexKey(file);
            if (key) this.deletingFileIndexes[key] = true;
        }
        await this.service.render();

        try {
            const res: any = await wiz.call('delete_files_by_type', {
                session_id: this.sessionId,
                file_type: fileType,
            });
            if (res.code === 200 && res.data) {
                if (res.data.session) {
                    this.sessionData = res.data.session;
                    this.refreshViewerFiles();
                } else {
                    await this.loadSession();
                }
                for (const file of files) {
                    this.clearViewerIfSessionFileDeleted(file);
                }
                const deletedCount = res.data.deleted_count || files.length;
                this.messages.push({
                    role: 'system',
                    content: `${label} ${deletedCount}개 파일이 삭제되었습니다.`,
                    timestamp: new Date().toISOString(),
                });
            } else {
                await this.service.modal.error(res.data?.message || '역할별 자료 삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('역할별 자료 삭제에 실패했습니다.');
        }

        for (const file of files) {
            const key = this.sessionFileIndexKey(file);
            if (key) delete this.deletingFileIndexes[key];
        }
        await this.service.render();
    }

    public onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    public scrollToBottom() {
        setTimeout(() => {
            if (this.chatContainer?.nativeElement) {
                this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
            }
        }, 100);
    }

    private buildInitialInspectionGuide(reportCount: number, referenceCount: number): string {
        const fileSummary = referenceCount > 0
            ? `보고서 ${reportCount}개, 전차보고서 ${referenceCount}개가 준비되었습니다.`
            : `${this.sessionData?.files?.length || 0}개의 문서가 준비되었습니다.`;
        return [
            '## 검사 가이드',
            `- ${fileSummary}`,
            '- 기본 방침: 보고서 본문 근거를 우선 확인하고, 지침/제안요청서/계약서/착수계/관리대장은 기준 문서로 대조합니다.',
            '- 결과 형식: 누락검사는 기본검토/상세검토 항목을 시트형 표로 정리하고, 유/무 및 비고 근거를 함께 표시합니다.',
            '- 요청 예시: "제안요청서를 기준으로 발표자료 평가표, 조견표, 강점/약점을 정리해줘"',
            '- 시작: "검사 시작" 또는 "누락사항 검사"를 입력하세요.',
        ].join('\n');
    }

    // ========== File Type Helpers ==========

    private normalizeSessionFileType(type: any): string {
        const text = String(type || '').trim();
        const compact = text.toLowerCase().replace(/[\s_-]+/g, '');
        const aliases: any = {
            report: 'report',
            '보고서': 'report',
            reference: 'reference',
            previous: 'reference',
            '전차': 'reference',
            '전차보고서': 'reference',
            proposal: 'proposal',
            '제안서': 'proposal',
            presentation: 'presentation',
            '발표자료': 'presentation',
            appendix: '부록',
            '부록': '부록',
            '부록자료': '부록',
            '첨부': '부록',
            '별첨': '부록',
            additional: 'additional',
            other: 'additional',
            '기타': 'additional',
            rfp: 'rfp',
            '제안요청서': 'rfp',
            evaluationguideline: 'evaluation_guideline',
            '평가가이드': 'evaluation_guideline',
            '평가가이드라인': 'evaluation_guideline',
            contract: 'contract',
            '계약서': 'contract',
            kickoff: 'kickoff',
            '착수계': 'kickoff',
            ledger: 'ledger',
            '관리대장': 'ledger',
        };
        return aliases[text] || aliases[compact] || text || 'additional';
    }

    public getFilesByType(type: string): any[] {
        const normalizedType = this.normalizeSessionFileType(type);
        return (this.sessionData?.files || []).filter((f: any) =>
            this.normalizeSessionFileType(f?.type) === normalizedType
        );
    }

    public getDeletableFileTypeGroups(): any[] {
        const grouped: any = {};
        for (const file of this.sessionData?.files || []) {
            if (!this.isDeletableSessionFile(file)) continue;
            const type = this.normalizeSessionFileType(file?.type);
            if (!grouped[type]) {
                grouped[type] = { type, files: [] };
            }
            grouped[type].files.push(file);
        }

        const order = this.driveFileTypeOptions.map((item: any) => this.normalizeSessionFileType(item.type));
        return Object.keys(grouped)
            .map((type: string) => ({
                type,
                label: this.getFileTypeLabel(type),
                count: grouped[type].files.length,
                files: grouped[type].files,
            }))
            .filter((group: any) => group.count > 1)
            .sort((a: any, b: any) => {
                const ai = order.indexOf(a.type);
                const bi = order.indexOf(b.type);
                if (ai < 0 && bi < 0) return a.label.localeCompare(b.label);
                if (ai < 0) return 1;
                if (bi < 0) return -1;
                return ai - bi;
            });
    }

    private formatAddedFileRoleSummary(roleCounts: any, fallbackType: string, fallbackCount: number): string {
        const counts = roleCounts && typeof roleCounts === 'object' ? roleCounts : {};
        const order = this.driveFileTypeOptions.map((item: any) => item.type);
        const types = Object.keys(counts)
            .filter((type: string) => Number(counts[type] || 0) > 0)
            .sort((a: string, b: string) => {
                const ai = order.indexOf(a);
                const bi = order.indexOf(b);
                if (ai < 0 && bi < 0) return a.localeCompare(b);
                if (ai < 0) return 1;
                if (bi < 0) return -1;
                return ai - bi;
            });
        if (types.length === 0) {
            return `${this.getFileTypeLabel(fallbackType || 'additional')} ${fallbackCount || 0}개`;
        }
        return types
            .map((type: string) => `${this.getFileTypeLabel(type)} ${Number(counts[type] || 0)}개`)
            .join(', ');
    }

    public getFileTypeLabel(type: string): string {
        switch (type) {
            case 'report': return '보고서';
            case 'proposal': return '제안서';
            case 'presentation': return '발표자료';
            case 'appendix':
            case '부록': return '부록';
            case 'rfp': return '제안요청서';
            case 'evaluation_guideline': return '평가 가이드라인';
            case 'reference': return '전차보고서';
            case 'kickoff': return '착수계';
            case 'contract': return '계약서';
            case 'ledger': return '관리대장';
            case 'additional': return '추가파일';
            default: return type;
        }
    }

    public getFileTypeShort(type: string): string {
        switch (type) {
            case 'report': return '보고서';
            case 'proposal': return '제안서';
            case 'presentation': return '발표';
            case 'appendix':
            case '부록': return '부록';
            case 'rfp': return 'RFP';
            case 'evaluation_guideline': return '평가';
            case 'reference': return '전차';
            case 'kickoff': return '착수계';
            case 'contract': return '계약서';
            case 'ledger': return '관리대장';
            case 'additional': return '추가';
            default: return type;
        }
    }

    public getFileTypeBadgeClass(type: string): string {
        switch (type) {
            case 'report': return 'bg-blue-50 text-blue-600 border-blue-200';
            case 'proposal': return 'bg-cyan-50 text-cyan-700 border-cyan-200';
            case 'presentation': return 'bg-sky-50 text-sky-700 border-sky-200';
            case 'appendix':
            case '부록': return 'bg-yellow-50 text-yellow-700 border-yellow-200';
            case 'rfp': return 'bg-rose-50 text-rose-700 border-rose-200';
            case 'evaluation_guideline': return 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200';
            case 'reference': return 'bg-amber-50 text-amber-600 border-amber-200';
            case 'kickoff': return 'bg-green-50 text-green-600 border-green-200';
            case 'contract': return 'bg-purple-50 text-purple-600 border-purple-200';
            case 'ledger': return 'bg-teal-50 text-teal-600 border-teal-200';
            default: return 'bg-zinc-50 text-zinc-500 border-zinc-200';
        }
    }

    public getFileTypeBadgeFullClass(type: string): string {
        return [
            'file-type-badge',
            this.getFileTypeBadgeClass(type),
        ].join(' ');
    }

    public getFileTypeColor(type: string, part: 'text' | 'border' | 'background'): string {
        const palette: any = {
            report: { text: '#1d4ed8', border: '#93c5fd', background: '#eff6ff' },
            proposal: { text: '#0e7490', border: '#a5f3fc', background: '#ecfeff' },
            presentation: { text: '#0369a1', border: '#bae6fd', background: '#f0f9ff' },
            appendix: { text: '#b7791f', border: '#f6d365', background: '#fffbeb' },
            '부록': { text: '#b7791f', border: '#f6d365', background: '#fffbeb' },
            rfp: { text: '#be123c', border: '#fecdd3', background: '#fff1f2' },
            evaluation_guideline: { text: '#a21caf', border: '#f5d0fe', background: '#fdf4ff' },
            reference: { text: '#b45309', border: '#fcd34d', background: '#fffbeb' },
            contract: { text: '#7c3aed', border: '#c4b5fd', background: '#f5f3ff' },
            kickoff: { text: '#047857', border: '#86efac', background: '#ecfdf5' },
            ledger: { text: '#0f766e', border: '#5eead4', background: '#f0fdfa' },
            additional: { text: '#52525b', border: '#d4d4d8', background: '#fafafa' },
        };
        return (palette[type] || palette.additional)[part];
    }

    public getReferencePdfFiles(): any[] {
        return this.pdfFiles.filter((f: any) => f.type === 'reference');
    }

    public getReportPdfFiles(): any[] {
        return this.pdfFiles.filter((f: any) => ['report', 'proposal', 'presentation'].includes(f.type) || (!f.type || f.type === 'additional'));
    }

    public getSupportingPdfFiles(): any[] {
        return this.pdfFiles.filter((f: any) =>
            !['report', 'proposal', 'presentation', 'reference', 'additional'].includes(f.type)
        );
    }

    public getViewerFileExt(file: any): string {
        const name = String(file?.filename || '').toLowerCase();
        const dot = name.lastIndexOf('.');
        return dot >= 0 ? name.slice(dot + 1) : '';
    }

    public getViewerFileLabel(file: any): string {
        const ext = this.getViewerFileExt(file).toUpperCase();
        const filename = String(file?.filename || '').normalize('NFC');
        return `${ext || '문서'} · ${filename}`;
    }

    private isViewerDocument(file: any): boolean {
        const ext = this.getViewerFileExt(file);
        return ext === 'pdf' || ext === 'hwp' || ext === 'hwpx';
    }

    private isHwpViewerFile(file: any): boolean {
        const ext = this.getViewerFileExt(file);
        return ext === 'hwp' || ext === 'hwpx';
    }

    private refreshViewerFiles() {
        this.pdfFiles = (this.sessionData?.files || []).filter((f: any) => this.isViewerDocument(f));
    }

    private normalizeViewerFileIndex(fileIndex: any): string {
        if (fileIndex === null || fileIndex === undefined) return '';
        const value = String(fileIndex).trim();
        if (!value || value === 'null' || value === 'undefined' || value === 'NaN') return '';
        const idx = Number(value);
        if (!isFinite(idx) || Math.floor(idx) !== idx) return '';
        return String(idx);
    }

    private hasViewerFileIndex(fileIndex: any): boolean {
        return !!this.normalizeViewerFileIndex(fileIndex);
    }

    private findViewerFile(fileIndex: any): any {
        const normalized = this.normalizeViewerFileIndex(fileIndex);
        if (!normalized) return null;
        const idx = Number(normalized);
        if (isNaN(idx)) return null;
        return this.pdfFiles.find((f: any) => Number(f.index) === idx) || null;
    }

    private buildHighlightedPdfUrl(fileIndex: number | string): string {
        return `/wiz/api/page.chatbot.room/serve_highlighted_pdf?session_id=${encodeURIComponent(this.sessionId)}&file_index=${encodeURIComponent(String(fileIndex))}`;
    }

    private buildRawPdfUrl(fileIndex: number | string): string {
        return `/wiz/api/page.chatbot.room/serve_pdf?session_id=${encodeURIComponent(this.sessionId)}&file_index=${encodeURIComponent(String(fileIndex))}`;
    }

    private parseDocumentPage(value: any, fallback: number = 0): number {
        const direct = Math.floor(Number(value));
        if (isFinite(direct) && direct > 0) return direct;

        const text = String(value ?? '').trim();
        if (!text) return fallback;

        const patterns = [
            /(?:page|pg|p|쪽|페이지)\s*[:.]?\s*(\d+(?:\.\d+)?)/i,
            /(\d+(?:\.\d+)?)\s*(?:p|쪽|페이지|page|pg)/i,
            /(\d+(?:\.\d+)?)/,
        ];
        for (const pattern of patterns) {
            const match = text.match(pattern);
            if (!match) continue;
            const page = Math.floor(Number(match[1]));
            if (isFinite(page) && page > 0) return page;
        }
        return fallback;
    }

    private firstDocumentPage(item: any, keys: string[] = ['target_page', 'page', 'page_start'], fallback: number = 0): number {
        for (const key of keys) {
            const page = this.parseDocumentPage(item?.[key], 0);
            if (page > 0) return page;
        }
        return fallback;
    }

    private buildHwpPageUrl(fileIndex: number | string, page: any = 1, highlighted: boolean = true, driveFileId: string = ''): string {
        const safePage = this.parseDocumentPage(page, 1);
        let url = `/wiz/api/page.chatbot.room/serve_hwp_page?session_id=${encodeURIComponent(this.sessionId)}&file_index=${encodeURIComponent(String(fileIndex))}&page=${encodeURIComponent(String(safePage))}&highlighted=${highlighted ? '1' : '0'}`;
        if (driveFileId) {
            url += `&drive_file_id=${encodeURIComponent(driveFileId)}`;
        }
        return url;
    }

    private withHwpPageUrl(url: string, page: any = 1): string {
        const safePage = this.parseDocumentPage(page, 1);
        const base = String(url || '').split('#')[0];
        if (!base) return '';
        try {
            const isAbsolute = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(base);
            const parsed = new URL(base, window.location.origin);
            parsed.searchParams.set('page', String(safePage));
            return isAbsolute
                ? `${parsed.origin}${parsed.pathname}${parsed.search}`
                : `${parsed.pathname}${parsed.search}`;
        } catch {
            const sep = base.includes('?') ? '&' : '?';
            return `${base}${sep}page=${encodeURIComponent(String(safePage))}`;
        }
    }

    private buildPdfPageImageUrl(sourceUrl: string, page: any = 1): string {
        const fileIndex = this.normalizeViewerFileIndex(this.getUrlParam(sourceUrl, 'file_index') || this.selectedPdfFileIndex);
        if (!fileIndex || !this.sessionId || !this.isServerPagedPdfUrl(sourceUrl)) return '';

        const safePage = this.parseDocumentPage(page, 1);
        const highlighted = sourceUrl.includes('/serve_highlighted_pdf') ? '1' : '0';
        let url = `/wiz/api/page.chatbot.room/serve_pdf_page_image?session_id=${encodeURIComponent(this.sessionId)}&file_index=${encodeURIComponent(String(fileIndex))}&page=${encodeURIComponent(String(safePage))}&highlighted=${highlighted}`;
        const driveFileId = this.getUrlParam(sourceUrl, 'drive_file_id');
        if (driveFileId) {
            url += `&drive_file_id=${encodeURIComponent(driveFileId)}`;
        }
        return url;
    }

    private buildDocumentPageImageUrl(fileIndex: number | string, page: any = 1, highlighted: boolean = true, driveFileId: string = ''): string {
        const normalized = this.normalizeViewerFileIndex(fileIndex);
        if (!normalized || !this.sessionId) return '';
        const safePage = this.parseDocumentPage(page, 1);
        let url = `/wiz/api/page.chatbot.room/serve_pdf_page_image?session_id=${encodeURIComponent(this.sessionId)}&file_index=${encodeURIComponent(normalized)}&page=${encodeURIComponent(String(safePage))}&highlighted=${highlighted ? '1' : '0'}`;
        if (driveFileId) {
            url += `&drive_file_id=${encodeURIComponent(driveFileId)}`;
        }
        return url;
    }

    private refreshPdfImageUrl() {
        this.viewerErrorMessage = '';
        this.viewerHighlights = [];
        this.activeViewerHighlight = null;
        this.setViewerHighlightLayerVisible(false);
        if (!this.pdfUrl || this.pdfUrl.includes('/serve_hwp_page')) {
            this.pdfImageUrl = '';
            return;
        }
        this.pdfImageUrl = this.buildPdfPageImageUrl(this.pdfUrl, this.pdfPage);
        this.loadViewerHighlights();
    }

    public usePdfImageViewer(): boolean {
        return !!this.pdfImageUrl;
    }

    public isHwpSvgScrollViewer(): boolean {
        return this.viewerMode === 'hwp_svg' || String(this.pdfUrl || '').includes('/serve_hwp_page');
    }

    public canUseScrollViewer(): boolean {
        if (!this.pdfUrl || this.compareMode || this.viewerTotalPages <= 1) return false;
        if (this.isHwpSvgScrollViewer()) return true;
        return !!this.buildPdfPageImageUrl(this.pdfUrl, this.pdfPage);
    }

    public isViewerScrollActive(): boolean {
        return this.viewerScrollMode && this.canUseScrollViewer();
    }

    public getViewerScrollPages(): number[] {
        if (!this.canUseScrollViewer()) return [];
        const total = Math.max(1, Math.floor(Number(this.viewerTotalPages) || 1));
        return Array.from({ length: total }, (_v, index) => index + 1);
    }

    public trackByViewerScrollPage(_index: number, page: number): number {
        return page;
    }

    public getViewerScrollPageUrl(page: any): string {
        const safePage = this.parseDocumentPage(page, 1);
        if (this.isHwpSvgScrollViewer()) {
            const fileIndex = this.normalizeViewerFileIndex(this.selectedPdfFileIndex || this.getUrlParam(this.pdfUrl, 'file_index'));
            if (!fileIndex) return '';
            const highlighted = this.getUrlParam(this.pdfUrl, 'highlighted') !== '0';
            return this.buildHwpPageUrl(fileIndex, safePage, highlighted);
        }
        return this.buildPdfPageImageUrl(this.pdfUrl, safePage);
    }

    public async toggleViewerScrollMode(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.canUseScrollViewer()) return;

        this.viewerScrollMode = !this.viewerScrollMode;
        if (this.viewerScrollMode) {
            this.setViewerHighlightLayerVisible(false);
        } else {
            this.refreshPdfImageUrl();
        }
        this.saveViewState();
        await this.service.render();

        if (this.viewerScrollMode) {
            this.scrollViewerToPage(this.pdfPage);
        } else {
            this.syncViewerHighlightLayer();
        }
    }

    private scrollViewerToPage(page: any) {
        window.setTimeout(() => {
            const container = this.viewerScrollContainer?.nativeElement;
            if (!container) return;
            const safePage = this.parseDocumentPage(page, 1);
            const target = container.querySelector(`[data-viewer-page="${safePage}"]`);
            if (!target) return;
            const containerRect = container.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            container.scrollTo({
                top: container.scrollTop + targetRect.top - containerRect.top - 8,
                behavior: 'smooth',
            });
        }, 0);
    }

    public onViewerScroll(event: any) {
        if (this.viewerScrollSyncTimer) return;
        const container = event?.target;
        this.viewerScrollSyncTimer = window.setTimeout(() => {
            this.viewerScrollSyncTimer = null;
            this.syncViewerPageFromScroll(container);
        }, 80);
    }

    private syncViewerPageFromScroll(container: any) {
        if (!container) return;
        const pageNodes = Array.from(container.querySelectorAll('[data-viewer-page]')) as any[];
        if (!pageNodes.length) return;

        const containerRect = container.getBoundingClientRect();
        const anchorTop = containerRect.top + 24;
        let currentPage = this.pdfPage;
        let bestDistance = Number.POSITIVE_INFINITY;
        for (const node of pageNodes) {
            const rect = node.getBoundingClientRect();
            if (rect.bottom < containerRect.top + 24) continue;
            const distance = Math.abs(rect.top - anchorTop);
            if (distance < bestDistance) {
                bestDistance = distance;
                currentPage = this.parseDocumentPage(node.getAttribute('data-viewer-page'), currentPage);
            }
        }

        if (currentPage !== this.pdfPage) {
            this.pdfPage = currentPage;
            if (this.viewerScrollSaveTimer) window.clearTimeout(this.viewerScrollSaveTimer);
            this.viewerScrollSaveTimer = window.setTimeout(() => {
                this.viewerScrollSaveTimer = null;
                this.saveViewState();
            }, 250);
        }
    }

    private clampPdfZoom(value: any): number {
        const zoom = Math.round(Number(value) || 100);
        return Math.max(100, Math.min(250, zoom));
    }

    public async zoomPdf(delta: number) {
        this.pdfZoomPercent = this.clampPdfZoom(this.pdfZoomPercent + delta);
        this.saveViewState();
        await this.service.render();
        this.syncViewerHighlightLayer();
    }

    public async resetPdfZoom() {
        this.pdfZoomPercent = 100;
        this.saveViewState();
        await this.service.render();
        this.syncViewerHighlightLayer();
    }

    public onViewerPageImageLoad(event?: any) {
        this.viewerErrorMessage = '';
        this.syncViewerHighlightLayer(event?.target);
    }

    public async onViewerPageImageError() {
        this.viewerErrorMessage = '문서 페이지를 불러오지 못했습니다.';
        this.viewerHighlights = [];
        this.activeViewerHighlight = null;
        this.setViewerHighlightLayerVisible(false);
        await this.service.render();
    }

    private viewerHighlightKey(fileIndex: string, page: number): string {
        const driveFileId = this.getUrlParam(this.pdfUrl, 'drive_file_id');
        return `${this.sessionId}|${fileIndex}|${page}|${driveFileId}`;
    }

    private async loadViewerHighlights() {
        const fileIndex = this.normalizeViewerFileIndex(this.getUrlParam(this.pdfUrl, 'file_index') || this.selectedPdfFileIndex);
        const page = this.parseDocumentPage(this.pdfPage, 1);
        if (!this.sessionId || !fileIndex || !this.pdfUrl.includes('/serve_highlighted_pdf')) {
            this.viewerHighlightRequestKey = '';
            return;
        }

        const requestKey = this.viewerHighlightKey(fileIndex, page);
        this.viewerHighlightRequestKey = requestKey;

        try {
            const params: any = {
                session_id: this.sessionId,
                file_index: fileIndex,
                page,
            };
            const driveFileId = this.getUrlParam(this.pdfUrl, 'drive_file_id');
            if (driveFileId) params.drive_file_id = driveFileId;

            const res: any = await wiz.call('viewer_highlights', params);
            if (this.viewerHighlightRequestKey !== requestKey) return;

            const data = res?.data || res || {};
            this.viewerHighlights = Array.isArray(data.items) ? data.items : [];
            this.activeViewerHighlight = null;
            await this.service.render();
            this.syncViewerHighlightLayer();
        } catch (e) {
            if (this.viewerHighlightRequestKey !== requestKey) return;
            console.warn('Failed to load viewer highlights:', e);
            this.viewerHighlights = [];
            this.activeViewerHighlight = null;
            this.setViewerHighlightLayerVisible(false);
            await this.service.render();
        }
    }

    private setViewerHighlightLayerVisible(visible: boolean) {
        const layer = this.viewerHighlightLayer?.nativeElement;
        if (!layer) return;
        layer.style.display = visible ? 'block' : 'none';
    }

    private syncViewerHighlightLayer(imageEl?: any) {
        window.setTimeout(() => {
            const layer = this.viewerHighlightLayer?.nativeElement;
            const frame = this.viewerPageFrame?.nativeElement;
            const image = imageEl || this.viewerPageImage?.nativeElement;
            if (!layer || !frame || !image || !this.viewerHighlights.length || this.viewerErrorMessage) {
                this.setViewerHighlightLayerVisible(false);
                return;
            }

            const imageRect = image.getBoundingClientRect();
            const frameRect = frame.getBoundingClientRect();
            if (!imageRect.width || !imageRect.height) {
                this.setViewerHighlightLayerVisible(false);
                return;
            }

            layer.style.display = 'block';
            layer.style.left = `${imageRect.left - frameRect.left}px`;
            layer.style.top = `${imageRect.top - frameRect.top}px`;
            layer.style.width = `${imageRect.width}px`;
            layer.style.height = `${imageRect.height}px`;
        }, 0);
    }

    public getViewerHighlightRects(highlight: any): any[] {
        const rects = Array.isArray(highlight?.rects)
            ? highlight.rects.filter((rect: any) => rect && typeof rect === 'object')
            : [];
        if (rects.length > 0) return rects;
        return highlight?.rect ? [highlight.rect] : [];
    }

    public getViewerHighlightStyle(highlight: any, rectInput?: any): any {
        const rect = rectInput || highlight?.rect || {};
        const width = Math.max(Number(rect.width) || 0, 0.7);
        const height = Math.max(Number(rect.height) || 0, 0.7);
        return {
            left: `${Math.max(0, Math.min(100, Number(rect.x) || 0))}%`,
            top: `${Math.max(0, Math.min(100, Number(rect.y) || 0))}%`,
            width: `${Math.min(100, width)}%`,
            height: `${Math.min(100, height)}%`,
            '--highlight-color': highlight?.color || '#ef4444',
        };
    }

    public async selectViewerHighlight(highlight: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.activeViewerHighlight = highlight;
        await this.service.render();
        this.syncViewerHighlightLayer();
    }

    public async closeViewerHighlight(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.activeViewerHighlight = null;
        await this.service.render();
        this.syncViewerHighlightLayer();
    }

    public isViewerHighlightActive(highlight: any): boolean {
        return !!highlight && this.activeViewerHighlight?.id === highlight.id;
    }

    public isHwpViewerMode(): boolean {
        return this.viewerMode === 'hwp' || this.viewerMode === 'hwp_svg';
    }

    public getViewerModeLabel(): string {
        if (this.viewerMode === 'hwp_svg') return 'HWP 원본';
        if (this.viewerMode === 'hwp') return 'HWP';
        return 'PDF';
    }

    public getViewerModeBadgeClass(): string {
        return this.isHwpViewerMode()
            ? 'bg-emerald-50 text-emerald-600 border-emerald-200'
            : 'bg-blue-50 text-blue-600 border-blue-200';
    }

    // ========== Document Viewer ==========

    private isServerPagedPdfUrl(url: string): boolean {
        const value = String(url || '');
        return value.includes('/serve_pdf') || value.includes('/serve_highlighted_pdf');
    }

    private withPdfPage(url: string, page: any = 1): string {
        const safePage = this.parseDocumentPage(page, 1);
        const base = String(url || '').split('#')[0];
        if (!base) return `#page=${safePage}`;
        const hashPage = this.isServerPagedPdfUrl(base) ? 1 : safePage;

        try {
            const isAbsolute = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(base);
            const parsed = new URL(base, window.location.origin);
            parsed.searchParams.set('viewer_page', String(safePage));
            const rebuilt = isAbsolute
                ? `${parsed.origin}${parsed.pathname}${parsed.search}`
                : `${parsed.pathname}${parsed.search}`;
            return `${rebuilt}#page=${hashPage}`;
        } catch {
            const sep = base.includes('?') ? '&' : '?';
            return `${base}${sep}viewer_page=${encodeURIComponent(String(safePage))}#page=${hashPage}`;
        }
    }

    private async loadPdfInfoForUrl(url: string) {
        const fileIndex = this.normalizeViewerFileIndex(this.getUrlParam(url, 'file_index') || this.selectedPdfFileIndex);
        if (!fileIndex) return;
        const file = this.findViewerFile(fileIndex);
        if (file && this.isHwpViewerFile(file)) return;

        try {
            const params: any = {
                session_id: this.sessionId,
                file_index: fileIndex,
            };
            const driveFileId = this.getUrlParam(url, 'drive_file_id');
            if (driveFileId) params.drive_file_id = driveFileId;
            const res: any = await wiz.call('pdf_info', params);
            if (res.code === 200 && res.data?.page_count) {
                this.viewerTotalPages = Number(res.data.page_count) || 0;
                if (!this.pdfFileName && res.data.filename) {
                    this.pdfFileName = String(res.data.filename);
                }
            }
        } catch (e) {
            console.warn('Failed to load PDF info:', e);
        }
    }

    public async showPdf(url: string, page: any = 1, fileName: string = '') {
        this.compareMode = false;
        this.compareLeft = null;
        this.compareRight = null;
        if (url && url.includes('/serve_highlighted_pdf')) {
            const fileIndex = this.normalizeViewerFileIndex(this.getUrlParam(url, 'file_index'));
            const file = fileIndex ? this.findViewerFile(fileIndex) : null;
            if (file && this.isHwpViewerFile(file)) {
                await this.showHwp(file.index, page, fileName || file.filename, true);
                return;
            }
        }
        const fileIndex = this.normalizeViewerFileIndex(this.getUrlParam(url, 'file_index'));
        if (fileIndex) {
            const file = this.findViewerFile(fileIndex);
            if (file) this.selectedPdfFileIndex = String(file.index);
        }
        this.viewerTotalPages = 0;
        this.pdfFileName = fileName;
        await this.loadPdfInfoForUrl(url);

        let safePage = this.parseDocumentPage(page, 1);
        if (this.viewerTotalPages > 0 && safePage > this.viewerTotalPages) {
            safePage = this.viewerTotalPages;
        }
        this.pdfUrl = this.withPdfPage(url, safePage);
        this.pdfPage = safePage;
        if (fileName) this.pdfFileName = fileName;
        this.viewerMode = 'pdf';
        this.refreshPdfImageUrl();
        this.setRightTab('pdf', true);
        this.saveViewState();
        await this.service.render();
    }

    public async showHwp(fileIndex: number | string, page: any = 1, fileName: string = '', highlighted: boolean = true) {
        this.compareMode = false;
        this.compareLeft = null;
        this.compareRight = null;
        const file = this.findViewerFile(fileIndex);
        if (!file) return;
        this.selectedPdfFileIndex = String(file.index);
        this.pdfPage = this.parseDocumentPage(page, 1);
        this.pdfFileName = fileName || file.filename;
        this.viewerTotalPages = 0;
        this.viewerMode = 'hwp';
        let hwpMode = '';
        try {
            const res: any = await wiz.call('hwp_info', {
                session_id: this.sessionId,
                file_index: file.index,
            });
            if (res.code === 200 && res.data?.page_count) {
                this.viewerTotalPages = Number(res.data.page_count) || 0;
                hwpMode = String(res.data.mode || '');
            }
        } catch (e) {
            console.warn('Failed to load HWP info:', e);
        }
        if (this.viewerTotalPages > 0 && this.pdfPage > this.viewerTotalPages) {
            this.pdfPage = this.viewerTotalPages;
        }
        if (hwpMode === 'svg') {
            this.viewerMode = 'hwp_svg';
            this.pdfUrl = this.buildHwpPageUrl(file.index, this.pdfPage, highlighted);
            this.pdfImageUrl = '';
            this.viewerHighlights = [];
            this.activeViewerHighlight = null;
            this.setViewerHighlightLayerVisible(false);
        } else {
            const baseUrl = highlighted ? this.buildHighlightedPdfUrl(file.index) : this.buildRawPdfUrl(file.index);
            this.pdfUrl = this.withPdfPage(baseUrl, this.pdfPage);
            this.refreshPdfImageUrl();
        }
        this.setRightTab('pdf', true);
        this.saveViewState();
        await this.service.render();
    }

    public async showDocumentByFileIndex(fileIndex: number | string, page: any = 1, fileName: string = '', highlighted: boolean = true) {
        this.compareMode = false;
        this.compareLeft = null;
        this.compareRight = null;
        const file = this.findViewerFile(fileIndex);
        if (!file) return;
        this.selectedPdfFileIndex = String(file.index);
        const ext = this.getViewerFileExt(file);
        if (ext === 'pdf') {
            const url = highlighted ? this.buildHighlightedPdfUrl(file.index) : this.buildRawPdfUrl(file.index);
            await this.showPdf(url, page, fileName || file.filename);
        } else if (ext === 'hwp' || ext === 'hwpx') {
            await this.showHwp(file.index, page, fileName || file.filename, highlighted);
        }
    }

    public async viewResultDetail(result: any) {
        const pdfUrl = result.pdf_url;
        const page = this.firstDocumentPage(result, ['target_page', 'page', 'page_start'], 1);
        const fileName = result.location || '';
        const file = this.hasViewerFileIndex(result.file_index) ? this.findViewerFile(result.file_index) : null;

        if (file && this.isHwpViewerFile(file)) {
            await this.showDocumentByFileIndex(result.file_index, page, fileName);
        } else if (pdfUrl) {
            await this.showPdf(pdfUrl, page, fileName);
        } else if (this.hasViewerFileIndex(result.file_index)) {
            await this.showDocumentByFileIndex(result.file_index, page, fileName);
        }
    }

    public async goToPage(page: any) {
        page = this.parseDocumentPage(page, 1);
        if (this.viewerTotalPages > 0 && page > this.viewerTotalPages) {
            page = this.viewerTotalPages;
        }
        this.pdfPage = page;
        if (this.isViewerScrollActive()) {
            this.saveViewState();
            await this.service.render();
            this.scrollViewerToPage(page);
            return;
        }
        if (this.viewerMode === 'hwp_svg' || this.pdfUrl.includes('/serve_hwp_page')) {
            const fileIndex = this.normalizeViewerFileIndex(this.selectedPdfFileIndex || this.getUrlParam(this.pdfUrl, 'file_index'));
            if (fileIndex) {
                const highlighted = this.getUrlParam(this.pdfUrl, 'highlighted') !== '0';
                this.pdfUrl = this.buildHwpPageUrl(fileIndex, page, highlighted);
                this.viewerMode = 'hwp_svg';
                this.pdfImageUrl = '';
                this.viewerHighlights = [];
                this.activeViewerHighlight = null;
                this.setViewerHighlightLayerVisible(false);
                this.saveViewState();
                await this.service.render();
                return;
            }
        }
        const baseUrl = this.pdfUrl.split('#')[0];
        this.pdfUrl = this.withPdfPage(baseUrl, page);
        this.refreshPdfImageUrl();
        this.saveViewState();
        await this.service.render();
    }

    private canNavigateViewerPage(): boolean {
        return this.rightTab === 'pdf' && !this.compareMode && !!this.pdfUrl;
    }

    private isViewerKeyboardShortcutTarget(target: any): boolean {
        if (!target) return true;
        if (target.classList?.contains('viewer-page-input')) return true;
        const tagName = String(target.tagName || '').toLowerCase();
        if (['input', 'textarea', 'select', 'button', 'a'].includes(tagName)) return false;
        return !target.isContentEditable;
    }

    private async moveViewerPage(delta: number, event?: KeyboardEvent) {
        if (!this.canNavigateViewerPage()) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const currentPage = this.parseDocumentPage(this.pdfPage, 1);
        const nextPage = currentPage + delta;
        if (nextPage < 1) return;
        if (this.viewerTotalPages > 0 && nextPage > this.viewerTotalPages) return;
        await this.goToPage(nextPage);
    }

    public async onViewerPageInputKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            await this.goToPage(this.pdfPage);
            return;
        }
        if (event.key === 'ArrowLeft') {
            await this.moveViewerPage(-1, event);
            return;
        }
        if (event.key === 'ArrowRight') {
            await this.moveViewerPage(1, event);
        }
    }

    private async onViewerKeyboardShortcut(event: KeyboardEvent) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (!this.canNavigateViewerPage()) return;
        if (!this.isViewerKeyboardShortcutTarget(event.target)) return;
        await this.moveViewerPage(event.key === 'ArrowLeft' ? -1 : 1, event);
    }

    private getUrlParam(url: string, key: string): string {
        try {
            const parsed = new URL(url, window.location.origin);
            return parsed.searchParams.get(key) || '';
        } catch {
            return '';
        }
    }

    public async selectPdfFile(fileIndex: number | string) {
        await this.showDocumentByFileIndex(fileIndex, 1, '', true);
    }

    private comparePaneFile(pane: any): any {
        const fileIndex = this.normalizeViewerFileIndex(pane?.file_index || this.getUrlParam(pane?.source_url || pane?.pdf_url || '', 'file_index'));
        return fileIndex ? this.findViewerFile(fileIndex) : null;
    }

    private comparePaneIsHwp(pane: any): boolean {
        if (!pane) return false;
        if (pane.mode === 'pdf') return false;
        if (pane.mode === 'hwp_svg') return true;
        const file = this.comparePaneFile(pane);
        return !!file && this.isHwpViewerFile(file);
    }

    private updateComparePaneSource(pane: any) {
        if (!pane) return;
        const safePage = this.parseDocumentPage(pane.page, 1);
        const totalPages = Math.floor(Number(pane.total_pages) || 0);
        pane.page = totalPages > 0 ? Math.min(safePage, totalPages) : safePage;

        const sourceUrl = String(pane.source_url || '');
        const driveFileId = String(pane.drive_file_id || this.getUrlParam(sourceUrl, 'drive_file_id') || '');
        const fileIndex = this.normalizeViewerFileIndex(pane.file_index || this.getUrlParam(sourceUrl, 'file_index'));
        const highlighted = pane.highlighted !== false;

        if (pane.mode === 'hwp_svg' || this.comparePaneIsHwp(pane)) {
            pane.mode = 'hwp_svg';
            pane.image_url = '';
            pane.pdf_url = fileIndex
                ? this.buildHwpPageUrl(fileIndex, pane.page, highlighted, driveFileId)
                : (sourceUrl.includes('/serve_hwp_page') ? this.withHwpPageUrl(sourceUrl, pane.page) : '');
            return;
        }

        pane.mode = 'pdf';
        if (sourceUrl) {
            pane.pdf_url = this.withPdfPage(sourceUrl, pane.page);
            pane.image_url = this.buildPdfPageImageUrl(sourceUrl, pane.page);
            return;
        }

        if (!fileIndex) {
            pane.pdf_url = '';
            pane.image_url = '';
            return;
        }
        const baseUrl = highlighted ? this.buildHighlightedPdfUrl(fileIndex) : this.buildRawPdfUrl(fileIndex);
        pane.pdf_url = this.withPdfPage(baseUrl, pane.page);
        pane.image_url = this.buildDocumentPageImageUrl(fileIndex, pane.page, highlighted, driveFileId);
    }

    private buildComparePane(fileIndex: number | string, page: any, role: string, fallbackName: string = ''): any {
        const file = this.findViewerFile(fileIndex);
        const safePage = this.parseDocumentPage(page, 1);
        const normalized = this.normalizeViewerFileIndex(file?.index ?? fileIndex);
        const pane = {
            role,
            file_index: normalized,
            filename: fallbackName || file?.filename || '',
            page: safePage,
            total_pages: 0,
            mode: (file && this.isHwpViewerFile(file)) ? 'hwp_svg' : 'pdf',
            highlighted: true,
            source_url: '',
            pdf_url: '',
            image_url: '',
        };
        this.updateComparePaneSource(pane);
        return pane;
    }

    private buildComparePaneFromUrl(url: string, page: any, role: string, fallbackName: string = ''): any {
        const safePage = this.parseDocumentPage(page, 1);
        const fileIndex = this.normalizeViewerFileIndex(this.getUrlParam(url, 'file_index'));
        const file = fileIndex ? this.findViewerFile(fileIndex) : null;
        const pane = {
            role,
            file_index: fileIndex,
            filename: fallbackName || file?.filename || '',
            page: safePage,
            total_pages: 0,
            mode: file && this.isHwpViewerFile(file) ? 'hwp_svg' : 'pdf',
            highlighted: !url.includes('/serve_pdf?'),
            source_url: url,
            drive_file_id: this.getUrlParam(url, 'drive_file_id'),
            pdf_url: '',
            image_url: '',
        };
        this.updateComparePaneSource(pane);
        return pane;
    }

    private async loadComparePaneInfo(pane: any) {
        if (!pane) return;
        const sourceUrl = String(pane.source_url || pane.pdf_url || '');
        const fileIndex = this.normalizeViewerFileIndex(pane.file_index || this.getUrlParam(sourceUrl, 'file_index'));
        if (!fileIndex && !pane.drive_file_id) return;
        const file = fileIndex ? this.findViewerFile(fileIndex) : null;
        const isHwp = (file && this.isHwpViewerFile(file)) || pane.mode === 'hwp_svg';
        try {
            const params: any = {
                session_id: this.sessionId,
                file_index: fileIndex || 0,
            };
            const driveFileId = pane.drive_file_id || this.getUrlParam(sourceUrl, 'drive_file_id');
            if (driveFileId) params.drive_file_id = driveFileId;
            const res: any = await wiz.call(isHwp ? 'hwp_info' : 'pdf_info', params);
            if (res.code === 200 && res.data) {
                pane.total_pages = Number(res.data.page_count) || pane.total_pages || 0;
                if (!pane.filename && res.data.filename) pane.filename = String(res.data.filename);
                if (isHwp) {
                    pane.mode = String(res.data.mode || '') === 'svg' ? 'hwp_svg' : 'pdf';
                }
                this.updateComparePaneSource(pane);
            }
        } catch (e) {
            console.warn('Failed to load compare pane info:', e);
        }
    }

    private async refreshComparePanesInfo() {
        await Promise.all([
            this.loadComparePaneInfo(this.compareLeft),
            this.loadComparePaneInfo(this.compareRight),
        ]);
        await this.service.render();
    }

    public canMoveComparePanePage(side: string, delta: number): boolean {
        const pane = side === 'left' ? this.compareLeft : this.compareRight;
        if (!pane) return false;
        const nextPage = this.parseDocumentPage(pane.page, 1) + delta;
        if (nextPage < 1) return false;
        const totalPages = Math.floor(Number(pane.total_pages) || 0);
        return totalPages <= 0 || nextPage <= totalPages;
    }

    public async goToComparePanePage(side: string, page: any) {
        const pane = side === 'left' ? this.compareLeft : this.compareRight;
        if (!pane) return;
        let safePage = this.parseDocumentPage(page, 1);
        const totalPages = Math.floor(Number(pane.total_pages) || 0);
        if (totalPages > 0 && safePage > totalPages) safePage = totalPages;
        pane.page = safePage;
        this.updateComparePaneSource(pane);
        this.pdfPage = this.compareLeft?.page || safePage;
        this.saveViewState();
        await this.service.render();
    }

    public async onComparePageInputKeydown(side: string, event: KeyboardEvent) {
        const pane = side === 'left' ? this.compareLeft : this.compareRight;
        if (!pane) return;
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            await this.goToComparePanePage(side, pane.page);
            return;
        }
        if (event.key === 'ArrowLeft' && this.canMoveComparePanePage(side, -1)) {
            event.preventDefault();
            event.stopPropagation();
            await this.goToComparePanePage(side, this.parseDocumentPage(pane.page, 1) - 1);
            return;
        }
        if (event.key === 'ArrowRight' && this.canMoveComparePanePage(side, 1)) {
            event.preventDefault();
            event.stopPropagation();
            await this.goToComparePanePage(side, this.parseDocumentPage(pane.page, 1) + 1);
        }
    }

    public canViewStateEvaluationReport(item: any): boolean {
        if (!item) return false;
        if (item.pdf_url) return true;
        return this.hasViewerFileIndex(item.file_index) && !!this.findViewerFile(item.file_index);
    }

    public canCompareStateEvaluationEvidence(item: any): boolean {
        return this.canViewStateEvaluationReport(item) && this.canViewRefDocument(item);
    }

    public async viewStateEvaluationReport(item: any) {
        if (!this.canViewStateEvaluationReport(item)) return;
        await this.viewResultDetail(item);
        await this.service.render();
    }

    public async viewStateEvaluationGuideline(item: any) {
        if (!this.canViewRefDocument(item)) return;
        await this.viewRefPdf(item);
        await this.service.render();
    }

    public async viewStateEvaluationComparison(item: any) {
        if (!this.canCompareStateEvaluationEvidence(item)) {
            await this.viewStateEvaluationGuideline(item);
            return;
        }
        const reportPage = this.firstDocumentPage(item, ['target_page', 'page', 'page_start'], 1);
        const guidelinePage = this.firstDocumentPage(item, ['ref_page', 'reference_page', 'baseline_page'], 1);
        this.compareLeft = this.buildComparePane(
            item.file_index,
            reportPage,
            '보고서 근거',
            item.filename || item.location || '보고서',
        );
        if (item.ref_pdf_url) {
            this.compareRight = this.buildComparePaneFromUrl(
                item.ref_pdf_url,
                guidelinePage,
                '지침 근거',
                item.ref_filename || item.ref_file || '지침 파일',
            );
        } else {
            this.compareRight = this.buildComparePane(
                item.ref_file_index,
                guidelinePage,
                '지침 근거',
                item.ref_filename || item.ref_file || '지침 파일',
            );
        }
        this.compareMode = true;
        this.pdfUrl = '';
        this.pdfImageUrl = '';
        this.pdfPage = reportPage;
        this.pdfFileName = `${this.compareLeft.filename || '보고서'} / ${this.compareRight.filename || '지침 파일'}`;
        this.viewerMode = 'pdf';
        this.setRightTab('pdf', true);
        this.saveViewState();
        await this.refreshComparePanesInfo();
    }

    public async closeCompareMode() {
        this.compareMode = false;
        this.compareLeft = null;
        this.compareRight = null;
        await this.service.render();
    }

    // ========== Results Classification ==========

    private isStateEvaluationResult(r: any): boolean {
        const text = [
            r?.type,
            r?.category,
            r?.title,
            r?.item,
            r?.description,
            r?.rule,
        ].map((v: any) => String(v || '')).join(' ');
        return r?.type === 'state_evaluation'
            || r?.type === 'state_evaluation_summary'
            || /상태평가|상태평가 적정성|상태평가 적절성|상태평가 점수표|평가점수표|상태평가 산정표/.test(text);
    }

    private applyCopyImageStats(stats: any, intent: string = '') {
        if (stats) {
            this.copyImageStats = stats;
            return;
        }
        if (intent === 'copy_check' || intent === 'inspect') {
            this.copyImageStats = null;
        }
    }

    private isImageCopyResult(item: any): boolean {
        const type = String(item?.type || '').toLowerCase();
        return type === 'image_copy' || (type === 'copy' && !!item?.image_context);
    }

    private copyImageContextValue(item: any, key: string): string {
        const context = String(item?.image_context || '');
        const token = `${key}=`;
        const start = context.indexOf(token);
        if (start < 0) return '';
        return context.slice(start + token.length).split(/[;\n]/)[0].trim();
    }

    private copyImageFileRoleLabel(fileIndex: any, item?: any): string {
        const parsed = Number(fileIndex);
        if (Number.isFinite(parsed)) {
            if (Number(item?.file_index) === parsed) return '대상 보고서';
            if (Number(item?.ref_file_index) === parsed) return '기준 보고서';
            const fileInfo = (this.sessionData?.files || []).find((file: any) => Number(file?.index) === parsed);
            const type = String(fileInfo?.type || '').toLowerCase();
            if (type === 'report') return '대상 보고서';
            if (type === 'reference') return '기준 보고서';
            if (type === 'additional') return '비교 문서';
        }
        return '문서';
    }

    private replaceInternalImageRefs(value: any, item?: any): string {
        let text = this.sanitizeProcessText(value || '');
        text = text.replace(/\bf(\d+):p(\d+):i\d+\b/g, (_match: string, fileIndex: string, page: string) => {
            return `${this.copyImageFileRoleLabel(fileIndex, item)} ${page}p 이미지`;
        });
        text = text.replace(/\bf(\d+):p(\d+):hwp:\d+\b/g, (_match: string, fileIndex: string, page: string) => {
            return `${this.copyImageFileRoleLabel(fileIndex, item)} ${page}p 이미지`;
        });
        text = text.replace(/(?:\/[^\s;,\])]+)*\/f(\d+)_p(\d+)_(?:hwp_)?i\d+\.(?:png|jpg|jpeg|webp)\b/gi, (_match: string, fileIndex: string, page: string) => {
            return `${this.copyImageFileRoleLabel(fileIndex, item)} ${page}p 이미지`;
        });
        text = text.replace(/\bf(\d+)_p(\d+)_(?:hwp_)?i\d+\b/gi, (_match: string, fileIndex: string, page: string) => {
            return `${this.copyImageFileRoleLabel(fileIndex, item)} ${page}p 이미지`;
        });
        text = text.replace(/\b(?:target|reference)_crop\s*=\s*/gi, '');
        text = text.replace(/\b(?:target|reference|대상|비교)\s*crop\s*:\s*/gi, '');
        text = text.replace(/\bbbox\s*\[[^\]]+\]/gi, '');
        text = text.replace(/\bimage[_\s-]*index\s*\d+/gi, '');
        return text.replace(/[ \t]{2,}/g, ' ').trim();
    }

    private hasInternalImageRef(value: any): boolean {
        const text = String(value || '');
        return /\bf\d+:p\d+:(?:i\d+|hwp:\d+)\b/.test(text)
            || /\bf\d+_p\d+_(?:hwp_)?i\d+\b/.test(text)
            || /image_index/i.test(text)
            || /crop_path/i.test(text);
    }

    private hasTechnicalImageLocation(value: any): boolean {
        const text = String(value || '');
        return this.hasInternalImageRef(text) || /\bbbox\b|\bimage[_\s-]*index\b/i.test(text);
    }

    private imageCopyLocationLabel(item: any, reference: boolean = false): string {
        const page = reference
            ? this.firstDisplayValue(item?.ref_page, item?.reference_page)
            : this.firstDisplayValue(item?.target_page, item?.page, item?.page_start);
        const role = reference ? '기준 보고서' : '대상 보고서';
        return page ? `${role} ${page}p 이미지` : `${role} 이미지`;
    }

    private cleanCopyDisplayCandidate(value: any): string {
        let text = this.replaceInternalImageRefs(value || '');
        text = text.replace(/\b(?:target|reference|대상|비교)\s*crop\s*:\s*\S+/gi, ' ');
        text = text.replace(/\b(?:target|reference)_crop\s*=\s*[^;\n]+/gi, ' ');
        text = text.replace(/\bbbox\s*\[[^\]]+\]/gi, ' ');
        text = text.replace(/\bpage\s*\d+\s*,?\s*image_index\s*\d+[^;\n]*/gi, ' ');
        text = text.replace(/\bimage\s+/gi, ' ');
        ['대상 캡션/주변문구:', '비교 캡션/주변문구:', '대상 주변문구:', '비교 주변문구:'].forEach((prefix: string) => {
            text = text.split(prefix).join('');
        });
        text = text.split(/\s*\/\s*(?:비교|대상)\s*(?:캡션|주변문구)|;/, 1)[0] || text;
        text = text.replace(/\s+/g, ' ').replace(/^[\s\-_:,/]+|[\s\-_:,/]+$/g, '');
        if (!text || this.hasInternalImageRef(text)) return '';
        if (text.startsWith('/mnt/') || text.includes('image_evidence/')) return '';
        return text.length > 90 ? `${text.slice(0, 90).trim()}...` : text;
    }

    private imageCopyDisplayItem(item: any): string {
        for (const key of ['evidence', 'matched_text', 'title', 'description']) {
            const cleaned = this.cleanCopyDisplayCandidate(item?.[key]);
            if (cleaned) return cleaned;
        }
        return '이미지 재사용';
    }

    private normalizeCopyFinding(item: any) {
        if (!item) return;
        const textFields = ['title', 'description', 'evidence', 'location', 'ref_location', 'reason', 'suggestion', 'note', 'matched_text'];
        for (const key of textFields) {
            if (item[key]) item[key] = this.replaceInternalImageRefs(item[key], item);
        }
        if (this.isImageCopyResult(item)) {
            if (this.hasTechnicalImageLocation(item.location)) item.location = this.imageCopyLocationLabel(item, false);
            if (this.hasTechnicalImageLocation(item.ref_location)) item.ref_location = this.imageCopyLocationLabel(item, true);
        }
        if (this.isImageCopyResult(item) && this.hasInternalImageRef(item.item)) {
            item.item = this.imageCopyDisplayItem(item);
        } else if (item.item) {
            item.item = this.replaceInternalImageRefs(item.item, item);
        }
    }

    private copyImageCompactKey(value: any): string {
        return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }

    private copyImageTargetKey(item: any): string {
        const targetBBox = item?.target_bbox || item?.bbox || this.copyImageContextValue(item, 'target_bbox');
        if (targetBBox) {
            return [
                'target_bbox',
                item?.file_index ?? '',
                item?.page ?? item?.target_page ?? '',
                String(targetBBox),
            ].join('|');
        }
        const targetSource = item?.target_image_source || this.copyImageContextValue(item, 'target_image_source');
        if (targetSource) {
            return [
                'target_source',
                item?.file_index ?? '',
                item?.page ?? item?.target_page ?? '',
                this.copyImageCompactKey(targetSource),
            ].join('|');
        }
        const targetCrop = item?.target_crop || this.copyImageContextValue(item, 'target_crop');
        if (targetCrop) return `target_crop|${targetCrop}`;
        const targetHash = this.copyImageContextValue(item, 'target_hash');
        if (targetHash) {
            return [
                'target_hash',
                item?.file_index ?? '',
                item?.page ?? item?.target_page ?? '',
                this.copyImageCompactKey(item?.location || item?.item || item?.matched_text),
                targetHash,
            ].join('|');
        }
        return [
            'target',
            item?.file_index ?? '',
            item?.page ?? item?.target_page ?? '',
            this.copyImageCompactKey(item?.location || item?.item || item?.matched_text),
        ].join('|');
    }

    private copyRateNumber(value: any): number {
        const rate = Number(value || 0);
        if (!Number.isFinite(rate)) return 0;
        return rate > 0 && rate <= 1 ? rate * 100 : rate;
    }

    private copySeverityRank(value: any): number {
        const key = String(value || '').toLowerCase();
        if (key === 'high') return 3;
        if (key === 'medium') return 2;
        if (key === 'low') return 1;
        return 0;
    }

    private copyImageRefEntry(item: any, source?: any): any {
        const ref = source || item || {};
        const entry: any = {
            ref_file_index: ref.ref_file_index ?? item?.ref_file_index,
            ref_filename: ref.ref_filename || ref.ref_file || item?.ref_filename || item?.ref_file,
            ref_file: ref.ref_file || ref.ref_filename || item?.ref_file || item?.ref_filename,
            ref_page: ref.ref_page ?? item?.ref_page,
            ref_location: ref.ref_location || item?.ref_location,
            ref_pdf_url: ref.ref_pdf_url || item?.ref_pdf_url,
            copy_rate: ref.copy_rate ?? item?.copy_rate,
            description: ref.description || item?.description,
            evidence: ref.evidence || item?.evidence,
            image_context: ref.image_context || item?.image_context,
            reference_crop: ref.reference_crop || this.copyImageContextValue(item, 'reference_crop'),
            reference_hash: ref.reference_hash || this.copyImageContextValue(item, 'reference_hash'),
            reference_bbox: ref.reference_bbox || ref.ref_bbox || item?.reference_bbox || this.copyImageContextValue(item, 'reference_bbox'),
            ref_bbox: ref.ref_bbox || ref.reference_bbox || item?.ref_bbox || item?.reference_bbox || this.copyImageContextValue(item, 'reference_bbox'),
            reference_source_kind: ref.reference_source_kind || item?.reference_source_kind,
            reference_source_page_x: ref.reference_source_page_x ?? item?.reference_source_page_x,
            reference_source_page_y: ref.reference_source_page_y ?? item?.reference_source_page_y,
            reference_source_page_width: ref.reference_source_page_width || item?.reference_source_page_width,
            reference_source_page_height: ref.reference_source_page_height || item?.reference_source_page_height,
        };
        Object.keys(entry).forEach((key: string) => {
            if (entry[key] === undefined || entry[key] === null || entry[key] === '') delete entry[key];
        });
        return entry;
    }

    private copyImageRefKey(entry: any): string {
        if (entry?.reference_bbox || entry?.ref_bbox) return `reference_bbox|${entry.ref_file_index ?? ''}|${entry.ref_page ?? ''}|${entry.reference_bbox || entry.ref_bbox}`;
        if (entry?.reference_crop) return `reference_crop|${entry.reference_crop}`;
        if (entry?.reference_hash) return `reference_hash|${entry.ref_file_index ?? ''}|${entry.reference_hash}`;
        return [
            entry?.ref_file_index ?? '',
            entry?.ref_page ?? '',
            this.copyImageCompactKey(entry?.ref_location || entry?.ref_filename || entry?.ref_file),
        ].join('|');
    }

    private appendCopyImageRef(target: any, entry: any) {
        if (!entry) return;
        const refs = Array.isArray(target.matched_refs) ? target.matched_refs : [];
        const key = this.copyImageRefKey(entry);
        const existing = refs.find((ref: any) => this.copyImageRefKey(ref) === key);
        if (existing) {
            if (this.copyRateNumber(entry.copy_rate) > this.copyRateNumber(existing.copy_rate)) {
                Object.assign(existing, entry);
            } else {
                Object.keys(entry).forEach((entryKey: string) => {
                    if ((existing[entryKey] === undefined || existing[entryKey] === null || existing[entryKey] === '') && entry[entryKey] !== '') {
                        existing[entryKey] = entry[entryKey];
                    }
                });
            }
        } else {
            refs.push({ ...entry });
        }
        refs.sort((a: any, b: any) => {
            const rateDiff = this.copyRateNumber(b.copy_rate) - this.copyRateNumber(a.copy_rate);
            if (rateDiff !== 0) return rateDiff;
            return this.formatCopyRefEntry(a).localeCompare(this.formatCopyRefEntry(b));
        });
        target.matched_refs = refs;
    }

    private finalizeCopyImageGroup(item: any): any {
        const refs = Array.isArray(item?.matched_refs) ? item.matched_refs : [];
        if (refs.length === 0) return item;
        const top = refs[0];
        [
            'ref_file_index', 'ref_filename', 'ref_file', 'ref_page', 'ref_location', 'ref_pdf_url',
            'reference_bbox', 'ref_bbox', 'reference_source_kind',
            'reference_source_page_x', 'reference_source_page_y',
            'reference_source_page_width', 'reference_source_page_height',
        ].forEach((key: string) => {
            if (top[key] !== undefined && top[key] !== null && top[key] !== '') item[key] = top[key];
        });
        if (top.copy_rate !== undefined && top.copy_rate !== null && top.copy_rate !== '') item.copy_rate = top.copy_rate;
        item.ref_count = refs.length;
        item.ref_summary = refs.length > 1 ? refs.map((ref: any) => this.formatCopyRefEntry(ref)).join('\n') : '';
        return item;
    }

    private mergeCopyImageFinding(target: any, incoming: any): any {
        const incomingRate = this.copyRateNumber(incoming?.copy_rate);
        const targetRate = this.copyRateNumber(target?.copy_rate);
        if (incomingRate > targetRate) {
            ['copy_rate', 'description', 'evidence', 'matched_text', 'severity'].forEach((key: string) => {
                if (incoming[key] !== undefined && incoming[key] !== null && incoming[key] !== '') target[key] = incoming[key];
            });
        } else if (this.copySeverityRank(incoming?.severity) > this.copySeverityRank(target?.severity)) {
            target.severity = incoming.severity;
        }
        [
            'target_bbox', 'bbox', 'target_image_source', 'target_display_width', 'target_display_height',
            'target_source_kind', 'target_source_page_x', 'target_source_page_y',
            'target_source_page_width', 'target_source_page_height',
        ].forEach((key: string) => {
            if ((target[key] === undefined || target[key] === null || target[key] === '') && incoming[key] !== undefined && incoming[key] !== null && incoming[key] !== '') {
                target[key] = incoming[key];
            }
        });
        for (const ref of (Array.isArray(incoming?.matched_refs) ? incoming.matched_refs : [])) {
            this.appendCopyImageRef(target, this.copyImageRefEntry(incoming, ref));
        }
        this.appendCopyImageRef(target, this.copyImageRefEntry(incoming));
        return this.finalizeCopyImageGroup(target);
    }

    private upsertCopyFinding(item: any) {
        this.normalizeCopyFinding(item);
        if (!this.isImageCopyResult(item)) {
            this.copyFindings.push(item);
            return;
        }
        const key = this.copyImageTargetKey(item);
        const existing = this.copyFindings.find((finding: any) => this.isImageCopyResult(finding) && this.copyImageTargetKey(finding) === key);
        if (existing) {
            this.mergeCopyImageFinding(existing, item);
            return;
        }
        const grouped = { ...item, matched_refs: [] };
        this.mergeCopyImageFinding(grouped, item);
        this.copyFindings.push(grouped);
    }

    public updateResults(newResults: any[]) {
        const isCopyResult = (r: any) => {
            const hasCopyRate = r?.copy_rate !== undefined && r?.copy_rate !== null && r?.copy_rate !== '';
            return r?.type === 'copy' || r?.type === 'text_copy' || r?.type === 'image_copy' || hasCopyRate;
        };
        const hasCopyFinding = (newResults || []).some((r: any) => isCopyResult(r));
        for (const r of newResults) {
            if (r) r.severity = this.normalizeSeverityKey(r.severity);
            if (r.type === 'omission_summary') {
                this.omissionSummary = r;
            } else if (r.type === 'omission') {
                this.upsertOmissionFinding(r);
            } else if (r.type === 'context_summary') {
                this.contextSummary = r;
            } else if (r.type === 'context' || r.type === 'context_check') {
                this.contextFindings.push(r);
            } else if (r.type === 'state_evaluation_summary' || (r.type === 'consistency_summary' && this.isStateEvaluationResult(r))) {
                this.stateEvaluationSummary = r;
            } else if (r.type === 'state_evaluation' || (r.type === 'consistency' && this.isStateEvaluationResult(r))) {
                this.attachStateEvaluationGuidelineRef(r);
                this.stateEvaluationFindings.push(r);
            } else if (r.type === 'instruction_summary') {
                this.instructionSummary = r;
            } else if (r.type === 'instruction' || r.type === 'instruction_check') {
                this.instructionFindings.push(r);
            } else if (r.type === 'consistency_summary') {
                this.consistencySummary = r;
            } else if (r.type === 'consistency') {
                this.consistencyFindings.push(r);
            } else if (r.type === 'typo') {
                this.normalizeTypoFinding(r);
                this.typoFindings.push(r);
            } else if (isCopyResult(r)) {
                this.upsertCopyFinding(r);
            } else if ((r.type === 'clean' || r.type === 'copy_clean') && hasCopyFinding) {
                continue;
            } else if (r.type !== 'parse_info' && r.type !== 'parse_error') {
                this.infoResults.push(r);
            }
        }
        this.sortOmissionFindings();
        this.results = [...this.copyFindings, ...this.typoFindings, ...this.omissionFindings, ...this.contextFindings, ...this.instructionFindings, ...this.stateEvaluationFindings, ...this.consistencyFindings, ...this.infoResults];
    }

    private partialResultKey(result: any): string {
        const parts = [
            result?.type || '',
            result?.file_index ?? '',
            result?.page ?? result?.target_page ?? '',
            result?.ref_file_index ?? '',
            result?.ref_page ?? '',
            result?.title || result?.item || result?.original || '',
            result?.corrected || '',
            result?.evidence || result?.description || '',
        ];
        return parts.map((value: any) => String(value)).join('|');
    }

    private appendPartialResults(newResults: any[]) {
        const fresh: any[] = [];
        for (const result of newResults || []) {
            if (!result || result.type === 'parse_info' || result.type === 'parse_error') continue;
            if (result.type === 'omission') {
                fresh.push(result);
                continue;
            }
            const key = this.partialResultKey(result);
            if (this._partialResultKeys.has(key)) continue;
            this._partialResultKeys.add(key);
            fresh.push(result);
        }
        if (fresh.length > 0) {
            this.updateResults(fresh);
            if (fresh.some((result: any) => result?.type === 'omission')) {
                this.resultSubTab = 'omission';
                this.autoSwitchRightTab('result');
            }
        }
    }

    // ========== Omission Results ==========

    public getOmissionStatusClass(status: string): string {
        if (status === '유') return 'text-emerald-600 bg-emerald-50';
        if (status === '무') return 'text-red-600 bg-red-50';
        return 'text-amber-700 bg-amber-50';
    }

    public isOmissionPendingStatus(status: any): boolean {
        const compact = String(status || '').replace(/\s+/g, '').toLowerCase();
        return ['진행중', 'pending', 'running', 'progress', 'inprogress', 'started'].indexOf(compact) >= 0;
    }

    public getOmissionStatusLabel(status: any): string {
        if (this.isOmissionPendingStatus(status)) return '진행중';
        return String(status || '-');
    }

    public getOmissionRowBackground(status: any): string {
        if (status === '무') return '#fff0f0';
        if (this.isOmissionPendingStatus(status)) return '#fff8e1';
        return '#ffffff';
    }

    public getOmissionStatusColor(status: any): string {
        if (status === '유') return '#006600';
        if (status === '무') return '#cc0000';
        return '#b7791f';
    }

    public getOmissionStatusBackground(status: any): string {
        if (status === '유') return '#e6ffe6';
        if (status === '무') return '#ffe6e6';
        return '#fff3cd';
    }

    private omissionStatusPriority(status: any): number {
        const compact = String(status || '').replace(/\s+/g, '').toLowerCase();
        if (compact === '유' || compact === 'present' || compact === 'found' || compact === 'match') return 3;
        if (compact === '무' || compact === 'missing' || compact === 'absent' || compact === 'notfound' || compact === '누락') return 2;
        if (this.isOmissionPendingStatus(status)) return 1;
        return 0;
    }

    public countOmissionStatus(status: string): number {
        return this.omissionFindings.filter((f: any) => f.status === status).length;
    }

    public getOmissionMajorTitle(item: any): string {
        const chapterTitle = String(item?.chapter_title || '').trim();
        if (chapterTitle) return chapterTitle;

        const explicitTitle = String(item?.major_title || '').trim();
        if (explicitTitle) return explicitTitle;

        const scopeTitle = String(item?.scope_title || '').trim();
        if (scopeTitle) return scopeTitle;

        const compoundTitle = this.splitOmissionCompoundTitle(item);
        return compoundTitle.major;
    }

    public getOmissionSubTitle(item: any): string {
        const majorTitle = this.getOmissionMajorTitle(item);
        const compoundTitle = this.splitOmissionCompoundTitle(item);
        const subTitle = String(item?.sub_title || '').trim();
        const title = String(item?.title || item?.item || '').trim();
        if (compoundTitle.major && compoundTitle.sub && (!subTitle || subTitle === title || subTitle === majorTitle)) {
            return compoundTitle.sub;
        }
        if (subTitle && subTitle !== majorTitle) return subTitle;
        return title === majorTitle ? '' : title;
    }

    private omissionTitleKey(value: string): string {
        return String(value || '')
            .replace(/[\s\-_/·․ㆍ.,:;()\[\]{}<>「」『』“”"'`]+/g, '')
            .toLowerCase();
    }

    private splitOmissionCompoundTitle(item: any): any {
        const title = String(item?.title || item?.item || '').trim();
        if (!title || this.normalizedOmissionSheetType(item) !== 'detail') {
            return { major: '', sub: '' };
        }
        const match = title.match(/^(.+?)\s*[-–—―＞>]\s*(.+)$/);
        if (!match) return { major: '', sub: '' };
        const major = String(match[1] || '').trim();
        const sub = String(match[2] || '').trim();
        if (!major || !sub) return { major: '', sub: '' };
        return { major, sub };
    }

    private isOmissionDetailMajorRow(item: any, previousItem: any, nextItem: any, currentMajor: string = ''): boolean {
        if (this.normalizedOmissionSheetType(item) !== 'detail') return false;
        const rawTitle = String(item?.title || item?.item || '').trim();
        if (!rawTitle || this.omissionTitleKey(rawTitle) === this.omissionTitleKey(currentMajor)) return false;
        if (this.splitOmissionCompoundTitle(item).major) return false;

        const nextMajorTitle = nextItem ? this.getOmissionMajorTitle(nextItem) : '';
        if (nextMajorTitle && this.omissionTitleKey(nextMajorTitle) === this.omissionTitleKey(rawTitle)) {
            return true;
        }

        const row = this.omissionRowNumber(item);
        const previousRow = previousItem ? this.omissionRowNumber(previousItem) : 0;
        const nextRow = nextItem ? this.omissionRowNumber(nextItem) : 999999;
        if (row >= 999999 || nextRow >= 999999 || nextRow !== row + 1) return false;
        return !previousItem || previousRow >= 999999 || row - previousRow > 1;
    }

    private isOmissionBasicMajorTitle(title: string, currentMajor: string = ''): boolean {
        const key = this.omissionTitleKey(title);
        const currentKey = this.omissionTitleKey(currentMajor);
        if (key && key === currentKey) return false;
        if (key === '안전등급지정' && currentKey === '종합결론및건의') return false;
        return [
            '서두',
            '정기안전점검개요',
            '안전점검개요',
            '정밀안전점검개요',
            '정밀안전진단개요',
            '자료수집및분석',
            '현장조사',
            '현장조사및시험',
            '시설물의상태평가',
            '시설물의안전성평가',
            '종합평가및안전등급지정',
            '보수보강방안',
            '유지관리방안',
            '종합결론및건의',
            '부록',
            '과업수행계획일정',
            '점검항목',
            '안전등급지정',
        ].indexOf(key) >= 0;
    }

    private normalizedOmissionSheetType(item: any): string {
        const sheetType = String(item?.sheet_type || '').toLowerCase();
        if (sheetType === 'basic' || sheetType === 'detail') return sheetType;
        const source = `${item?.sheet || ''} ${item?.category || ''} ${item?.title || ''}`.toLowerCase();
        if (source.includes('기본') || source.includes('basic')) return 'basic';
        if (source.includes('상세') || source.includes('detail')) return 'detail';
        return 'detail';
    }

    private omissionRowNumber(item: any): number {
        const row = Math.floor(Number(item?.row));
        return isFinite(row) && row > 0 ? row : 999999;
    }

    private omissionResultKeys(item: any): string[] {
        const keys: string[] = [];
        const row = this.omissionRowNumber(item);
        const sheetType = this.normalizedOmissionSheetType(item);
        const sheet = String(item?.sheet || '');
        if (row < 999999) {
            if (sheet) return [`row|${sheet}|${row}`];
            return [`row|${sheetType}|${row}`];
        }
        const label = String(item?.item || item?.title || '').trim();
        if (label) {
            if (sheet) keys.push(`item|${sheet}|${label}`);
            else if (sheetType) keys.push(`item|${sheetType}|${label}`);
            else keys.push(`item|${label}`);
        }
        return keys;
    }

    private omissionEvidenceScore(item: any): number {
        let score = item?.status === '유' ? 100 : 0;
        for (const key of ['page', 'target_page', 'page_start', 'page_end']) {
            if (item?.[key]) score += 10;
        }
        for (const key of ['evidence', 'note', 'description', 'table_context', 'cell_context', 'image_context']) {
            if (String(item?.[key] || '').trim()) score += 3;
        }
        const confidence = Number(item?.confidence);
        if (isFinite(confidence)) score += confidence;
        return score;
    }

    private mergeOmissionFinding(current: any, incoming: any): any {
        const currentPriority = this.omissionStatusPriority(current?.status);
        const incomingPriority = this.omissionStatusPriority(incoming?.status);
        const mergeIncoming = () => {
            const merged = { ...current, ...incoming };
            for (const key of ['chapter_no', 'chapter_title', 'indent_level', 'parent_title', 'major_title', 'sub_title', 'scope_title']) {
                if (!String(incoming?.[key] || '').trim() && String(current?.[key] || '').trim()) {
                    merged[key] = current[key];
                }
            }
            return merged;
        };
        if (incomingPriority < currentPriority) {
            return current;
        }
        if (incomingPriority > currentPriority) {
            return mergeIncoming();
        }
        if (incoming?.status === '유' || this.omissionEvidenceScore(incoming) >= this.omissionEvidenceScore(current)) {
            return mergeIncoming();
        }
        return current;
    }

    private upsertOmissionFinding(item: any) {
        if (!item._display_order) {
            item._display_order = ++this._omissionDisplaySequence;
        }
        const keys = this.omissionResultKeys(item);
        const index = this.omissionFindings.findIndex((candidate: any) => {
            const candidateKeys = this.omissionResultKeys(candidate);
            return keys.some((key: string) => candidateKeys.indexOf(key) >= 0);
        });
        if (index >= 0) {
            const current = this.omissionFindings[index];
            const merged = this.mergeOmissionFinding(current, item);
            merged._display_order = current._display_order || item._display_order;
            this.omissionFindings[index] = merged;
        } else {
            this.omissionFindings.push(item);
        }
    }

    private sortOmissionFindings() {
        const sheetOrder: any = { basic: 0, detail: 1 };
        this.omissionFindings.sort((a: any, b: any) => {
            const aType = this.normalizedOmissionSheetType(a);
            const bType = this.normalizedOmissionSheetType(b);
            const typeDiff = (sheetOrder[aType] ?? 9) - (sheetOrder[bType] ?? 9);
            if (typeDiff !== 0) return typeDiff;
            const sheetDiff = String(a?.sheet || '').localeCompare(String(b?.sheet || ''));
            if (sheetDiff !== 0) return sheetDiff;
            const rowDiff = this.omissionRowNumber(a) - this.omissionRowNumber(b);
            if (rowDiff !== 0) return rowDiff;
            const orderDiff = (Number(a?._display_order) || 999999) - (Number(b?._display_order) || 999999);
            if (orderDiff !== 0) return orderDiff;
            return String(a?.title || a?.item || '').localeCompare(String(b?.title || b?.item || ''));
        });
    }

    public getOmissionBySheetType(sheetType: string): any[] {
        this.sortOmissionFindings();
        return this.omissionFindings.filter((f: any) => this.normalizedOmissionSheetType(f) === sheetType);
    }

    private countOmissionBySheetType(sheetType: string, stopAfter: number = -1): number {
        let count = 0;
        for (const item of this.omissionFindings) {
            if (this.normalizedOmissionSheetType(item) !== sheetType) continue;
            count++;
            if (stopAfter >= 0 && count > stopAfter) return count;
        }
        return count;
    }

    public hasOmissionSheetType(sheetType: string): boolean {
        return this.countOmissionBySheetType(sheetType, 0) > 0;
    }

    public isOmissionSheetPreviewTruncated(sheetType: string): boolean {
        return this.resultSubTab === 'all' && this.countOmissionBySheetType(sheetType, this.allResultPreviewLimit) > this.allResultPreviewLimit;
    }

    public getOmissionDisplayRowsBySheetType(sheetType: string): any[] {
        const rows: any[] = [];
        let lastMajorTitle = '';
        let inferredMajorTitle = '';
        let itemIndex = 0;
        const pushMajorRow = (title: string) => {
            const majorTitle = String(title || '').trim();
            if (!majorTitle) return;
            if (this.omissionTitleKey(majorTitle) !== this.omissionTitleKey(lastMajorTitle)) {
                rows.push({
                    kind: 'major',
                    title: majorTitle,
                });
            }
            lastMajorTitle = majorTitle;
            inferredMajorTitle = majorTitle;
        };

        const items = this.getOmissionBySheetType(sheetType);
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const previousItem = i > 0 ? items[i - 1] : null;
            const nextItem = i < items.length - 1 ? items[i + 1] : null;
            let majorTitle = this.getOmissionMajorTitle(item);
            const subTitle = this.getOmissionSubTitle(item);
            const rawTitle = String(item?.title || item?.item || '').trim();
            const itemTitle = subTitle || rawTitle || majorTitle;
            const isMajorOnlyRow = !!(majorTitle && !subTitle && this.omissionTitleKey(itemTitle) === this.omissionTitleKey(majorTitle));
            const isInferredDetailMajorRow = !majorTitle
                && this.isOmissionDetailMajorRow(item, previousItem, nextItem, inferredMajorTitle)
                && this.omissionTitleKey(itemTitle) === this.omissionTitleKey(rawTitle);
            const isInferredBasicMajorRow = !majorTitle
                && this.normalizedOmissionSheetType(item) === 'basic'
                && this.isOmissionBasicMajorTitle(rawTitle, inferredMajorTitle)
                && this.omissionTitleKey(itemTitle) === this.omissionTitleKey(rawTitle);

            if (isMajorOnlyRow || isInferredDetailMajorRow || isInferredBasicMajorRow) {
                pushMajorRow(rawTitle || majorTitle);
                continue;
            }

            if (!majorTitle && inferredMajorTitle) {
                majorTitle = inferredMajorTitle;
            }

            const hasNestedSubTitle = !!(majorTitle && itemTitle && this.omissionTitleKey(itemTitle) !== this.omissionTitleKey(majorTitle));

            if (hasNestedSubTitle && this.omissionTitleKey(majorTitle) !== this.omissionTitleKey(lastMajorTitle)) {
                pushMajorRow(majorTitle);
            } else if (!majorTitle) {
                lastMajorTitle = '';
                inferredMajorTitle = '';
            } else if (!subTitle) {
                lastMajorTitle = majorTitle;
                inferredMajorTitle = majorTitle;
            }

            rows.push({
                kind: 'item',
                item,
                index: ++itemIndex,
                title: itemTitle,
                majorTitle: majorTitle || '',
                subTitle: subTitle || itemTitle,
                nested: hasNestedSubTitle,
            });
        }

        return rows;
    }

    private limitOmissionRowsForAllTab(rows: any[]): any[] {
        if (this.resultSubTab !== 'all' || rows.length === 0) return rows;
        const limited: any[] = [];
        let itemCount = 0;
        for (const row of rows) {
            if (row?.kind === 'item') {
                if (itemCount >= this.allResultPreviewLimit) break;
                itemCount++;
            }
            limited.push(row);
        }
        while (limited.length > 0 && limited[limited.length - 1]?.kind !== 'item') {
            limited.pop();
        }
        return limited;
    }

    public getRenderedOmissionDisplayRowsBySheetType(sheetType: string): any[] {
        return this.limitOmissionRowsForAllTab(this.getOmissionDisplayRowsBySheetType(sheetType));
    }

    public getOmissionDetailText(item: any): string {
        return String(
            item?.description
            || item?.note
            || item?.evidence
            || item?.reason
            || ''
        ).trim();
    }

    public countOmissionStatusBySheet(sheetType: string, status: string): number {
        return this.omissionFindings.filter((f: any) => this.normalizedOmissionSheetType(f) === sheetType && f.status === status).length;
    }

    public async downloadOmissionExcel() {
        const url = this.omissionSummary?.download_url
            || this.omissionWorkbook?.download_url
            || (this.sessionData?.omission_result ? `/wiz/api/page.chatbot.room/serve_excel?session_id=${encodeURIComponent(this.sessionId || '')}` : '');
        if (!url) return;
        window.open(url, '_blank');
    }

    private hasOmissionWorkbookSource(): boolean {
        return !!(
            this.sessionData?.omission_result
            || this.omissionSummary?.download_url
            || this.omissionFindings.length > 0
        );
    }

    public async switchOmissionResultView(view: string) {
        this.omissionResultView = view === 'checklist' ? 'checklist' : 'excel';
        if (this.omissionResultView === 'excel') {
            await this.loadOmissionWorkbook(false);
        }
        await this.service.render();
    }

    private async loadOmissionWorkbook(force: boolean = false) {
        if (!this.sessionId || (!force && this.omissionWorkbook) || !this.hasOmissionWorkbookSource()) {
            return;
        }

        this.omissionWorkbookLoading = true;
        this.omissionWorkbookError = '';
        await this.service.render();

        try {
            const res: any = await wiz.call('load_omission_workbook', { session_id: this.sessionId });
            if (res.code === 200 && res.data) {
                this.omissionWorkbook = res.data;
                const sheets = this.omissionWorkbook?.sheets || [];
                if (!this.selectedOmissionSheet || !sheets.some((s: any) => s.name === this.selectedOmissionSheet)) {
                    const sheetWithMissing = sheets.find((s: any) => this.omissionWorkbookSheetHasNegativeCheck(s));
                    this.selectedOmissionSheet = sheetWithMissing?.name || sheets[0]?.name || '';
                }
            } else if (force) {
                this.omissionWorkbookError = res.data?.message || '결과를 불러오지 못했습니다.';
            }
        } catch (e: any) {
            if (force) {
                this.omissionWorkbookError = e?.message || '결과를 불러오지 못했습니다.';
            }
        }

        this.omissionWorkbookLoading = false;
        await this.service.render();
    }

    public async switchOmissionSheet(sheetName: string) {
        this.selectedOmissionSheet = sheetName;
        await this.service.render();
    }

    public getSelectedOmissionSheet(): any {
        const sheets = this.omissionWorkbook?.sheets || [];
        return sheets.find((sheet: any) => sheet.name === this.selectedOmissionSheet) || sheets[0] || null;
    }

    public getOmissionWorkbookMarkdown(): string {
        return String(this.getSelectedOmissionSheet()?.markdown || '');
    }

    private splitWorkbookMarkdownRow(line: string): string[] {
        let text = String(line || '').trim();
        if (text.startsWith('|')) text = text.slice(1);
        if (text.endsWith('|')) text = text.slice(0, -1);

        const cells: string[] = [];
        let current = '';
        let escaped = false;
        for (const ch of text) {
            if (escaped) {
                current += ch;
                escaped = false;
            } else if (ch === '\\') {
                escaped = true;
            } else if (ch === '|') {
                cells.push(current.trim());
                current = '';
            } else {
                current += ch;
            }
        }
        if (escaped) current += '\\';
        cells.push(current.trim());
        return cells.map((cell: string) => cell.replace(/<br>/g, '\n'));
    }

    private isWorkbookMarkdownSeparator(cells: string[]): boolean {
        return cells.length > 0 && cells.every((cell: string) => /^:?-{3,}:?$/.test(String(cell || '').trim()));
    }

    private parseWorkbookMarkdownTable(markdown: string): any {
        const lines = String(markdown || '').split(/\r?\n/).filter((line: string) => line.trim().startsWith('|'));
        if (lines.length < 2) return this.emptyWorkbookTable;

        const columns = this.splitWorkbookMarkdownRow(lines[0]);
        if (!columns.length) return this.emptyWorkbookTable;

        let startIndex = 1;
        const separator = this.splitWorkbookMarkdownRow(lines[1] || '');
        if (this.isWorkbookMarkdownSeparator(separator)) {
            startIndex = 2;
        }

        const rows: any[] = [];
        for (let i = startIndex; i < lines.length; i += 1) {
            const cells = this.splitWorkbookMarkdownRow(lines[i]);
            const normalized = columns.map((_col: string, index: number) => cells[index] || '');
            rows.push({
                index: rows.length + 1,
                cells: normalized,
            });
        }
        return { columns, rows };
    }

    private getWorkbookRenderedTable(sheet: any): any {
        if (!sheet) return this.emptyWorkbookTable;
        const markdown = String(sheet.markdown || '');
        if (sheet.__renderedTable && sheet.__renderedTableMarkdown === markdown) {
            return sheet.__renderedTable;
        }

        let table = this.emptyWorkbookTable;
        if (Array.isArray(sheet.rows) && sheet.rows.length > 0) {
            table = {
                columns: Array.isArray(sheet.columns) ? sheet.columns : [],
                rows: sheet.rows,
            };
        } else if (markdown.trim()) {
            table = this.parseWorkbookMarkdownTable(markdown);
        }

        sheet.__renderedTable = table;
        sheet.__renderedTableMarkdown = markdown;
        return table;
    }

    public getOmissionWorkbookRows(): any[] {
        return this.getWorkbookRenderedTable(this.getSelectedOmissionSheet()).rows || [];
    }

    public getOmissionWorkbookColumns(): string[] {
        return this.getWorkbookRenderedTable(this.getSelectedOmissionSheet()).columns || [];
    }

    private getOmissionWorkbookColumnRoleForSheet(sheet: any, colIndex: number): string {
        const rows = this.getWorkbookRenderedTable(sheet).rows || [];
        const marker = String(rows?.[2]?.cells?.[colIndex] || '').replace(/[()\s]/g, '');
        if (!marker) return '';
        if (marker.indexOf('무') >= 0 || marker.indexOf('불일치') >= 0) return 'negative';
        if (marker.indexOf('유') >= 0 || marker === '일치') return 'positive';
        return '';
    }

    private getOmissionWorkbookColumnRole(colIndex: number): string {
        return this.getOmissionWorkbookColumnRoleForSheet(this.getSelectedOmissionSheet(), colIndex);
    }

    private omissionWorkbookSheetHasNegativeCheck(sheet: any): boolean {
        if (sheet?.has_negative_check === true) return true;
        for (const row of this.getWorkbookRenderedTable(sheet).rows || []) {
            const cells = row?.cells || [];
            for (let i = 0; i < cells.length; i += 1) {
                if (String(cells[i] || '').trim() === 'O' && this.getOmissionWorkbookColumnRoleForSheet(sheet, i) === 'negative') {
                    return true;
                }
            }
        }
        return false;
    }

    public getOmissionWorkbookCellText(value: any, colIndex: number = -1): any {
        const text = String(value || '').trim();
        if (text !== 'O') return value;
        const role = this.getOmissionWorkbookColumnRole(colIndex);
        if (role === 'negative') {
            const marker = String(this.getOmissionWorkbookRows()?.[2]?.cells?.[colIndex] || '').replace(/[()\s]/g, '');
            return marker.indexOf('불일치') >= 0 ? '불일치' : '무';
        }
        if (role === 'positive') {
            const marker = String(this.getOmissionWorkbookRows()?.[2]?.cells?.[colIndex] || '').replace(/[()\s]/g, '');
            return marker === '일치' ? '일치' : '유';
        }
        return value;
    }

    public getOmissionWorkbookCellClass(value: any, colIndex: number = -1): string {
        const text = String(value || '').trim();
        if (text === 'O') {
            const role = this.getOmissionWorkbookColumnRole(colIndex);
            if (role === 'negative') return 'excel-cell-negative';
            if (role === 'positive') return 'excel-cell-positive';
        }
        if (text === '유' || text === '일치') return 'excel-cell-positive';
        if (text === 'X' || text === '무') return 'excel-cell-negative';
        if (text === '불일치') return 'excel-cell-negative';
        return '';
    }

    public hasInspectionWorkbookSource(): boolean {
        const hasPersistedResultLikeRows = (this.results || []).some((item: any) =>
            item?.type !== 'no_findings'
            && item?.type !== 'parse_info'
            && item?.type !== 'parse_error'
        );
        const inspectionResultCount = Number(this.sessionData?.inspection_result?.result_count || 0);
        return !!(
            inspectionResultCount > 0
            || this.inspectionWorkbook?.download_url
            || hasPersistedResultLikeRows
        );
    }

    public async downloadInspectionExcel() {
        const url = this.inspectionWorkbook?.download_url
            || (this.hasInspectionWorkbookSource() ? `/wiz/api/page.chatbot.room/serve_inspection_excel?session_id=${encodeURIComponent(this.sessionId || '')}` : '');
        if (!url) return;
        window.open(url, '_blank');
    }

    private async loadInspectionWorkbook(force: boolean = false) {
        if (!this.sessionId || (!force && this.inspectionWorkbook) || !this.hasInspectionWorkbookSource()) {
            return;
        }

        this.inspectionWorkbookLoading = true;
        this.inspectionWorkbookError = '';
        await this.service.render();

        try {
            const res: any = await wiz.call('load_inspection_workbook', { session_id: this.sessionId });
            if (res.code === 200 && res.data) {
                this.inspectionWorkbook = res.data;
                const sheets = this.inspectionWorkbook?.sheets || [];
                if (!this.selectedInspectionSheet || !sheets.some((s: any) => s.name === this.selectedInspectionSheet)) {
                    this.selectedInspectionSheet = sheets[0]?.name || '';
                }
            } else if (force) {
                this.inspectionWorkbookError = res.data?.message || '검사 결과를 불러오지 못했습니다.';
            }
        } catch (e: any) {
            if (force) {
                this.inspectionWorkbookError = e?.message || '검사 결과를 불러오지 못했습니다.';
            }
        }

        this.inspectionWorkbookLoading = false;
        await this.service.render();
    }

    public async switchInspectionSheet(sheetName: string) {
        this.selectedInspectionSheet = sheetName;
        await this.service.render();
    }

    public getSelectedInspectionSheet(): any {
        const sheets = this.inspectionWorkbook?.sheets || [];
        return sheets.find((sheet: any) => sheet.name === this.selectedInspectionSheet) || sheets[0] || null;
    }

    public getInspectionWorkbookMarkdown(): string {
        return String(this.getSelectedInspectionSheet()?.markdown || '');
    }

    public getInspectionWorkbookRows(): any[] {
        return this.getWorkbookRenderedTable(this.getSelectedInspectionSheet()).rows || [];
    }

    public getInspectionWorkbookColumns(): string[] {
        return this.getWorkbookRenderedTable(this.getSelectedInspectionSheet()).columns || [];
    }

    public getInspectionWorkbookCellClass(value: any): string {
        const text = String(value || '').trim();
        if (['O', '유', '정상', '일치', '낮음'].indexOf(text) >= 0) return 'excel-cell-positive';
        if (['X', '무', '불일치', '높음', '중간', '주의', '심각'].indexOf(text) >= 0) return 'excel-cell-negative';
        return '';
    }

    public getOmissionPage(item: any): number {
        return this.firstDocumentPage(item, ['target_page', 'page', 'page_start'], 0);
    }

    public getOmissionPageLabel(item: any): string {
        for (const key of ['target_page', 'page']) {
            const page = this.parseDocumentPage(item?.[key], 0);
            if (page > 0) return `${page}p`;
        }
        const pageStart = this.parseDocumentPage(item?.page_start, 0);
        const pageEnd = this.parseDocumentPage(item?.page_end, 0);
        if (pageStart > 0 && pageEnd > 0) {
            return pageStart === pageEnd ? `${pageStart}p` : `${pageStart}~${pageEnd}p`;
        }
        const page = this.getOmissionPage(item);
        if (page > 0) return `${page}p`;
        return '';
    }

    public canViewOmissionResult(item: any): boolean {
        if (!item || item.status !== '유' || this.getOmissionPage(item) < 1) return false;
        if (item.pdf_url) return true;
        return this.hasViewerFileIndex(item.file_index) && !!this.findViewerFile(item.file_index);
    }

    public async viewOmissionResult(item: any) {
        if (!this.canViewOmissionResult(item)) return;
        const page = this.getOmissionPage(item) || 1;
        const fileName = item.location || item.filename || item.title || '누락사항 근거';
        const file = this.hasViewerFileIndex(item.file_index) ? this.findViewerFile(item.file_index) : null;
        if (file && this.isHwpViewerFile(file)) {
            await this.showDocumentByFileIndex(item.file_index, page, fileName);
        } else if (item.pdf_url) {
            if (this.hasViewerFileIndex(item.file_index)) this.selectedPdfFileIndex = this.normalizeViewerFileIndex(item.file_index);
            await this.showPdf(item.pdf_url, page, fileName);
        } else if (this.hasViewerFileIndex(item.file_index)) {
            await this.showDocumentByFileIndex(item.file_index, page, fileName);
        }
        await this.service.render();
    }

    // ========== Copy Results ==========

    public async selectCopyResult(item: any) {
        this.selectedCopy = item;
        this.saveViewState();
        await this.service.render();
    }

    public async viewCopyResult(item: any) {
        this.selectedCopy = item;
        const page = this.firstDocumentPage(item, ['target_page', 'page', 'page_start'], 1);
        if (this.hasViewerFileIndex(item.file_index) && (this.hasViewerFileIndex(item.ref_file_index) || item.ref_pdf_url)) {
            this.compareLeft = this.buildComparePane(
                item.file_index,
                page,
                '대상 보고서',
                item.filename || item.location || '',
            );
            const refPage = this.firstDocumentPage(item, ['ref_page', 'reference_page', 'baseline_page'], 1);
            this.compareRight = item.ref_pdf_url
                ? this.buildComparePaneFromUrl(item.ref_pdf_url, refPage, '비교 보고서', this.getCopyRefFileName(item))
                : this.buildComparePane(item.ref_file_index, refPage, '비교 보고서', this.getCopyRefFileName(item));
            this.compareMode = true;
            this.pdfUrl = '';
            this.pdfImageUrl = '';
            this.pdfPage = page;
            this.pdfFileName = `${this.compareLeft.filename || '대상 보고서'} / ${this.compareRight.filename || '비교 보고서'}`;
            this.viewerMode = 'pdf';
            this.setRightTab('pdf', true);
            this.saveViewState();
            await this.refreshComparePanesInfo();
            return;
        }
        const file = this.hasViewerFileIndex(item.file_index) ? this.findViewerFile(item.file_index) : null;
        if (file && this.isHwpViewerFile(file)) {
            await this.showDocumentByFileIndex(item.file_index, page, item.location || item.filename || '');
        } else if (item.pdf_url) {
            if (this.hasViewerFileIndex(item.file_index)) this.selectedPdfFileIndex = this.normalizeViewerFileIndex(item.file_index);
            await this.showPdf(item.pdf_url, page, item.location || '');
        } else if (this.hasViewerFileIndex(item.file_index)) {
            await this.showDocumentByFileIndex(item.file_index, page, item.location || item.filename || '');
        }
        await this.service.render();
    }

    public async viewCopyResultRef(item: any, ref: any) {
        this.selectedCopy = item;
        const page = this.firstDocumentPage(item, ['target_page', 'page', 'page_start'], 1);
        const refPage = this.firstDocumentPage(ref || {}, ['ref_page', 'reference_page', 'baseline_page'], this.firstDocumentPage(item, ['ref_page', 'reference_page', 'baseline_page'], 1));
        const refFileIndex = ref?.ref_file_index ?? item?.ref_file_index;
        const refPdfUrl = ref?.ref_pdf_url || item?.ref_pdf_url;
        if (this.hasViewerFileIndex(item.file_index) && (this.hasViewerFileIndex(refFileIndex) || refPdfUrl)) {
            this.compareLeft = this.buildComparePane(
                item.file_index,
                page,
                '대상 보고서',
                item.filename || item.location || '',
            );
            if (refPdfUrl) {
                this.compareRight = this.buildComparePaneFromUrl(
                    refPdfUrl,
                    refPage,
                    '비교 보고서',
                    ref?.ref_filename || ref?.ref_file || this.getCopyRefFileName(item),
                );
            } else {
                this.compareRight = this.buildComparePane(
                    refFileIndex,
                    refPage,
                    '비교 보고서',
                    ref?.ref_filename || ref?.ref_file || this.getCopyRefFileName(item),
                );
            }
            this.compareMode = true;
            this.pdfUrl = '';
            this.pdfImageUrl = '';
            this.pdfPage = page;
            this.pdfFileName = `${this.compareLeft.filename || '대상 보고서'} / ${this.compareRight.filename || '비교 보고서'}`;
            this.viewerMode = 'pdf';
            this.setRightTab('pdf', true);
            this.saveViewState();
            await this.refreshComparePanesInfo();
            return;
        }
        await this.viewCopyResult(item);
    }

    public async viewRefPdf(item: any) {
        const page = this.firstDocumentPage(item, ['ref_page', 'reference_page', 'baseline_page'], 1);
        const file = this.hasViewerFileIndex(item.ref_file_index) ? this.findViewerFile(item.ref_file_index) : null;
        if (file && this.isHwpViewerFile(file)) {
            await this.showDocumentByFileIndex(item.ref_file_index, page, item.ref_location || '참조 문서');
        } else if (item.ref_pdf_url) {
            if (this.hasViewerFileIndex(item.ref_file_index)) this.selectedPdfFileIndex = this.normalizeViewerFileIndex(item.ref_file_index);
            await this.showPdf(item.ref_pdf_url, page, item.ref_location || '참조 문서');
        } else if (this.hasViewerFileIndex(item.ref_file_index)) {
            await this.showDocumentByFileIndex(item.ref_file_index, page, item.ref_location || '참조 문서');
        }
    }

    public canViewRefDocument(item: any): boolean {
        if (!item) return false;
        if (item.ref_pdf_url) return true;
        return this.hasViewerFileIndex(item.ref_file_index) && !!this.findViewerFile(item.ref_file_index);
    }

    private countImageCopyFindings(): number {
        return (this.copyFindings || []).filter((item: any) => {
            const type = String(item?.type || '').toLowerCase();
            return type === 'image_copy' || (type === 'copy' && !!item?.image_context);
        }).length;
    }

    private numberFromStats(key: string): number {
        const value = Number(this.copyImageStats?.[key]);
        return Number.isFinite(value) && value > 0 ? value : 0;
    }

    public getCopyImageTotalCount(): number {
        return this.numberFromStats('image_count');
    }

    public getCopyReportImageTotalCount(): number {
        return this.numberFromStats('report_image_count');
    }

    public getCopyReferenceImageTotalCount(): number {
        return this.numberFromStats('reference_image_count');
    }

    public getCopyImageEstimatedCount(): number {
        const estimated = this.numberFromStats('estimated_copy_image_count');
        return estimated || this.countImageCopyFindings();
    }

    public getCopyCandidatePairCount(): number {
        return this.numberFromStats('candidate_pair_count');
    }

    public getCopyPotentialPairCount(): number {
        return this.numberFromStats('potential_pair_count');
    }

    public getCopyScannedPairCount(): number {
        return this.numberFromStats('scanned_pair_count') || this.getCopyPotentialPairCount();
    }

    public getCopyCandidatePairSummaryText(): string {
        const candidate = this.getCopyCandidatePairCount();
        if (candidate <= 0) return '';
        const potential = this.getCopyPotentialPairCount();
        const scanned = this.getCopyScannedPairCount();
        if (scanned > candidate) {
            return `전체 조합 ${potential || scanned}개 1차 스캔 / LLM 확인 후보 ${candidate}개`;
        }
        if (potential > candidate) {
            return `후보쌍 ${candidate}개 / 전체 조합 ${potential}개`;
        }
        return `LLM 확인 후보 ${candidate}개`;
    }

    public getCopyImageSummaryText(): string {
        const total = this.getCopyImageTotalCount();
        const reportTotal = this.getCopyReportImageTotalCount();
        const referenceTotal = this.getCopyReferenceImageTotalCount();
        const estimated = this.getCopyImageEstimatedCount();
        if (reportTotal > 0) {
            const segments = [`검사 이미지 총 ${reportTotal}개`];
            if (referenceTotal > 0) segments.push(`비교 이미지 ${referenceTotal}개`);
            if (total > 0 && total !== reportTotal) segments.push(`전체 이미지 ${total}개`);
            return `${segments.join(', ')} 중 ${estimated}개가 카피 의심으로 추정됩니다.`;
        }
        if (total > 0) {
            return `현재 이미지 ${total}개 중 ${estimated}개가 카피 의심으로 추정됩니다.`;
        }
        if (estimated > 0) {
            return `카피 의심 이미지 ${estimated}개로 추정됩니다.`;
        }
        return '';
    }

    public getCopyRateClass(rate: number): string {
        if (rate >= 80) return 'text-red-600 font-bold';
        if (rate >= 50) return 'text-orange-500 font-semibold';
        if (rate >= 30) return 'text-yellow-600';
        return 'text-green-600';
    }

    public countCopySeverity(level: string): number {
        return this.copyFindings.filter((f: any) => {
            const rate = f.copy_rate || 0;
            if (level === 'high') return rate >= 80;
            if (level === 'medium') return rate >= 50 && rate < 80;
            if (level === 'low') return rate >= 30 && rate < 50;
            return rate < 30;
        }).length;
    }

    public getCopyKindLabel(item: any): string {
        const type = String(item?.type || '').toLowerCase();
        if (type === 'image_copy') return '이미지';
        if (type === 'text_copy') return '텍스트';
        if (type === 'copy') return item?.image_context ? '이미지' : '텍스트';
        if (type === 'copy_clean' || type === 'clean') return '요약';
        return type || '카피';
    }

    public getCopyKindClass(item: any): string {
        const label = this.getCopyKindLabel(item);
        if (label === '이미지') return 'text-[10px] px-1.5 py-0.5 bg-amber-50 text-amber-600 rounded';
        if (label === '텍스트') return 'text-[10px] px-1.5 py-0.5 bg-violet-50 text-violet-600 rounded';
        return 'text-[10px] px-1.5 py-0.5 bg-slate-100 text-slate-600 rounded';
    }

    public getCopyRefFileName(item: any): string {
        return this.firstDisplayValue(item?.ref_filename, item?.ref_file, item?.reference_filename, '비교 문서');
    }

    private isGenericCopyTargetLabel(value: any): boolean {
        const text = String(value || '').trim();
        if (!text) return true;
        return /^대상\s*보고서\s*\d+p\s*이미지$/i.test(text)
            || /^보고서\s*\d+p\s*이미지$/i.test(text)
            || /^이미지(?:\s*재사용)?$/i.test(text)
            || /^동일\s*이미지\s*재사용\s*의심$/i.test(text)
            || /^동일\s*(?:원본|렌더링)?\s*이미지$/i.test(text)
            || /^크기\s*변경\s*이미지$/i.test(text)
            || /^직접\s*시각\s*비교\s*대상$/i.test(text);
    }

    private extractCopyTargetFromDescription(item: any): string {
        const description = this.cleanCopyDisplayCandidate(item?.description || '');
        const match = description.match(/대상\s*보고서\s*\d+p(?:의|에 있는)?\s*(.+?)(?:이|가|은|는)\s*(?:기준|비교)\s*보고서/);
        if (match && match[1]) return this.cleanCopyDisplayCandidate(match[1]);
        return '';
    }

    private compactCopyBboxLabel(item: any): string {
        const raw = item?.target_bbox || item?.bbox || this.copyImageContextValue(item, 'target_bbox');
        const text = String(raw || '').replace(/[^\d.,\-\s]/g, '').trim();
        if (!text) return '';
        const nums = text.split(/[,\s]+/).filter((part: string) => part !== '').slice(0, 4);
        return nums.length >= 4 ? `위치 ${nums.join(',')}` : '';
    }

    public getCopyTargetLabel(item: any): string {
        if (!this.isImageCopyResult(item)) {
            return this.firstDisplayValue(item?.item, item?.title, item?.matched_text, '카피 의심 구간');
        }
        const page = this.firstDisplayValue(item?.target_page, item?.page, item?.page_start);
        const candidates = [
            item?.location,
            item?.item,
            this.extractCopyTargetFromDescription(item),
            item?.title,
            item?.matched_text,
            item?.evidence,
        ];
        for (const candidate of candidates) {
            const cleaned = this.cleanCopyDisplayCandidate(candidate);
            if (cleaned && !this.isGenericCopyTargetLabel(cleaned)) {
                return page && cleaned.indexOf(`${page}p`) < 0 ? `${page}p ${cleaned}` : cleaned;
            }
        }
        const bbox = this.compactCopyBboxLabel(item);
        if (bbox && page) return `${page}p 이미지 (${bbox})`;
        if (bbox) return `이미지 (${bbox})`;
        return page ? `${page}p 이미지` : '대상 이미지';
    }

    public getCopyTargetTitle(item: any): string {
        const parts = [
            this.getCopyTargetLabel(item),
            this.firstDisplayValue(item?.description),
            this.firstDisplayValue(item?.location),
        ].filter((part: string) => !!part);
        return parts.join('\n');
    }

    public getCopyRefEntries(item: any): any[] {
        const refs = Array.isArray(item?.matched_refs)
            ? item.matched_refs.filter((ref: any) => ref && typeof ref === 'object')
            : [];
        if (refs.length > 0) return refs;
        const entry = this.copyImageRefEntry(item || {});
        return entry && Object.keys(entry).length > 0 ? [entry] : [];
    }

    public getCopyTableRefs(item: any): any[] {
        const refs = this.getCopyRefEntries(item);
        return refs.length > 0 ? refs : [{}];
    }

    public getCopyRowspan(item: any): number {
        return Math.max(1, this.getCopyTableRefs(item).length);
    }

    public formatCopyRefEntry(ref: any): string {
        const filename = this.firstDisplayValue(ref?.ref_filename, ref?.ref_file, '비교 문서');
        const page = this.firstDisplayValue(ref?.ref_page, ref?.reference_page);
        const location = this.replaceInternalImageRefs(this.firstDisplayValue(ref?.ref_location), ref);
        const pageLabel = page ? `${page}p` : '';
        return [filename, pageLabel, location].filter((value: string) => !!value).join(' ');
    }

    public getCopyRefRateLabel(ref: any): string {
        const rate = this.copyRateNumber(ref?.copy_rate);
        if (rate <= 0) return '';
        return `${Math.round(rate)}%`;
    }

    public hasMultipleCopyRefs(item: any): boolean {
        return this.getCopyRefEntries(item).length > 1;
    }

    public getCopyRefCount(item: any): number {
        return this.getCopyRefEntries(item).length;
    }

    public getCopyRefLabel(item: any): string {
        const refs = this.getCopyRefEntries(item);
        if (refs.length > 1) return `비교 대상 ${refs.length}건`;
        if (refs.length === 1) return this.formatCopyRefEntry(refs[0]);
        return this.getCopyRefFileName(item);
    }

    public getCopyRefTitle(item: any): string {
        const refs = this.getCopyRefEntries(item);
        if (refs.length > 0) return refs.map((ref: any) => this.formatCopyRefEntry(ref)).join('\n');
        return this.getCopyRefLabel(item);
    }

    // ========== Typo Results ==========

    private normalizeSeverityKey(severity: any): string {
        const raw = `${severity || ''}`.trim().toLowerCase();
        if (!raw) return 'info';
        if (['high', 'critical', 'severe', 'major', 'error', 'danger', '심각', '높음', '중대'].includes(raw)) return 'high';
        if (['medium', 'moderate', 'warning', 'warn', '주의', '중간', '보통'].includes(raw)) return 'medium';
        if (['low', 'minor', 'note', 'notice', '참고', '낮음', '경미'].includes(raw)) return 'low';
        if (['info', 'information', 'informational', 'clean', 'normal', 'none', '정보', '정상'].includes(raw)) return 'info';
        return 'info';
    }

    private typoErrorTypeCandidates(value: any): any[] {
        if (value && typeof value === 'object') {
            return [
                value.error_type,
                value.error_type_label,
                value.type_label,
                value.category,
                value.label,
            ];
        }
        return [value];
    }

    private isKnownTypoErrorType(errorType: string): boolean {
        return ['typo', 'spelling', 'spacing', 'grammar', 'punctuation'].includes(errorType);
    }

    private normalizeTypoErrorTypeText(errorType: any): string {
        const raw = `${errorType || ''}`.trim().toLowerCase();
        if (!raw) return '';

        const compact = raw.replace(/[\s_\-./\\·・ㆍ]+/g, '');
        const tokens = raw.split(/[^a-z]+/).filter((token: string) => !!token);
        const hasToken = (...expected: string[]) => tokens.some((token: string) => expected.includes(token));

        if (
            compact.includes('띄어쓰기')
            || compact.includes('띄어쓰')
            || compact.includes('붙여쓰기')
            || compact.includes('붙여쓰')
            || compact.includes('공백')
            || hasToken('spacing', 'space', 'whitespace', 'wordspacing')
        ) {
            return 'spacing';
        }
        if (compact.includes('맞춤법') || compact.includes('철자') || hasToken('spelling', 'spell')) return 'spelling';
        if (compact.includes('문법') || hasToken('grammar', 'grammatical')) return 'grammar';
        if (
            compact.includes('문장부호')
            || compact.includes('구두점')
            || compact.includes('부호')
            || compact.includes('표기')
            || hasToken('punctuation', 'punct', 'symbol', 'notation')
        ) {
            return 'punctuation';
        }
        if (compact.includes('오탈자') || compact.includes('오타') || hasToken('typo', 'typographical')) return 'typo';
        return raw;
    }

    private normalizeTypoErrorType(value: any): string {
        let fallback = '';
        for (const candidate of this.typoErrorTypeCandidates(value)) {
            const normalized = this.normalizeTypoErrorTypeText(candidate);
            if (!normalized) continue;
            if (this.isKnownTypoErrorType(normalized)) return normalized;
            if (!fallback) fallback = normalized;
        }
        return fallback || 'typo';
    }

    private normalizeTypoFinding(finding: any) {
        if (!finding) return;
        finding.severity = this.normalizeSeverityKey(finding.severity);
        const normalizedType = this.normalizeTypoErrorType(finding);
        finding.error_type = normalizedType;
        finding.error_type_label = this.getTypoErrorTypeLabel(finding);
    }

    public getTypoErrorTypeLabel(value: any): string {
        const normalized = this.normalizeTypoErrorType(value);
        switch (normalized) {
            case 'typo': return '오타';
            case 'spelling': return '맞춤법';
            case 'spacing': return '띄어쓰기';
            case 'grammar': return '문법';
            case 'punctuation': return '부호·표기';
            default: {
                const raw = typeof value === 'string' ? value : (value?.error_type_label || value?.error_type);
                return this.sanitizeProcessText(raw || '오타') || '오타';
            }
        }
    }

    public get displayedTypoFindings(): any[] {
        if (this.hideSpacing) {
            return this.typoFindings.filter((f: any) => this.normalizeTypoErrorType(f) !== 'spacing');
        }
        return this.typoFindings;
    }

    public get renderedTypoFindings(): any[] {
        return this.limitForAllResultTab(this.displayedTypoFindings);
    }

    public async toggleSpacing() {
        this.hideSpacing = !this.hideSpacing;
        this.saveViewState();
        await this.service.render();
    }

    public async selectTypoResult(item: any) {
        this.selectedTypo = item;
        this.saveViewState();
        await this.service.render();
    }

    public async viewTypoResult(item: any) {
        this.selectedTypo = item;
        const page = this.firstDocumentPage(item, ['target_page', 'page', 'page_start'], 1);
        const file = this.hasViewerFileIndex(item.file_index) ? this.findViewerFile(item.file_index) : null;
        if (file && this.isHwpViewerFile(file)) {
            await this.showDocumentByFileIndex(item.file_index, page, item.filename || '');
        } else if (item.pdf_url) {
            if (this.hasViewerFileIndex(item.file_index)) this.selectedPdfFileIndex = this.normalizeViewerFileIndex(item.file_index);
            await this.showPdf(item.pdf_url, page, item.filename || '');
        } else if (this.hasViewerFileIndex(item.file_index)) {
            await this.showDocumentByFileIndex(item.file_index, page, item.filename || '');
        }
        await this.service.render();
    }

    public getTypoSeverityClass(severity: string): string {
        switch (this.normalizeSeverityKey(severity)) {
            case 'high': return 'bg-red-50 text-red-600';
            case 'medium': return 'bg-orange-50 text-orange-600';
            case 'low': return 'bg-yellow-50 text-yellow-600';
            default: return 'bg-zinc-50 text-zinc-500';
        }
    }

    public getErrorTypeClass(errorType: any): string {
        switch (this.normalizeTypoErrorType(errorType)) {
            case 'typo': return 'bg-red-50 text-red-600';
            case 'spelling': return 'bg-purple-50 text-purple-600';
            case 'spacing': return 'bg-blue-50 text-blue-600';
            case 'grammar': return 'bg-amber-50 text-amber-600';
            case 'punctuation': return 'bg-zinc-100 text-zinc-500';
            default: return 'bg-zinc-50 text-zinc-500';
        }
    }

    public getLegacyErrorTypeColor(errorType: any): string {
        switch (this.normalizeTypoErrorType(errorType)) {
            case 'typo': return '#cc0000';
            case 'spelling': return '#663399';
            case 'spacing': return '#333399';
            case 'punctuation': return '#666666';
            default: return '#996600';
        }
    }

    public getLegacyErrorTypeBackground(errorType: any): string {
        switch (this.normalizeTypoErrorType(errorType)) {
            case 'typo': return '#ffe6e6';
            case 'spelling': return '#f0e0ff';
            case 'spacing': return '#e6e6ff';
            case 'punctuation': return '#f5f5f5';
            default: return '#fffff0';
        }
    }

    public getLegacyErrorTypeBorder(errorType: any): string {
        switch (this.normalizeTypoErrorType(errorType)) {
            case 'typo': return '#ffaaaa';
            case 'spelling': return '#cc99ff';
            case 'spacing': return '#9999ff';
            case 'punctuation': return '#cccccc';
            default: return '#cccc66';
        }
    }

    public countTypoSeverity(level: string): number {
        const normalizedLevel = this.normalizeSeverityKey(level);
        return this.displayedTypoFindings.filter((f: any) => this.normalizeSeverityKey(f.severity) === normalizedLevel).length;
    }

    public countTypoErrorType(errorType: string): number {
        const normalized = this.normalizeTypoErrorType(errorType);
        return this.typoFindings.filter((f: any) => this.normalizeTypoErrorType(f) === normalized).length;
    }

    // ========== Utility ==========

    public getStatusText(): string {
        if (this.statusMessage) return this.statusMessage;
        switch (this.agentStatus) {
            case 'planning': return '에이전트가 요청을 분석하고 있습니다...';
            case 'executing': return '에이전트가 문서를 검사하고 있습니다...';
            case 'done': return '검사 완료';
            default: return '';
        }
    }

    public async toggleProgressDetails(msg: any) {
        if (!msg || !msg.progressDetails || msg.progressDetails.length === 0) return;
        msg.progressExpanded = !msg.progressExpanded;
        await this.service.render();
    }

    public getSeverityLabel(severity: string): string {
        switch (this.normalizeSeverityKey(severity)) {
            case 'high': return '심각';
            case 'medium': return '주의';
            case 'low': return '참고';
            case 'info': return '정보';
            default: return '정보';
        }
    }

    public getSeverityIcon(severity: string): string {
        switch (this.normalizeSeverityKey(severity)) {
            case 'high': return '🔴';
            case 'medium': return '🟡';
            case 'low': return '🟢';
            case 'info': return 'ℹ️';
            default: return '•';
        }
    }

    public countSeverity(severity: string): number {
        const normalizedLevel = this.normalizeSeverityKey(severity);
        return this.results.filter((r: any) => this.normalizeSeverityKey(r.severity) === normalizedLevel).length;
    }

    public async switchResultSubTab(tab: string) {
        this.setRightTab('result', true);
        this.resultSubTab = tab;
        this.selectedCopy = null;
        this.selectedTypo = null;
        this.saveViewState();
        if (tab === 'excel') {
            await this.loadInspectionWorkbook(!this.inspectionWorkbook);
        }
        await this.service.render();
    }

    public objectKeys(obj: any): string[] {
        return obj ? Object.keys(obj) : [];
    }

    private firstDisplayValue(...values: any[]): string {
        for (const value of values) {
            if (value === undefined || value === null) continue;
            const text = String(value).trim();
            if (text) return text;
        }
        return '';
    }

    private stateEvaluationStatusCounts(): any {
        const counts: any = { match: 0, mismatch: 0, needs_review: 0 };
        for (const row of this.stateEvaluationFindings || []) {
            const status = this.normalizeConsistencyStatusKey(row?.status);
            counts[status] = (counts[status] || 0) + 1;
        }
        return counts;
    }

    private instructionStatusCounts(): any {
        const counts: any = { match: 0, mismatch: 0 };
        for (const row of this.instructionFindings || []) {
            const status = this.normalizeConsistencyStatusKey(row?.status);
            if (status === 'match') counts.match += 1;
            else counts.mismatch += 1;
        }
        return counts;
    }

    public hasInstructionSummary(): boolean {
        return !!this.instructionSummary || (this.instructionFindings || []).length > 0;
    }

    public getInstructionSummaryText(): string {
        const explicit = this.firstDisplayValue(this.instructionSummary?.report_value);
        if (explicit && explicit.indexOf('점') < 0 && explicit.indexOf('확인 필요') < 0) return explicit;
        const counts = this.instructionStatusCounts();
        return `유 ${counts.match}건 / 무 ${counts.mismatch}건`;
    }

    public getInstructionSummaryStatus(): string {
        const explicit = this.firstDisplayValue(this.instructionSummary?.status);
        if (explicit && this.normalizeConsistencyStatusKey(explicit) !== 'needs_review') return explicit;
        const counts = this.instructionStatusCounts();
        if (counts.mismatch > 0) return 'mismatch';
        return 'match';
    }

    public getInstructionSummaryReason(): string {
        const explicit = this.firstDisplayValue(
            this.instructionSummary?.description,
            this.instructionSummary?.reason,
            this.instructionSummary?.note,
            this.instructionSummary?.evidence,
        );
        if (explicit) return explicit;
        const counts = this.instructionStatusCounts();
        return `지침 수행 여부 기준으로 유 ${counts.match}건, 무 ${counts.mismatch}건입니다.`;
    }

    public hasStateEvaluationScoreSummary(): boolean {
        return !!this.stateEvaluationSummary || (this.stateEvaluationFindings || []).length > 0;
    }

    public getStateEvaluationScoreText(): string {
        const explicit = this.firstDisplayValue(this.stateEvaluationSummary?.report_value);
        if (explicit && explicit.indexOf('점') < 0) return explicit;
        const counts = this.stateEvaluationStatusCounts();
        return `유 ${counts.match}건 / 무 ${counts.mismatch}건 / 확인 필요 ${counts.needs_review}건`;
    }

    public getStateEvaluationScoreStatus(): string {
        const explicit = this.firstDisplayValue(this.stateEvaluationSummary?.status);
        if (explicit) return explicit;
        const counts = this.stateEvaluationStatusCounts();
        if (counts.mismatch > 0) return 'mismatch';
        if (counts.needs_review > 0) return 'needs_review';
        return 'match';
    }

    public getStateEvaluationScoreReason(): string {
        const explicit = this.firstDisplayValue(
            this.stateEvaluationSummary?.description,
            this.stateEvaluationSummary?.reason,
            this.stateEvaluationSummary?.note,
            this.stateEvaluationSummary?.evidence,
        );
        const basis = this.firstDisplayValue(this.stateEvaluationSummary?.table_context);
        if (explicit && basis && explicit.indexOf(basis) < 0) return `${explicit} 기준표: ${basis}`;
        if (explicit) return explicit;
        if (basis) return `기준표: ${basis}`;
        const counts = this.stateEvaluationStatusCounts();
        return `상태평가 수행 여부 기준으로 유 ${counts.match}건, 무 ${counts.mismatch}건, 확인 필요 ${counts.needs_review}건입니다.`;
    }

    public getContextSummaryEntries(): any[] {
        const baseline = this.contextSummary?.baseline || this.contextSummary?.required_values || {};
        if (!baseline || typeof baseline !== 'object') return [];
        const priority = [
            '용역명', '과업명', '보고서명', '시설물명', '발주처', '수행기관',
            '계약기간', '점검종류', '점검일', '조사일', '작성일', '대상기간',
            '위치', '관리주체',
        ];
        const keys = Object.keys(baseline).filter((key: string) => this.firstDisplayValue(baseline[key]));
        keys.sort((a: string, b: string) => {
            const ai = priority.indexOf(a);
            const bi = priority.indexOf(b);
            if (ai === -1 && bi === -1) return a.localeCompare(b);
            if (ai === -1) return 1;
            if (bi === -1) return -1;
            return ai - bi;
        });
        return keys.map((key: string) => ({ key, value: baseline[key] }));
    }

    public getContextBaselineSourceLabel(): string {
        return this.firstDisplayValue(this.contextSummary?.baseline_source, this.contextSummary?.evidence_source, '계약서/착수계 기준');
    }

    public getContextBaselineValue(r: any): string {
        return this.firstDisplayValue(r?.baseline_value, r?.expected, r?.ref_value, r?.reference_value) || '-';
    }

    public getContextFoundValue(r: any): string {
        return this.firstDisplayValue(r?.found_value, r?.actual, r?.report_value, r?.observed_value, r?.original) || '-';
    }

    private formatContextPage(page: any, fallbackLabel: string): string {
        const text = this.firstDisplayValue(page);
        if (!text || text === '0') return '';
        const pageText = /(p|쪽|페이지)$/i.test(String(text).trim()) ? text : `${text}p`;
        return `${fallbackLabel} ${pageText}`;
    }

    private resultTargetPage(item: any): number {
        return this.firstDocumentPage(item, ['target_page', 'page', 'page_start', 'report_page'], 0);
    }

    private resultReferencePage(item: any): number {
        return this.firstDocumentPage(item, ['ref_page', 'reference_page', 'baseline_page', 'expected_page'], 0);
    }

    public getResultTargetPageLabel(item: any): string {
        const page = this.resultTargetPage(item);
        return page > 0 ? `${page}p` : '-';
    }

    public getConsistencyComparePageLabel(r: any): string {
        const report = this.formatContextPage(r?.page || r?.target_page || r?.report_page, '보고서');
        const refLabel = this.firstDisplayValue(r?.ref_type, '기준');
        const ref = this.formatContextPage(r?.ref_page || r?.reference_page || r?.baseline_page, refLabel);
        if (ref && report) return `${report} ↔ ${ref}`;
        return report || ref || '-';
    }

    public getConsistencyComparePageTitle(r: any): string {
        const parts: string[] = [];
        const reportFile = this.firstDisplayValue(r?.filename, r?.report_filename, '보고서');
        const reportPage = this.firstDisplayValue(r?.page, r?.target_page, r?.report_page);
        const reportLoc = this.firstDisplayValue(r?.location, r?.report_location);
        if (reportPage || reportLoc || r?.filename) {
            parts.push(`보고서: ${reportFile}${reportPage ? ` ${reportPage}p` : ''}${reportLoc ? ` / ${reportLoc}` : ''}`);
        }
        const refFile = this.firstDisplayValue(r?.ref_filename, r?.ref_file, r?.reference_filename, '기준 문서');
        const refPage = this.firstDisplayValue(r?.ref_page, r?.reference_page, r?.baseline_page);
        const refLoc = this.firstDisplayValue(r?.ref_location, r?.reference_location, r?.baseline_location);
        if (refPage || refLoc || r?.ref_filename || r?.ref_file) {
            parts.push(`기준: ${refFile}${refPage ? ` ${refPage}p` : ''}${refLoc ? ` / ${refLoc}` : ''}`);
        }
        return parts.join('\n') || this.getConsistencyComparePageLabel(r);
    }

    private canViewResultTarget(item: any): boolean {
        if (!item || this.resultTargetPage(item) < 1) return false;
        if (item.pdf_url) return true;
        return this.hasViewerFileIndex(item.file_index) && !!this.findViewerFile(item.file_index);
    }

    private canViewResultReference(item: any): boolean {
        return !!item && this.resultReferencePage(item) > 0 && this.canViewRefDocument(item);
    }

    public canViewContextResult(item: any): boolean {
        return this.canViewResultTarget(item) || this.canViewResultReference(item);
    }

    public canViewConsistencyResult(item: any): boolean {
        return this.canViewResultTarget(item) || this.canViewResultReference(item);
    }

    public canViewInstructionResult(item: any): boolean {
        return this.canViewResultTarget(item) || this.canViewResultReference(item);
    }

    private async viewEvidenceResult(item: any) {
        if (this.canViewResultTarget(item)) {
            await this.viewResultDetail(item);
            await this.service.render();
            return;
        }
        if (this.canViewResultReference(item)) {
            await this.viewRefPdf(item);
            await this.service.render();
        }
    }

    public async viewContextResult(item: any) {
        await this.viewEvidenceResult(item);
    }

    public async viewConsistencyResult(item: any) {
        await this.viewEvidenceResult(item);
    }

    public async viewInstructionResult(item: any) {
        await this.viewEvidenceResult(item);
    }

    public getContextComparePageLabel(r: any): string {
        const ref = this.formatContextPage(r?.ref_page || r?.baseline_page || r?.expected_page, '기준');
        const report = this.formatContextPage(r?.page || r?.target_page || r?.report_page, '보고서');
        if (ref && report) return `${ref} ↔ ${report}`;
        return ref || report || '-';
    }

    public getContextComparePageTitle(r: any): string {
        const parts: string[] = [];
        const refFile = this.firstDisplayValue(r?.ref_filename, r?.ref_file, r?.baseline_filename, '기준 문서');
        const refPage = this.firstDisplayValue(r?.ref_page, r?.baseline_page, r?.expected_page);
        const refLoc = this.firstDisplayValue(r?.ref_location, r?.baseline_location, r?.expected_location);
        if (refPage || refLoc || r?.ref_filename || r?.ref_file) {
            parts.push(`기준: ${refFile}${refPage ? ` ${refPage}p` : ''}${refLoc ? ` / ${refLoc}` : ''}`);
        }
        const reportFile = this.firstDisplayValue(r?.filename, r?.report_filename, '보고서');
        const reportPage = this.firstDisplayValue(r?.page, r?.target_page, r?.report_page);
        const reportLoc = this.firstDisplayValue(r?.location, r?.report_location);
        if (reportPage || reportLoc || r?.filename) {
            parts.push(`보고서: ${reportFile}${reportPage ? ` ${reportPage}p` : ''}${reportLoc ? ` / ${reportLoc}` : ''}`);
        }
        return parts.join('\n') || this.getContextComparePageLabel(r);
    }

    public countContextStatus(status: string): number {
        if (status === 'match') return this.contextFindings.filter((f: any) => f.status === 'match').length;
        return this.contextFindings.filter((f: any) => f.status !== 'match').length;
    }

    public countConsistencyStatus(status: string): number {
        if (status === 'match') return this.consistencyFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'match').length;
        if (status === 'needs_review') return this.consistencyFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'needs_review').length;
        return this.consistencyFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'mismatch').length;
    }

    public countStateEvaluationStatus(status: string): number {
        if (status === 'match') return this.stateEvaluationFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'match').length;
        if (status === 'needs_review') return this.stateEvaluationFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'needs_review').length;
        return this.stateEvaluationFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'mismatch').length;
    }

    public countInstructionStatus(status: string): number {
        if (status === 'match') return this.instructionFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'match').length;
        if (status === 'needs_review') return this.instructionFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'needs_review').length;
        return this.instructionFindings.filter((f: any) => this.normalizeConsistencyStatusKey(f.status) === 'mismatch').length;
    }

    private normalizeConsistencyStatusKey(status: any): string {
        const compact = String(status || '').replace(/\s+/g, '').toLowerCase();
        if (['match', 'matched', 'consistent', 'same', 'pass', 'passed', 'ok', 'true', 'yes', '일치', '부합', '적합', '정상', '유', '있음', '수행', '수행됨'].includes(compact)) {
            return 'match';
        }
        if (['needs_review', 'needreview', 'needsreview', 'review', 'unknown', 'uncertain', 'insufficient', '확인필요', '검토필요', '판단보류', '근거부족', '보류'].includes(compact)) {
            return 'needs_review';
        }
        return 'mismatch';
    }

    public getConsistencyStatusLabel(status: string): string {
        const normalized = this.normalizeConsistencyStatusKey(status);
        if (normalized === 'match') return '일치';
        if (normalized === 'needs_review') return '확인 필요';
        return '불일치';
    }

    public getConsistencyStatusClass(status: string): string {
        const normalized = this.normalizeConsistencyStatusKey(status);
        if (normalized === 'match') return 'text-emerald-600 font-semibold text-[10px]';
        if (normalized === 'needs_review') return 'text-amber-600 font-semibold text-[10px]';
        return 'text-red-600 font-semibold text-[10px]';
    }

    public getStateEvaluationStatusLabel(status: string): string {
        const normalized = this.normalizeConsistencyStatusKey(status);
        if (normalized === 'match') return '유';
        if (normalized === 'needs_review') return '확인 필요';
        return '무';
    }

    public getInstructionStatusLabel(status: string): string {
        return this.getStateEvaluationStatusLabel(status);
    }

    public getConsistencyCompareSymbol(status: string): string {
        const normalized = this.normalizeConsistencyStatusKey(status);
        if (normalized === 'match') return '=';
        if (normalized === 'needs_review') return '?';
        return '≠';
    }

    public isConsistencyMatch(status: any): boolean {
        return this.normalizeConsistencyStatusKey(status) === 'match';
    }

    public isConsistencyNeedsReview(status: any): boolean {
        return this.normalizeConsistencyStatusKey(status) === 'needs_review';
    }

    public isConsistencyMismatch(status: any): boolean {
        return this.normalizeConsistencyStatusKey(status) === 'mismatch';
    }
}

export default PageChatbotRoomComponent;
